webpackJsonp([1],{

/***/ "/huF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opportunities_vue__ = __webpack_require__("MTZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083b38f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opportunities_vue__ = __webpack_require__("4jLI");
function injectStyle (ssrContext) {
  __webpack_require__("oEqp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-083b38f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opportunities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083b38f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Opportunities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "/r3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({
        colour: "#00000044",
        height: 30,
        pad: 3,
        width: Math.random() * 50 + 50,
        child: childA
      });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "03pU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),

/***/ "0FZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "0jUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__ = __webpack_require__("3NRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ed021e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__ = __webpack_require__("gMGA");
function injectStyle (ssrContext) {
  __webpack_require__("idHo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ed021e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0w4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slowbart_vue__ = __webpack_require__("0FZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f21553_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slowbart_vue__ = __webpack_require__("QvwB");
function injectStyle (ssrContext) {
  __webpack_require__("b6Vx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77f21553"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slowbart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f21553_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slowbart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Z2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      showForgot: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        //this.$router.push('/participate')

        console.log("USER CHANGED");
        this.$router.go(-1);
      }
    },
    error: function error(val) {
      if (val) {
        this.showForgot = true;
      }
    }
  },
  methods: {
    doForgot: function doForgot() {
      console.log("FORGOT", this.email);
      this.$store.dispatch('forgotPassword', this.email);
    },
    onSignin: function onSignin() {
      console.log('email:', this.email);
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onSigninGoogle: function onSigninGoogle() {

      this.$store.dispatch('signUserUpGoogle', { email: 'this.email', password: 'this.password' });
    },
    onDismissed: function onDismissed() {
      console.log('Dismissed alert');
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),

/***/ "1n4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebCam_vue__ = __webpack_require__("Tpnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ee88b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebCam_vue__ = __webpack_require__("UDPz");
function injectStyle (ssrContext) {
  __webpack_require__("5eZ5")
  __webpack_require__("oFsg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53ee88b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebCam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ee88b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebCam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "25Jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__("It2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__("3VHS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    menuItems: null,
    loading: false,
    currentEvent: null,
    currentEvents: null

  },
  mutations: {
    loading: function loading(state, payload) {
      state.loading = payload;
    },
    setMenuItems: function setMenuItems(state, payload) {
      state.menuItems = payload;
    },
    addMenuItem: function addMenuItem(state, payload) {
      if (!state.menuItems) {
        state.menuItems = [];
      }
      state.menuItems.push(payload);
      console.log("state.menuItems");
    },
    setCurrentEvent: function setCurrentEvent(state, payload) {
      state.currentEvent = payload;
    },
    setCurrentEvents: function setCurrentEvents(state, payload) {
      state.currentEvents = payload;
    },
    addEvent: function addEvent(state, payload) {
      state.currentEvents.push(payload);
      console.log("++++++++", state.currentEvents);
    }
  },
  actions: {
    loadEventsStatus: function loadEventsStatus(_ref) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["firestore"]();
      console.log("------", db);
      commit('loading', true);
      var doc = void 0;
      var data = void 0;
      var docRef = db.collection("website").doc("Events");
      docRef.get().then(function (doc) {
        if (doc.exists) {
          console.log("Document dataXX:", doc.data());
          commit("setCurrentEvents", []);
          if (doc.data().Active && doc.data().ActiveEvents) {
            console.log("Document dataXX:", doc.data().ActiveEvents);
            for (var event in doc.data().ActiveEvents) {
              console.log("Document dataXXX:", doc.data().ActiveEvents[event]);
              dispatch("loadEvent", doc.data().ActiveEvents[event]);
            }
          }
          // if(doc.data().Active && doc.data().TestEvents){
          //   console.log("Document dataXX:", doc.data().TestEvents);
          //   for(var event in doc.data().TestEvents){
          //     console.log("Document dataXXX2:",event, doc.data().TestEvents[event]);
          //     dispatch("loadEvent",doc.data().TestEvents[event])
          //   }
          // }
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    addEvent: function addEvent(_ref2, payload) {
      var commit = _ref2.commit;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["firestore"]();
      commit('loading', true);
      var doc = void 0;
      var data = void 0;
      var docRef = db.collection("Events").doc(payload);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          commit("addEvent", doc.data());
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
          commit('loading', false);
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
        commit('loading', false);
      });
    },
    loadEvent: function loadEvent(_ref3, payload) {
      var commit = _ref3.commit;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["firestore"]();
      console.log("------", db);
      commit('loading', true);
      var doc = void 0;
      var data = void 0;
      var docRef = db.collection("Events").doc(payload);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          console.log("Document data:::::", doc.data());
          commit("addEvent", doc.data());
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    },
    loadMenuItems: function loadMenuItems(_ref4) {
      var commit = _ref4.commit;

      var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app__["firestore"]();
      commit('loading', true);
      var doc = void 0;
      var data = void 0;
      console.log("----- Load menu items");
      var collRef = db.collection("website");
      console.log("----- ", collRef);
      commit('setMenuItems', []);
      collRef.get().then(function (coll) {
        for (var d in coll.docs) {
          doc.coll.docs[d];
          data = doc.data();
          console.log("MENU ITEMS", data);
          commit('addMenuItem', data);
        }
        commit('loading', false);
      }).catch(function (error) {
        console.log("Error getting document:", error);
        commit('loading', false);
      });
    }
  },
  getters: {
    getCurrentEvent: function getCurrentEvent(state) {
      return state.currentEvent;
    },
    getCurrentEvents: function getCurrentEvents(state) {
      return state.currentEvents;
    }
  }
});

/***/ }),

/***/ "2AZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('h2',[_vm._v("What")]),_vm._v(" "),_c('p',[_vm._v("The Loop is a high-quality digital LED screen (4800 x 2560, 4.8mm pixel pitch).")]),_c('p',[_vm._v("\nHosted content is screened with audio emitting from speakers near the screen, set to a level that\nis comfortable for those nearby, while unobtrusive to local businesses and residents.")]),_c('p',[_vm._v("\nThe Loop also offers a venue for special screening opportunities, events and performances.")]),_vm._v(" "),_c('h2',[_vm._v("Who")]),_vm._v(" "),_c('p',[_vm._v("We are seeking expressions of interest from digital art and film practitioners, curators and\norganisations who work with creative screen-based content. Appropriate formats include\nexperimental films, music videos, interactive and non-narrative digital art, short films /\ndocumentaries.")]),_c('p',[_vm._v("\nApplicants are encouraged to consider the suitability of their work to the public nature of the\nplatform. Content cannot include material that could be deemed offensive to any members of the\nwider public. The Loop is also situated in a high-traffic location where many viewers only take in\nthe work in small snippets, rather than engaging for extended periods. With this in mind, content\nthat has an immediate visual impact is favoured.")]),_vm._v(" "),_c('p',[_vm._v("Curators and film programmers are encouraged to submit complete programs of content for\nconsideration.")]),_vm._v(" "),_c('p',[_vm._v("Community-based and amateur creative content will also be considered for some programming\nstreams.")]),_vm._v(" "),_c('h2',[_vm._v("How")]),_vm._v(" "),_c('p',[_vm._v("Whether you have a piece of screen-based content that you believe would be a fit for the Loop or\na whole packaged program, we would like to hear from you.")]),_vm._v(" "),_c('p',[_vm._v("Please "),_c('v-btn',{attrs:{"href":"mailto:publicart@hobartcity.com.au"}},[_vm._v("email us")]),_vm._v(" links to your content with a brief description of the work / project for\nconsideration. If deemed suitable for the Loop platform, we will guide you through further steps to\nprepare files and upload full-resolution content for presentation.")],1),_vm._v(" "),_c('p',[_vm._v("If you wish to discuss your proposal please call the number on the "),_c('v-btn',{attrs:{"to":"/contact"}},[_vm._v("contact page")]),_vm._v(".")],1),_vm._v(" "),_c('p',[_vm._v("Submitting content does not indicate the relinquishing of any rights to your work and does not\ngrant permission for The Loop to screen it.")]),_vm._v(" "),_c('p',[_vm._v("If your work is selected for inclusion in the program, you will receive a contract for consideration,\noutlining the terms and conditions of licensing (including screen dates and number of\nscreenings).")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2O9n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panel',{attrs:{"inset":""}},_vm._l((_vm.items),function(item,i){return (!item.hideS)?_c('v-expansion-panel-content',{key:i,model:{value:(_vm.expandMain),callback:function ($$v) {_vm.expandMain=$$v},expression:"expandMain"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        "+_vm._s(_vm.secToClock(item.time))+"\n        "),_c('v-icon',[_vm._v(_vm._s(_vm.getIcon(item.type)))]),_vm._v("\n          "+_vm._s(item.title)+_vm._s(item.name)+" "+_vm._s(_vm.getArtist(item.id))+"\n      ")],1),_vm._v(" "),_c('v-card',[(item.type!='playlist')?_c('v-layout',{attrs:{"row":""}},[_c('div',{staticStyle:{"width":"180px","padding":"20px","padding-top":"0px"}},[_c('v-img',{attrs:{"width":"160","src":_vm.getContent(item.id).imageUrl}})],1),_vm._v(" "),_c('v-flex',[(item.type!='playlist')?_c('v-card-text',{staticStyle:{"padding-top":"0px"}},[_vm._v("\n              Title: "+_vm._s(item.title)+"\n              "),_c('br'),_vm._v("\n              Artist: "+_vm._s(_vm.getContent(item.id).artist)+"\n              "),_c('br'),_vm._v("\n              Description: "+_vm._s(_vm.getContent(item.id).description)+"\n              "),_c('br'),_vm._v("\n              Duration: "+_vm._s(_vm.secondsToDurationText(item.duration))+"\n              "),_c('br')]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(item.type=='playlist')?_c('v-card-text',{staticStyle:{"padding-top":"0px"}},[_c('v-expansion-panel',{attrs:{"inset":"","expand":""},model:{value:(_vm.expandSubX),callback:function ($$v) {_vm.expandSubX=$$v},expression:"expandSubX"}},_vm._l((_vm.playlists[item.id].items),function(child){return (_vm.getContent(child.id).type!='title' && !_vm.getContent(child.id).hideS)?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                "+_vm._s(_vm.secToClock(child.time))+"  \n                "),_c('v-icon',[_vm._v(_vm._s(_vm.getIcon(_vm.getContent(child.id).type)))]),_vm._v("\n                 \n                "+_vm._s(_vm.getContent(child.id).title)+" - "+_vm._s(_vm.getContent(child.id).artist)+"\n              ")],1),_vm._v(" "),_c('v-card',[_c('v-layout',[_c('div',{staticStyle:{"width":"180px","padding":"20px","padding-top":"0px"}},[_c('v-img',{attrs:{"height":"140","width":"160","src":_vm.getContent(child.id).imageUrl}})],1),_vm._v(" "),_c('v-flex',[_c('v-card-text',{staticStyle:{"padding-top":"0px"}},[_vm._v("\n                      Title:"+_vm._s(_vm.getContent(child.id).title)+"\n                      "),_c('br'),_vm._v("\n                      Artist:"+_vm._s(_vm.getContent(child.id).artist)+"\n                      "),_c('br'),_vm._v("\n                      Description:"+_vm._s(_vm.getContent(child.id).description)+"\n                      "),_c('br'),_vm._v("\n                      Duration:"+_vm._s(_vm.secondsToDurationText(child.duration))+"\n                    ")])],1)],1)],1)],1):_vm._e()}))],1):_vm._e()],1)],1):_vm._e()}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3NRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swatches__ = __webpack_require__("gQ/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_swatches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Editable_vue__ = __webpack_require__("Ku90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScheduleView_vue__ = __webpack_require__("IJh6");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a, Swatches: __WEBPACK_IMPORTED_MODULE_2_vue_swatches___default.a, Editable: __WEBPACK_IMPORTED_MODULE_3__Editable_vue__["a" /* default */], ScheduleView: __WEBPACK_IMPORTED_MODULE_4__ScheduleView_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showSchedule: false,
      showSchedOptions: false,
      date: null,
      dateModal: false,
      time: "8:00",
      timeModal: false,
      editDuration: 111,
      currentElement: null,
      editdialog: false,
      mediaMode: "playlist",
      color: '#1CA085',
      scheduleName: "New Schedule",

      schedule: [],
      sourceList: [{ id: "s0", type: "URL", icon: "web_asset", duration: 180, title: "", link: "", description: " " }, { id: "s1", type: "Blank", icon: "broken_image", duration: 60, title: "Blank", description: " " }, { id: "s2", type: "Camera", icon: "camera_alt", duration: 300, title: "", description: " " }, { id: "s3", type: "Title", icon: "font_download", duration: 20, title: "", description: " " }],
      heading: '',
      description: '',
      duration: 1000,
      totalDuration: 0,
      email: '',
      password: '',
      confirmPassword: '',
      elementCount: 0,
      keywordList: [],
      keywords: ['Animation', 'MyState', 'Student', 'Stories in September', 'TAC', 'TAHO', 'Tasmanian Artist', 'The Loop', 'Title', 'UTAS', 'Visual Art', 'Wide Angle', 'Test']
    };
  },
  created: function created() {
    console.log("USER", this.user);
    if (this.mediaList.length == 0) {
      this.$store.dispatch('loadContents');
    }
    if (this.playlists.length == 0) {
      this.$store.dispatch('loadPlaylists');
    }
  },
  mounted: function mounted() {
    this.adjustTimes();
  },


  computed: {
    mediaList: function mediaList() {
      return this.$store.getters.loadedContents;
    },
    playlists: function playlists() {
      //console.log("P",this.$store.getters.loadedPlaylists)
      return this.$store.getters.loadedPlaylists;
    },
    scheduals: function scheduals() {

      return this.$store.getters.loadedSchedules;
    },
    currentSchedule: function currentSchedule() {
      //console.log("P",this.$store.getters.createdKey)
      return this.$store.getters.createdKey;
    },
    currentLoadedSchedule: function currentLoadedSchedule() {
      return this.$store.getters.loadedSchedule(this.currentSchedule);
    },
    getLoops: function getLoops() {
      return 3;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      console.log("HAVE A USER");
    }
  },
  methods: {
    makeJson: function makeJson() {
      var pl = [];
      var plindex = [];
      var item = void 0;
      console.log(this.currentLoadedSchedule, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentLoadedSchedule));
      if (this.currentLoadedSchedule) {
        for (var i in this.currentLoadedSchedule.items) {
          item = this.currentLoadedSchedule.items[i];
          if (item.pListIndex) {
            if (!plindex.includes(item.pListIndex)) {
              pl.push(item.pListId);
              plindex.push(item.pListIndex);
            }
          }
        }
        console.log(pl, plindex);
      }
    },
    deleteSchedule: function deleteSchedule(scheduleId) {
      console.log("DELETE", scheduleId);
      this.deleteID = scheduleId;
      this.deletedialog = true;
      this.$store.dispatch('deleteSchedule', scheduleId);
    },
    confirmDelete: function confirmDelete() {
      console.log("DELETE -", this.deletedialog);
      this.$store.dispatch('deleteSchedule', this.deleteID);
      this.deletedialog = false;
    },
    clean: function clean() {
      this.schedule = [];
      this.elementCount = 0;
      this.$store.commit('setCurrentSchedule', null);
      this.scheduleName = "New Shedule";
      this.time = "8:00";
      this.date = null;
      this.adjustTimes();
    },
    editSchedule: function editSchedule(scheduleList, clean) {

      if (clean) {
        this.clean();
      }
      var self = this;
      this.$store.commit('setCurrentSchedule', scheduleList.id);

      var schedule;
      var item;
      var newItem;
      var time = this.clockToSec(scheduleList.startTime);
      for (var i in scheduleList.items) {
        newItem = {};
        console.log("--", i, scheduleList.items[i]);
        this.elementCount++;
        schedule = scheduleList.items[i];
        item = this.getContent(schedule.id);
        if (item) {
          newItem.tid = "clone" + this.elementCount;
          newItem.duration = parseFloat(schedule.duration, 10);
          newItem.loops = parseInt(schedule.loops, 10) || 1;
          newItem.totalDuration = newItem.duration * newItem.loops;
          newItem.pListId = schedule.pListId;
          newItem.pListIndex = schedule.pListIndex;
          newItem.durationText = this.secToTime(newItem.totalDuration);
          newItem.durationText = newItem.durationText || " ";
          newItem.loops = schedule.loops;
          newItem.imageUrl = item.imageUrl;
          newItem.videoUrl = item.videoUrl;
          newItem.web = item.web;
          newItem.hideS = item.hideS;
          newItem.scaleMode = item.scaleMode;
          newItem.addTitle = item.addTitle;
          newItem.approved = item.approved;
          newItem.artist = item.artist;

          newItem.id = item.id;
          newItem.title = item.title;
          newItem.type = item.type;
          newItem.looping = item.looping;
          newItem.description = item.description;
          newItem.creatorId = item.creatorId;
          newItem.date = item.date;
          newItem.title = item.title;
          newItem.body = item.body;
          newItem.footer = item.footer;
          newItem.subtitle = item.subtitle;

          /*
          keywords: (...)
          mode: (...)
          rating: (...)
          videoSize: (...)
          */

          newItem.time = this.secToTime(time);
          time += newItem.totalDuration;
          console.log("NEW", item, newItem, time, schedule.pListIndex);
          this.schedule.push(newItem);
        } else {
          console.log("Missing item", scheduleList.items[i]);
        }
      }
      this.scheduleName = scheduleList.title;
      this.color = scheduleList.color;
      this.time = scheduleList.startTime;
      this.date = scheduleList.startDate;
      console.log("NEW Schedual", this.schedule, scheduleList);
      this.adjustTimes();
      //this.playlist.push(playlist.items[0]);
      // this.playlist.push(this.rebuild(this.getContent(playlist.items[0].id))
    },
    editableDuration: function editableDuration(type) {
      if (type == "web" || type == "URL" || type == "Camera" || type == "Blank") {
        return true;
      }
      return false;
    },
    doEditChanges: function doEditChanges(changes) {
      if (this.currentElement.type != "video") {
        this.currentElement.duration = this.timeToSec(changes);
      }
      if (this.currentElement.loops) {
        this.currentElement.totalDuration = this.currentElement.duration * this.currentElement.loops;
        this.currentElement.durationText = this.secToTime(this.currentElement.totalDuration);
      } else {
        this.currentElement.totalDuration = this.currentElement.duration = this.timeToSec(this.currentElement.durationText);
      }
      this.adjustTimes();
    },
    deleteItem: function deleteItem(element, index) {
      console.log("remove", element, index, this.schedule);
      //for (var i = this.schedule.length - 1; i >= 0; --i) {
      // if (this.schedule[i].id == element.id) {
      this.schedule.splice(index, 1);
      // }
      //}
      this.adjustTimes();
      console.log("DELETE THIS");
    },
    expand: function expand(evt) {
      console.log("EXPAND", evt, evt.id);
      console.log(this.$refs);
      console.log(this.$refs[evt.id][0].el);
      this.$refs[evt.id][0].styles.height = "200px";
    },
    deploySchedule: function deploySchedule() {
      console.log("Deploy SCHED", this.currentSchedule);
      this.$store.dispatch('setControlsGenerate', this.currentSchedule);
    },
    saveSchedule: function saveSchedule(update) {
      console.log("SAVE SCHED", this.schedule);

      var sched = { duration: this.totalDuration, name: this.scheduleName, color: this.color, startDate: this.date, startTime: this.time };
      sched.items = [];

      var plist;
      var pListItems;
      var count = 0;
      var item;
      var newItem;
      var content;
      for (var i = 0; i < this.schedule.length; i++) {
        newItem = {};
        plist = this.schedule[i];
        if (plist.type == "playlist") {
          pListItems = plist.items;
          //sched.items.push({type:'groupStart',title:'group'})

          for (var j = 0; j < pListItems.length; j++) {
            count++;
            item = pListItems[j];
            sched.items.push({ index: count, duration: parseFloat(item.duration, 10), loops: item.loops, id: item.id, type: plist.type, pListIndex: plist.pListIndex, pListId: plist.itemId });
          }
        } else {
          count++;
          if (plist.itemId) {
            content = this.getContent(plist.itemId);
            newItem.id = plist.itemId;
          } else {
            content = this.getContent(plist.id);
            newItem.id = plist.id;
          }
          newItem.index = count;
          newItem.duration = plist.duration;
          newItem.loops = parseInt(plist.loops, 10) || 1;
          newItem.hideS = plist.hideS;
          newItem.type = plist.type;
          newItem.title = plist.title;
          newItem.duration = plist.duration;

          newItem.pListId = plist.pListId || null;
          if (!isNaN(plist.pListIndex)) {
            newItem.pListIndex = plist.pListIndex;
          }
          if (plist.type == "web" || plist.type == "URL") {
            newItem.link = content.web;
            //newItem.description=content.description
          }
          sched.items.push(newItem);
          //sched.items.push({index:count,duration:plist.duration,loops:parseInt(plist.loops,10),id:plist.id,type:plist.type,title:plist.title,duration:plist.duration})
        }
      }
      if (update) {
        sched.id = this.currentSchedule;
        sched.name = this.scheduleName;
        sched.hideTime = this.currentLoadedSchedule.hideTime || false;
        sched.expandPlaylist = this.currentLoadedSchedule.expandPlaylist || false;
        this.$store.dispatch('updateScheduleData', sched);
      } else {
        this.$store.dispatch('createSchedule', sched);
      }
    },
    getContent: function getContent(id) {
      //console.log("GET",id,this.$store.getters.loadedContent(id))
      return this.$store.getters.loadedContent(id);
    },
    getPlaylist: function getPlaylist(id) {
      console.log("getPlaylist", id);
      return this.$store.getters.loadedPlaylist(id);
    },

    //TODO add totalDuration to all objects
    clone: function clone(e1) {
      console.log(e1);
      this.elementCount++;
      return { id: "clone" + this.elementCount, type: e1.type, title: e1.title,
        name: e1.name, durationText: this.secToTime(e1.duration), duration: e1.duration, totalDuration: e1.duration,
        color: e1.color, time: 0, loops: 0, items: this.cloneItems(e1.items), itemId: e1.id, hideS: e1.hideS };
    },
    cloneItems: function cloneItems(items) {
      var newItems = [];
      var item;
      console.log(items);
      for (var i in items) {
        item = items[i];
        console.log("--", item);
        newItems.push({ duration: item.duration, id: item.id, loops: item.loops, index: item.index, hideS: item.hideS });
      }
      return newItems;
    },
    cloneMedia: function cloneMedia(e1) {
      console.log(e1);
      this.elementCount++;
      return { id: "clone" + this.elementCount, type: e1.type, title: e1.title, footer: e1.footer || null, subtitle: e1.subtitle || null, name: e1.name, durationText: this.secToTime(e1.duration), duration: e1.duration, totalDuration: e1.duration, color: e1.color, time: 0, loops: 1, videoUrl: e1.videoUrl, imageUrl: e1.imageUrl, itemId: e1.id, hideS: e1.hideS };
    },
    cloneSource: function cloneSource(e1) {
      console.log("Source", e1);
      this.elementCount++;
      return { id: "clone" + this.elementCount, type: e1.type, title: e1.title, name: e1.name, link: e1.link, description: e1.description, durationText: this.secToTime(e1.duration), duration: e1.duration, totalDuration: e1.duration, color: e1.color, time: 0, loops: 0, videoUrl: e1.videoUrl, imageUrl: e1.imageUrl, itemId: e1.id, hideS: e1.hideS };
    },
    onChange: function onChange(evt) {
      console.log("Change", evt);
      var type;
      if (evt.added) {
        try {
          type = evt.added.element.type;
          console.log("Change added", type);
          this.currentElement = evt.added.element;
          switch (type) {
            case "Blank":
              this.editdialog = true;
              break;
          }
        } catch (err) {
          console.log("Not a Vaild element");
        }
      }
      this.adjustTimes();
    },
    adjustTimes: function adjustTimes() {

      var time = this.timeToSec(this.time + ":00");
      this.totalDuration = 0;
      console.log("ADJUST TIME", this.time, this.timeToSec(this.time + ":00"));
      for (var i = 0; i < this.schedule.length; i++) {
        this.schedule[i].totalDuration = parseFloat(this.schedule[i].totalDuration, 10);
        this.schedule[i].time = this.secToTime(time + this.totalDuration);
        this.totalDuration += this.schedule[i].totalDuration;
        console.log("XXX", this.schedule[i]);
        if (this.schedule[i].type == "playlist") {
          console.log("PLAYLIST", this.schedule[i]);
          this.schedule[i].pListIndex = i;
          for (var item in this.schedule[i].items) {
            this.schedule[i].items[item].pListIndex = i;
          }
        }
        //this.schedule[i].id="media_"+i; 
        //this.schedule[i] = Object.assign({}, this.schedule[i], { time: this.secToTime(items[i].offsetTop*60) })
        //}
      }
      console.log("SCHEDULE", this.schedule);
    },
    textChange: function textChange() {
      console.log("TC");
      this.adjustTimes();
    },
    cardRef: function cardRef(element) {
      return element.id;
    },
    mediaHeight: function mediaHeight(element) {
      console.log("HH", element.loops);
      //return (element.totalDuration/10)+"px"
      return "100px";
    },
    checkMove: function checkMove(evt) {
      // cant drag empty elements

      return evt.draggedContext.element.name !== '';
    },
    sendMessage: function sendMessage(btn) {
      this.$store.dispatch('sendMessage', { heading: this.heading, description: this.description });
      console.log(this.heading);
    },
    sendCommand: function sendCommand(btn) {
      this.$store.dispatch('sendCommand', btn);
      console.log(btn);
    },
    onSignin: function onSignin() {
      console.log('email:', this.email);
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      console.log('Dismissed alert');
      this.$store.dispatch('clearError');
    },
    secToTime: function secToTime(sec) {
      var secs = sec % 60;
      var mins = (sec - secs) / 60 % 60;
      var hrs = (sec - mins * 60 - secs) / 60 / 60;
      secs = Math.round(secs);
      if (secs < 10) secs = "0" + secs;
      if (mins < 10) mins = "0" + mins;
      return hrs + ":" + mins + ":" + secs;
    },
    timeToSec: function timeToSec(time) {
      var times = time.split(":");
      var secs = parseInt(times[2], 10);
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60 + secs;
    },
    clockToSec: function clockToSec(time) {
      var times = time.split(":");
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60;
    },
    matchesKey: function matchesKey(element) {

      if (this.keywordList.length == 0) {
        return true;
      }
      if (this.keywordList[0] == "None" && !element.keywords) {
        return true;
      }
      if (!element.keywords) {
        return false;
      }
      return this.findOne(this.keywordList, element.keywords);
    },
    findOne: function findOne(haystack, arr) {
      var haystack_lc = haystack.map(function (x) {
        return x.toLowerCase();
      });
      return arr.some(function (v) {

        return haystack_lc.indexOf(v.toLowerCase()) >= 0;
      });
    }
  }
});

/***/ }),

/***/ "3r5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({
        colour: "#00000044",
        height: 30,
        pad: 3,
        width: Math.random() * 50 + 50,
        child: childA
      });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    glitch: function glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "3ul3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      trackInfo: [],
      prelaunch: false

    };
  },


  computed: {
    menuItems: function menuItems() {
      var menuItems = [
      //{icon: 'face', title: 'Sign Up', link: '/signup'},
      //{icon: 'lock_open', title: 'Sign In', link: '/signin'},
      { icon: 'movie', title: 'Upload content', link: '/content/new' }];
      return menuItems;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },

  methods: {}
});

/***/ }),

/***/ "4N5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Colour_vue__ = __webpack_require__("x+az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a35a26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Colour_vue__ = __webpack_require__("cK6N");
function injectStyle (ssrContext) {
  __webpack_require__("gQzT")
  __webpack_require__("w9mj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51a35a26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Colour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a35a26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Colour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ec5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4jLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('h2',[_vm._v("Slowbart")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("i6fs"),"width":"100%"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Call out for film and video content for a new program on The Loop")]),_vm._v(" "),_c('p',[_vm._v("From ambient landscapes and soundscapes to leisurely depictions of local happenings, Slowbart is about stories told at a relaxed pace. It’s about gradually unfolding moments and experiences, designed to be enjoyed by audiences as they wait, or pass by, or settle in for the long-haul.")]),_vm._v(" "),_c('p',[_vm._v("Emerging curators Victoria Bremner and Heath Willis from the School of Media at the University of Tasmania are seeking film and video that encapsulates these ideas, whether in narrative or non-narrative form.")]),_vm._v(" "),_c('p',[_vm._v("Filmmakers, artists and content makers of all kinds are asked to scour their hard drives, delve into the depths of their filing cabinets and check under their beds to contribute imagery for this program...")]),_vm._v(" "),_c('p',[_vm._v("Do you have some stunning footage that’s never quite fitted in anywhere? A long cut of an existing work? A strangely meditative tale?  ")]),_vm._v(" "),_c('h2',[_vm._v("Submit before Wednesday 17 April 2019.")]),_vm._v(" "),_c('p',[_vm._v("Slowbart will screen on The Loop, the City of Hobart’s digital art platform located in the public courtyard of 157 Elizabeth Street, from May to July 2019. The program will be launched with a special media event to celebrate the selected work. ")]),_c('p',[_vm._v("\nPlease note that The Loop does not accept commercial or advertising content.")]),_vm._v(" "),_c('p',[_vm._v("\n          To submit content for consideration go to:  "),_c('v-btn',{attrs:{"to":'/participate'}},[_c('span',{staticStyle:{"text-transform":"lowercase"}},[_vm._v("theloophobart.com.au/participate")])])],1),_c('p',[_vm._v("For all enquiries email: "),_c('v-btn',{attrs:{"href":"mailto:publicart@hobartcity.com.au"}},[_c('span',{staticStyle:{"text-transform":"lowercase"}},[_vm._v("publicart@hobartcity.com.au")])])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4xsP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{key:'g'+g,staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{key:'gc'+gc,staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%","margin":"auto"}},[_vm._l((_vm.currentEvents),function(ce,i){return _c('div',{key:'ce'+i},[(_vm.showEvent(ce.title))?_c('div',[_c('div',{staticClass:"EventHeading",staticStyle:{"font-weight":"600"}},[_c('i',[_vm._v(_vm._s(ce.status))])]),_vm._v(" "),(ce.image)?_c('img',{attrs:{"src":ce.image,"width":"100%"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"EventHeading"},[_c('i',[_vm._v(_vm._s(ce.title))])]),_vm._v(" "),_c('h2',[_vm._v("\n        "+_vm._s(ce.date)+"\n        "),_c('br'),_vm._v(_vm._s(ce.location)+"\n        "),_c('br'),_vm._v(_vm._s(ce.time)+"\n        "),_c('br')]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(ce.content)}}),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1,true)]):_vm._e()])}),_vm._v(" "),_c('h2',[_vm._v("Host your Event")]),_vm._v(" "),_c('p',[_vm._v("\n          The Loop has the capacity to host screenings with invited audiences, such as for the\n          premiere of a neew film or digital art work.\n        ")]),_vm._v(" "),_c('p',[_vm._v("It is also an ideal venue for hybrid and/or interactive art screenings and performances.")]),_vm._v(" "),_c('p',[_vm._v("\n          Get in touch\n          "),_c('v-btn',{attrs:{"to":"/contact","pl-0":""}},[_vm._v("Contact")]),_vm._v("to discuss your proposal.\n        ")],1)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5FE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"60%","lazy":"","persistentX":""},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-btn',{attrs:{"slot":"activator","accent":""},slot:"activator"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("present_to_all")]),_vm._v("Full Details\n  ")],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoUrl),expression:"videoUrl"}],attrs:{"width":"100%","poster":_vm.imageUrl,"src":_vm.videoUrl,"type":"video/mp4","controls":""}}),_vm._v(" "),(!_vm.videoUrl)?_c('v-img',{attrs:{"src":_vm.imageUrl}}):_vm._e(),_vm._v(" "),(_vm.content.allowEdit && (_vm.videoUrl || false))?_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"disabled":_vm.uploading,"flat":""}},[_vm._v("Replace Video")]):_vm._e(),_vm._v(" "),(_vm.content.allowEdit && (_vm.videoUrl || true))?_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}}):_vm._e(),_vm._v(" "),(_vm.content.allowEdit && _vm.imageUrl )?_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"disabled":_vm.uploading,"flat":""},on:{"click":_vm.onPickFile}},[_vm._v("Replace Image")]):_vm._e(),_vm._v(" "),(_vm.content.type=='title')?_c('div',{staticClass:"titlePreview",staticStyle:{"width":"480px","height":"288px","font-size":"30px","margin":"auto","max-width":"480px","max-height":"288px"}},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.content.title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(_vm.content.subtitle))]),_vm._v(" "),(false)?_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(_vm.content.body))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(_vm.content.footer))])]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","required":""},model:{value:(_vm.content.title),callback:function ($$v) {_vm.$set(_vm.content, "title", $$v)},expression:"content.title"}}),_vm._v(" "),(_vm.content.type!='title')?_c('div',[_c('v-text-field',{attrs:{"name":"author","label":"Author","id":"author","required":""},model:{value:(_vm.content.artist),callback:function ($$v) {_vm.$set(_vm.content, "artist", $$v)},expression:"content.artist"}}),_vm._v(" "),(_vm.content.web)?_c('v-text-field',{attrs:{"name":"url","label":"URL","id":"url"},model:{value:(_vm.content.web),callback:function ($$v) {_vm.$set(_vm.content, "web", $$v)},expression:"content.web"}}):_vm._e(),_vm._v(" "),_c('v-textarea',{attrs:{"name":"description","label":"Description","id":"description","required":""},model:{value:(_vm.content.description),callback:function ($$v) {_vm.$set(_vm.content, "description", $$v)},expression:"content.description"}})],1):_c('div',[_c('v-text-field',{attrs:{"name":"subtitle","label":"Subtitle","id":"subtitle"},model:{value:(_vm.content.subtitle),callback:function ($$v) {_vm.$set(_vm.content, "subtitle", $$v)},expression:"content.subtitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"footer","label":"Footer","id":"footer"},model:{value:(_vm.content.footer),callback:function ($$v) {_vm.$set(_vm.content, "footer", $$v)},expression:"content.footer"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Close")]),_vm._v(" "),(_vm.content.allowEdit)?_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":_vm.doEdit}},[_vm._v("Save")]):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5TPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var date = new Date(value);

  return date.toLocaleString('en-GB', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
});

/***/ }),

/***/ "5eZ5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6EED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__("2aIq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    userContents: [],
    email: null,
    admin: false,
    curator: false
  },
  mutations: {
    setAdmin: function setAdmin(state, payload) {
      state.admin = payload;
    },
    setCurator: function setCurator(state, payload) {
      state.curator = payload;
    },
    setUserContents: function setUserContents(state, payload) {
      state.userContents = payload;
    },
    setEmail: function setEmail(state, payload) {
      state.user.email = payload;
    },
    assignContentToUser: function assignContentToUser(state, payload) {
      var id = payload.id;
      state.user.fbKeys[id] = payload.fbKey;
    },
    assignUserEmail: function assignUserEmail(state, payload) {

      state.email = payload;
    },
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    assignUserEmail: function assignUserEmail(_ref, payload) {
      var commit = _ref.commit,
          getters = _ref.getters;

      commit('setLoading', true);
      var user = getters.user;
      var email = __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().currentUser.email;
      console.log("XXXXX", email, payload, user);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id).child('/email/').set(email).then(function (data) {
        commit('setLoading', false);
        commit('assignUserEmail', { email: email });
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    assignContentToUser: function assignContentToUser(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('setLoading', true);
      var user = getters.user;
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id).child('/content/').push(payload).then(function (data) {
        commit('setLoading', false);
        commit('assignContentToUser', { id: payload, fbKey: data.key });
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    getUserContent: function getUserContent(_ref3, payload) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      commit('setLoading', true);
      var user = getters.user;
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.id).child('/content/').push(payload).then(function (data) {
        commit('setLoading', false);
        commit('assignContentToUser', { id: payload, fbKey: data.key });
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    getContact: function getContact(_ref4, userID) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Do something here... lets say, a http call using vue-resource

        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + userID + '/email/').once('value').then(function (data) {
          commit('setLoading', false);
          console.log(data.val());
          resolve(data.val());
        }, function (error) {
          // http failed, let the calling function know that action did not work out
          commit('setLoading', false);
          reject(error);
        });
      });
      console.log("GET CONTACT For ", userID);
      // this.$store.commit('setLoading', true)

      // commit('setLoading', false)
    },
    signUserUp: function signUserUp(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          admin: false,
          user: true,
          fbKeys: {}
        };
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.uid).child('/admin/').set(false).then(function (data) {
          console.log("Setting admin", user.id, false);
          commit('setUser', newUser);
        });
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserUpGoogle: function signUserUpGoogle(_ref6, payload) {
      var commit = _ref6.commit;

      commit('setLoading', true);
      commit('clearError');
      console.log("SIGN UP WITH GOOGLE");
      var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithPopup(provider).then(function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        var newUser = {
          id: user.uid,
          admin: false,
          user: true,
          fbKeys: {}
        };
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + user.uid).child('/user/').set(true).then(function (data) {

          commit('setUser', newUser);
        });
        // ...
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });
      commit('setLoading', false);
    },
    signUserIn: function signUserIn(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          fbKeys: {}
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setUser', { id: payload.uid, fbKeys: {} });
    },
    forgotPassword: function forgotPassword(_ref9, emailAddress) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

      var auth = __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]();
      console.log("forgot", emailAddress);
      auth.sendPasswordResetEmail(emailAddress).then(function (message) {
        console.log("Email SENT");
        alert("An email has been sent to " + emailAddress + " please follow the link to reset your password");
      }).catch(function (error) {
        console.log("EMAIL ERROR", error);
        alert(error.message);
      });
    },
    fetchUserData: function fetchUserData(_ref10) {
      var commit = _ref10.commit,
          getters = _ref10.getters;

      commit('setLoading', true);
      var uploadedContent = [];

      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + getters.user.id + '/content/').once('value').then(function (data) {
        var dataPairs = data.val();
        var swappedPairs = {};
        for (var key in dataPairs) {
          uploadedContent.push(dataPairs[key]);
          swappedPairs[dataPairs[key]] = key;
        }
        var updatedUser = {
          id: getters.user.id,
          uploadedContent: uploadedContent,
          fbKeys: swappedPairs
        };
        commit('setLoading', false);
        commit('setUser', updatedUser);
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + getters.user.id + '/admin/').once('value').then(function (data) {
          commit('setAdmin', data.val());
          __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + getters.user.id + '/curator/').once('value').then(function (data) {
            commit('setCurator', data.val());
            __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + getters.user.id + '/email/').once('value').then(function (data) {
              commit('setEmail', data.val());
            });
          });
        });
      }).catch(function (error) {
        commit('setLoading', false);
        console.log(error);
      });
    },
    loadUserInfo: function loadUserInfo(_ref11, uid) {
      var commit = _ref11.commit;

      commit('setLoading', true);
      console.log(__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().currentUser.email);

      commit('setLoading', false);
    },
    loadUserContents: function loadUserContents(_ref12, id) {
      var commit = _ref12.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('content').once('value').then(function (data) {
        var contents = [];
        var obj = data.val();
        for (var key in obj) {
          console.log(obj[key].creatorId, "   ", id);
          if (id == obj[key].creatorId) {
            contents.push({
              id: key,
              title: obj[key].title,
              description: obj[key].description,
              artist: obj[key].author,
              videoUrl: obj[key].videoUrl,
              imageUrl: obj[key].imageUrl,
              date: obj[key].date,
              creatorId: obj[key].creatorId
            });
          }
        }
        commit('setLoading', false);
        commit('setUserContents', contents);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    logout: function logout(_ref13) {
      var commit = _ref13.commit;

      __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signOut();
      commit('setUser', null);
      console.log(LOGOUT);
    }
  },
  getters: {
    email: function email(state) {},
    user: function user(state) {
      return state.user;
    },
    userAdmin: function userAdmin(state) {
      return state.admin;
    },
    userCurator: function userCurator(state) {
      return state.curator;
    },
    userContents: function userContents(state) {
      return state.userContents.sort(function (contentA, contentB) {
        var d1 = new Date(contentA.date);
        var d2 = new Date(contentB.date);
        return d2.getTime() - d1.getTime();
      });
    }
  }
});

/***/ }),

/***/ "6FS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibertyLoop_vue__ = __webpack_require__("3r5L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1755563a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibertyLoop_vue__ = __webpack_require__("o61H");
function injectStyle (ssrContext) {
  __webpack_require__("mWuK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1755563a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LibertyLoop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1755563a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LibertyLoop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "82ws":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8qSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Playlist_vue__ = __webpack_require__("PV2S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_013cdbd9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Playlist_vue__ = __webpack_require__("YAQW");
function injectStyle (ssrContext) {
  __webpack_require__("SnXZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-013cdbd9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Playlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_013cdbd9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Playlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "950n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasTouch: false,
      canvas: null,
      ctx: null,
      xPos: null,
      yPos: null,
      screenCol: null,
      mouseIsDown: false,
      moveY: 0,
      moveX: 0,
      pixelSpeed: 5,
      cDown: false,
      cDownFor: 0,
      colourIndex: 0,
      effectIndex: 0,
      colours: ["rgb(255,   255,   255)", "rgb(255,   0,   0)", "rgb(255,   0, 255)", "rgb(0,     0, 255)", "rgb(0,   255, 255)", "rgb(0,   255,   0)", "rgb(255, 255,   0)", "rgb(255,   127,   0)"],
      effect: {}

    };
  },
  mounted: function mounted() {
    window.requestAnimationFrame(this.step);
    //this.$store.dispatch('loadStatus');
    if (!this.screenMode) {
      this.$store.dispatch("loadPixels");

      this.$store.dispatch("addPixel");
    } else {
      //this.$store.dispatch("loadPixels");
      this.$store.dispatch("resetPixels");
      this.$store.dispatch("loadPixels");
      this.addVEffect(300, 300, "#0f0");
      this.addHEffect(300, 300, "#0f0");
    }
  },

  computed: {
    pixelColour: function pixelColour() {
      if (this.pixel) {
        return this.pixel.color;
      }
      return "rgb(50, 50, 50)";
    },
    pixelIndex: function pixelIndex() {
      return this.$store.getters.getPixelIndex;
    },
    screenMode: function screenMode() {
      return this.$route.path.indexOf("screen") > -1;
    },
    pixel: function pixel() {
      console.log(this.pixels);
      for (var p in this.pixels) {
        console.log("PX", p);
        if (p == "pixel" + this.pixelIndex) {
          this.pixels[p].id = p;
          return this.pixels[p];
        }
      }
      return null;
    },
    pixels: function pixels() {
      return this.$store.getters.getPixels;
    },
    colour: function colour() {
      return this.$store.getters.getColour;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },

  methods: {
    addVEffect: function addVEffect(x, y, c) {
      this.$set(this.effect, "v" + this.effectIndex, { vis: true, x: x, y: y, vx: 0, vy: 10, c: c });
      this.effectIndex++;
      this.$set(this.effect, "v" + this.effectIndex, { vis: true, x: x, y: y, vx: 0, vy: -10, c: c });
      this.effectIndex++;
    },
    addHEffect: function addHEffect(x, y, c) {
      this.$set(this.effect, "v" + this.effectIndex, { vis: true, x: x, y: y, vx: 10, vxy: 0, c: c });
      this.effectIndex++;
      this.$set(this.effect, "v" + this.effectIndex, { vis: true, x: x, y: y, vx: -10, vxy: 0, c: c });
      this.effectIndex++;
    },
    pixelX: function pixelX(p) {
      return (p.xpos % window.innerWidth + window.innerWidth) % window.innerWidth;
    },
    pixelY: function pixelY(p) {
      return (p.ypos % window.innerHeight + window.innerHeight) % window.innerHeight;
    },
    step: function step() {
      var hasEffect = void 0;
      for (var p in this.effect) {
        if (this.effect[p].vis) {
          this.$set(this.effect[p], "y", this.effect[p].y + this.effect[p].vy);
          this.$set(this.effect[p], "x", this.effect[p].x + this.effect[p].vx);
          if (this.effect[p].x > window.innerWidth) {
            this.$set(this.effect[p], "vis", false);
            //delete this.effect[p]
          } else if (this.effect[p].x < 0) {
            this.$set(this.effect[p], "vis", false);
            //delete this.effect[p]
          }if (this.effect[p].y > window.innerHeight) {
            this.$set(this.effect[p], "vis", false);
            // delete this.effect[p]
          } else if (this.effect[p].y < 0) {
            this.$set(this.effect[p], "vis", false);
            // delete this.effect[p]
          }
        }
        if (this.screenMode) {

          for (var p in this.pixels) {

            for (var t in this.pixels) {
              hasEffect = false;
              if (p != t) {

                if (this.pixels[p].xpos > 0 && this.pixelX(this.pixels[p]) == this.pixelX(this.pixels[t])) {
                  if (!this.pixels[p].hasEffect) {
                    hasEffect = true;
                    this.addVEffect(this.pixelX(this.pixels[p]), this.pixelY(this.pixels[p]), this.pixels[p].color);
                  }
                  if (!this.pixels[t].hasEffect) {
                    hasEffect = true;
                    this.addVEffect(this.pixelX(this.pixels[t]), this.pixelY(this.pixels[t]), this.pixels[t].color);
                  }
                }

                if (this.pixels[p].ypos > 0 && this.pixelY(this.pixels[p]) == this.pixelY(this.pixels[t])) {

                  if (!this.pixels[p].hasEffect) {
                    hasEffect = true;
                    this.addHEffect(this.pixelX(this.pixels[p]), this.pixelY(this.pixels[p]), this.pixels[p].color);
                  }
                  if (!this.pixels[t].hasEffect) {
                    hasEffect = true;
                    this.addHEffect(this.pixelX(this.pixels[t]), this.pixelY(this.pixels[t]), this.pixels[t].color);
                  }
                }
                if (hasEffect) {
                  this.pixels[p].hasEffect = true;
                  this.pixels[t].hasEffect = true;
                }
              }
            }
          }
        }
      }
      if (this.pixel) {
        if (this.moveY) {
          this.pixel.ypos += this.moveY * this.pixelSpeed;
          this.$store.dispatch("setPixel", this.pixel);
          this.pixels.hasEffect = false;
        }
        if (this.moveX) {
          this.pixel.xpos += this.moveX * this.pixelSpeed;
          this.$store.dispatch("setPixel", this.pixel);
          this.pixels.hasEffect = false;
        }
        if (this.cDown) {
          this.cDownFor++;
          if (this.cDownFor > 200) {
            this.pixel.color = this.colours[Math.floor((this.cDownFor - 200) / 50) % this.colours.length];
          } else {
            this.pixel.color = this.colours[0];
          }
        }
      }
      window.requestAnimationFrame(this.step);
    },
    moveUp: function moveUp() {
      console.log(this.pixels.pixel1);
      //this.$store.dispatch("setColour", "rgb(255,255,0)");
      //this.pixels.pixel1.ypos -= 10;
      this.$store.dispatch("setPixel", this.pixels.pixel1);
    },
    mouseDown: function mouseDown(event) {
      this.mouseIsDown = true;
      this.mouseMove(event);
    },
    centerUp: function centerUp(event) {
      this.cDown = false;
      this.cDownFor = 0;
      this.$store.dispatch("setPixel", this.pixel);
    },
    mouseUp: function mouseUp(event) {
      this.mouseIsDown = false;
      this.moveY = 0;
      this.moveX = 0;
    }
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ "96hL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadContent_vue__ = __webpack_require__("DvNh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcc6e27e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadContent_vue__ = __webpack_require__("yP2D");
function injectStyle (ssrContext) {
  __webpack_require__("MKaD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcc6e27e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ATei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");

/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.userAdmin) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),

/***/ "B7Ey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Current_vue__ = __webpack_require__("N8ek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_829e2610_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Current_vue__ = __webpack_require__("Xn6Y");
function injectStyle (ssrContext) {
  __webpack_require__("bM7r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-829e2610"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Current_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_829e2610_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Current_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Br1U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content_ScheduleView_vue__ = __webpack_require__("IJh6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ScheduleView: __WEBPACK_IMPORTED_MODULE_0__Content_ScheduleView_vue__["a" /* default */] },
  data: function data() {
    return {
      trackInfo: [],
      prelaunch: false,
      lastPlaylistId: null,
      hasPlaying: false,
      plistIds: [],
      scheduleDisplay: null,
      nowPlaying: null,
      currentSchedule: null,
      lastTrack: null,
      currentTrack: null,
      date: null,
      dateModal: false,

      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    //this.$store.dispatch('loadStatus');
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
    console.log("MOUNTED", this.status);
    this.date = new Date().toISOString().substr(0, 10);
    console.log("PROGRAM MOUNTED");
  },

  computed: {
    hasStatus: function hasStatus() {
      return this.$store.getters.getStatus != null;
    },
    status: function status() {

      return this.$store.getters.getStatus;
    },
    tracks: function tracks() {

      return this.$store.getters.getTracks;
    },
    trackIndex: function trackIndex() {
      if (status) {
        return status.active;
      } else {
        return null;
      }
    },
    schedules: function schedules() {

      return this.$store.getters.loadedSchedules;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  watch: {
    status: function (_status) {
      function status(_x) {
        return _status.apply(this, arguments);
      }

      status.toString = function () {
        return _status.toString();
      };

      return status;
    }(function (status) {
      console.log("Watch status", status);
      this.currentTrack = status.active;
      if (this.currentTrack != this.lastTrack) {
        this.currentSchedule = this.$store.getters.loadedSchedule(status.schedule);
        this.lastTrack = this.currentTrack;
        var key = this.tracks.tracks[this.currentTrack - 1].split('.')[0];
        if (key.substr(0, 1) == "-") {
          this.nowPlaying = this.$store.getters.loadedContent(key);
        } else {
          this.nowPlaying = this.getContent(this.currentSchedule.items[this.currentTrack - 1].id);
        }
      }
    })
  },
  methods: {
    allowedDates: function allowedDates(val) {
      parseInt(val.split('-')[2], 10) % 2 === 0;
    },
    playlistInfo: function playlistInfo(playlist) {
      this.plistIds.push(playlist.id);
      if (this.plistIds.length > 1 && this.plistIds[this.plistIds.length - 1] == this.plistIds[this.plistIds.length - 2]) {
        //this.lastPlaylistId=playlist.id;
        return null;
      } else {
        return "[ " + playlist.name + " ]";
      }
    },
    showSchedule: function showSchedule(id) {
      console.log("SHOW", id);
    },
    getContent: function getContent(id) {
      //console.log("GET CONTENT",id)
      // console.log(this.$store.getters.loadedContent(id));
      return this.$store.getters.loadedContent(id);
    },
    getPlaylist: function getPlaylist(id) {

      return this.$store.getters.loadedPlaylist(id);
    },
    secondsToDuration: function secondsToDuration(sec) {
      var hrs = Math.floor(sec / (60 * 60));
      var mins = Math.floor((sec - hrs * 60 * 60) / 60);
      var secs = Math.floor(sec % 60);
      if (hrs < 10) {
        hrs = "0" + hrs;
      }
      if (mins < 10) {
        mins = "0" + mins;
      }
      if (secs < 10) {
        secs = "0" + secs;
      }
      return hrs + ":" + mins + ":" + secs;
    },
    glitch: function glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);
        return;
      }
      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "CAEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block","min-width":"100px"},attrs:{"contenteditable":"true"},on:{"input":_vm.update}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cedj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    tracks: null
  },
  mutations: {
    setTracks: function setTracks(state, payload) {
      console.log("PL", payload);
      state.tracks = payload;
    }
  },
  actions: {
    loadTracks: function loadTracks(_ref) {
      var commit = _ref.commit;

      console.log("LOAD STATUS");
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('tracks').on('value', function (snapshot) {
        console.log(snapshot);
        console.log(snapshot.val());
        commit('setTracks', snapshot.val());
      });
    }
  },
  getters: {
    getTracks: function getTracks(state) {
      console.log("GET STATUS");
      return state.tracks;
    }
  }
});

/***/ }),

/***/ "Cppt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CzIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "Dqi8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__("yCdV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c848354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__("Zfyi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c848354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DvNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe__ = __webpack_require__("QhtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__("2Pnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  //Vue.component('vue-friendly-iframe', VueFriendlyIframe);
  components: { VueFriendlyIframe: __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe___default.a, Checkbox: __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a },
  data: function data() {
    return {
      mode: "message",
      uploadStarted: false,
      videoText: '[  MP4 files Only - NB Large Files may not Preview ] <br> [ No files over 5GB ]',
      videoDetails: "",
      valid: true,
      imageUrl: '',
      videoUrl: '',
      webURL: '',
      webURLInput: '',
      date: new Date(),
      time: new Date(),
      contentInfo: {
        title: '',
        author: '',
        image: '',
        video: '',
        videoSize: '',
        description: '',
        duration: '',
        type: 'video',
        addTitle: false,
        keywords: [],
        date: new Date(),
        scaleMode: 'none',
        mode: "submitted"
      },

      keywords: ['UTAS', 'Student', 'Wide Angle', 'The Loop', 'Test'],
      notEmpty: [function (v) {
        return !!v || 'can\'t be empty';
      }],
      titleRules: [function (v) {
        return !!v || 'Title is required';
      }, function (v) {
        return v && v.length >= 2 || 'Title is too short';
      }]
    };
  },
  mounted: function mounted() {
    if (this.isCurator) {} else {
      this.mode = "video";
    }
  },

  computed: {
    progress: function progress() {
      return this.$store.getters.progress;
    },
    progressText: function progressText() {
      var pct = (Math.floor(this.progress * 100) * .01 + "").substr(0, 5);
      if (pct.length == 1) {
        pct += ".00";
      }
      if (pct.length == 2) {
        pct += ".00";
      }
      if (pct.length == 3) {
        pct += "0";
      }
      if (pct.length == 4 && this.progress > 10) {
        pct += "0";
      }
      return pct + "%";
    },
    formIsValid: function formIsValid() {
      return this.contentInfo.title !== '' && (this.contentInfo.author !== '' || this.mode == 'title') && (this.imageUrl !== '' || this.mode == 'title') && (this.contentInfo.video !== '' || this.mode !== 'video') && (this.webUrl !== '' || this.mode !== 'web') && (this.contentInfo.description !== '' || this.mode == 'title');
    },
    fullDateTime: function fullDateTime() {
      var date = new Date(this.date);
      if (typeof this.time === 'string') {
        var hours = this.time.match(/^(\d+)/)[1];
        var minutes = this.time.match(/:(\d+)/)[1];
        date.setHours(hours);
        date.setMinutes(minutes);
      } else {
        date.setHours(this.time.getHours());
        date.setMinutes(this.time.getMinutes());
      }
      return date;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    isCurator: function isCurator() {
      return this.$store.getters.userCurator;
    }
  },
  methods: {
    setType: function setType(type) {
      this.mode = type;
      this.contentInfo.type = type;
    },
    getScreenGrab: function getScreenGrab() {

      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector("#webFrame").querySelector("body")).then(function (canvas) {
        document.body.appendChild(canvas);
      });

      canvas = document.getElementById("c");
      var storageRef = firebase.storage().ref();
      var mountainsRef = storageRef.child('mountains.jpg');
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      var uploadTask = storageRef.child('images/' + "apple").put(image);
      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // See below for more detail
      }, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        var downloadURL = uploadTask.snapshot.downloadURL;
      });
    },
    uploading: function uploading() {
      if (!this.$store.getters.uploading && this.uploadStarted) {
        this.uploadStarted = false;
        this.$router.push('/profile');
      } else if (this.$store.getters.uploading) {
        this.uploadStarted = true;
      }
      return this.$store.getters.uploading;
    },
    onCreateContent: function onCreateContent() {
      console.log("CREATE CONTENT", this.contentInfo);
      if (!this.formIsValid) {
        console.log("FORM not valis");
        return;
      }
      if (!this.contentInfo.image && this.mode != "title") {
        console.log("No Image");
        return;
      }
      if (!this.contentInfo.video && this.mode == "video") {
        console.log("No Video");
        return;
      }
      if (!this.contentInfo.web && this.mode == "web") {
        console.log("No Web");
        return;
      }

      this.$store.dispatch('createContent', this.contentInfo);
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onPickVideo: function onPickVideo() {
      this.contentInfo.web = "";
      this.$refs.videoInput.click();
    },
    onPickUrl: function onPickUrl() {
      this.contentInfo.web = this.webURLInput;
      this.contentInfo.video = "";
      this.webURL = this.webURLInput;
    },
    onVideoPicked: function onVideoPicked(event) {
      var _this = this;

      var self = this;
      this.videoText = "loading preview ";
      var files = event.target.files;

      var filename = files[0].name;
      this.videoDetails = "file:" + filename + " size:" + Math.round(files[0].size / 1024 / 1024) + "MB";
      console.log(files[0]);

      if (filename.lastIndexOf('.mp4') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function (data) {
        console.log("LOADING", fileReader);
        console.log("LOADING2", data);
      });
      fileReader.addEventListener('progress', function (data) {
        console.log("progress", data);
        _this.videoText = "loading preview " + data.loaded;
      });
      fileReader.addEventListener('loadend', function (data) {
        console.log("LOADED", fileReader, data);
        _this.videoUrl = fileReader.result;
      });
      if (files[0].size < 1024 * 1024 * 500) {
        fileReader.readAsDataURL(files[0]);
        //fileReader.readAsDataURL(slice)
        this.contentInfo.video = files[0];
        var vid = document.getElementById("video1");
        //console.log("SIZE",vid.width,vid.height);
        //self.contentInfo.videoSize=vid.width+","+vid.height;
        vid.oncanplay = function () {
          self.contentInfo.duration = vid.duration;
          console.log("SIZE", vid.videoWidth, vid.videoHeight);
          self.contentInfo.videoSize = vid.videoWidth + "," + vid.videoHeight;
        };
      } else {
        this.videoText = "File too large to preview please continue with submission or upload a smaller file";
        this.contentInfo.video = files[0];
      }
    },
    onFilePicked: function onFilePicked(event) {
      var _this2 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this2.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.contentInfo.image = files[0];
    }
  }
});

/***/ }),

/***/ "ETxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g,gi){return _c('div',{key:'g'+gi,staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc,gci){return _c('div',{key:'gc'+gci,staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pa-0":"","fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[(_vm.showBars)?_c('div',{attrs:{"id":"colorBars"}},_vm._l((_vm.colours),function(bar,b){return _c('div',{key:'bar'+b,staticClass:"colorBar",style:({backgroundColor:bar.colour,height:bar.height+'px',marginBottom:bar.pad+'px',width:bar.width+'%'})})})):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","offset-xs2":""}},[_c('v-carousel',{ref:'carousel',style:('height:'+_vm.vidHeight+'px;box-shadow:none;'),attrs:{"hide-delimiters":"","cycle":_vm.cycle,"interval":_vm.cinterval},model:{value:(_vm.cModel),callback:function ($$v) {_vm.cModel=$$v},expression:"cModel"}},[_c('v-carousel-item',{attrs:{"reverse-transition":"fade-transition","transition":"fade-transition"}},[_c('video',{staticStyle:{"margin-top":"10px","margin":"auto","position":"relative","width":"100%"},attrs:{"id":"video1","src":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/content%2F-LRgQ1KTLH7S6kRdFRZb.mp4?alt=media&token=6aaf2f3e-9f2d-4792-8ef5-5d00b6e677cd","poster":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/content%2F-LRgQ1KTLH7S6kRdFRZb.png?alt=media&token=710663f1-1683-4c0f-b08c-100560b081ea","width":"100%","controls":""}})]),_vm._v(" "),(false)?_c('v-carousel-item',{attrs:{"reverse-transition":"fade-transition","transition":"fade-transition"}},[_c('video',{staticStyle:{"margin-top":"10px","margin":"auto","position":"relative","width":"100%","background-color":"#dedede"},attrs:{"id":"video2","src":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FSlowbart.mp4?alt=media&token=bdf7fdfc-b036-47aa-8784-ddefa8cd4533","poster":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2Fslowbart.png?alt=media&token=2ef0e16b-0101-4234-8e02-e7ef6b52be7c","width":"100%","controls":"","autoplay":""}}),_vm._v(" "),_c('div',[_c('v-btn',{staticStyle:{"position":"absolute","top":"5px","left":"5px","font-size":"20px","color":"#807f7f","text-transform":"lowercase","cursor":"pointer"},attrs:{"flat":"","to":'slowbart'}},[_vm._v("     \n                slowbart program")])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.currentEventImages),function(img,i){return _c('v-carousel-item',{key:'img'+i},[_c('v-img',{staticStyle:{"margin-top":"10px","margin":"auto","position":"relative"},attrs:{"src":img.image,"height":"100%","width":"100%"},on:{"click":function($event){_vm.showBars=!_vm.showBars}}},[_c('div',{staticStyle:{"position":"absolute","top":"5px","left":"5px","font-size":"20px","color":"#fff!important","background-color":"#00000055"}},[_vm._v("  \n                  "+_vm._s(img.title)+"   \n               ")])])],1)}),_vm._v(" "),( _vm.currentEvent && _vm.currentEvent.image)?_c('v-carousel-item',[_c('v-img',{staticStyle:{"margin-top":"10px","margin":"auto","position":"relative"},attrs:{"src":_vm.currentEvent.image,"height":"100%","width":"100%"},on:{"click":function($event){_vm.showBars=!_vm.showBars}}},[_c('div',{staticStyle:{"position":"absolute","top":"5px","left":"5px","font-size":"20px","color":"#fff!important","background-color":"#00000055","padding":"0px 5px"}},[_vm._v("     \n                "+_vm._s(_vm.currentEvent.title))])])],1):_vm._e()],2),_vm._v(" "),_vm._l((_vm.currentEvents),function(ce,i){return _c('div',{key:'ce'+i,staticStyle:{"display":"flex","height":"150px","margin-top":"10px","position":"relative","background-color":"#eee"}},[_c('div',{staticStyle:{"margin-right":"10px"}},[_c('img',{staticStyle:{"position":"relative"},attrs:{"src":ce.thumbnail,"height":"100%"}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px"}},[_c('div',[_c('h3',[_vm._v(_vm._s(ce["Home-Heading"]))]),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(ce['Home-Details'])}})]),_vm._v(" "),(ce.link)?_c('h4',{staticStyle:{"bottom":"0px"}},[_c('a',{attrs:{"href":ce.link,"target":"blank"}},[_vm._v("More Info")])]):_c('h4',{staticStyle:{"bottom":"0px"}},[_c('a',{attrs:{"href":'/events?'+ce.title,"target":"blank"}},[_vm._v("More Info")])])])])})],2)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs8":"","offset-xs2":"","pt-4":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1),_vm._v(" "),(_vm.nowPlaying)?_c('div',[_c('v-layout',[(_vm.previewImages.length>0)?_c('v-flex',{attrs:{"xs3":"","mr-2":""}},[_c('div',{staticClass:"sub1"},[_vm._v("Now Playing")]),_vm._v(" "),_c('div',{staticStyle:{"height":"120px","overflow":"hidden"}},[(this.nowPlaying)?_c('v-img',{attrs:{"src":this.nowPlaying.imageUrl,"height":"180px","position":"center -10px"},on:{"click":function($event){_vm.showBars=!_vm.showBars},"mouseout":function($event){_vm.showBars=false}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(this.nowPlaying.title))])]):_vm._e(),_vm._v(" "),(_vm.previewImages.length>1)?_c('v-flex',{attrs:{"xs3":"","ml-2":""}},[_c('div',{staticClass:"sub1"},[_vm._v("Coming up")]),_vm._v(" "),_c('div',{staticStyle:{"height":"120px","overflow":"hidden"}},[(this.nowPlaying)?_c('v-img',{attrs:{"src":_vm.previewImages[1].imageUrl,"height":"180px","position":"center -10px"},on:{"click":function($event){_vm.showBars=!_vm.showBars},"mouseout":function($event){_vm.showBars=false}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.previewImages[1].title)+" ")])]):_vm._e(),_vm._v(" "),(_vm.previewImages.length>2)?_c('v-flex',{attrs:{"xs3":"","ml-2":""}},[_c('div',{staticClass:"sub1"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticStyle:{"height":"120px","overflow":"hidden"}},[(this.nowPlaying)?_c('v-img',{attrs:{"src":_vm.previewImages[2].imageUrl,"height":"180px","position":"center -10px"},on:{"click":function($event){_vm.showBars=!_vm.showBars},"mouseout":function($event){_vm.showBars=false}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.previewImages[2].title))])]):_vm._e(),_vm._v(" "),(_vm.previewImages.length>3)?_c('v-flex',{attrs:{"xs3":"","ml-2":""}},[_c('div',{staticClass:"sub1"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticStyle:{"height":"120px","overflow":"hidden"}},[_c('v-img',{attrs:{"src":_vm.previewImages[3].imageUrl,"height":"180px","position":"center -10px"},on:{"click":function($event){_vm.showBars=!_vm.showBars},"mouseout":function($event){_vm.showBars=false}}})],1),_vm._v(" "),_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.previewImages[3].title))])]):_vm._e()],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FGJs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FI9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{staticClass:"hidden-md-and-up",attrs:{"fixed":"","app":""},model:{value:(_vm.sideNav),callback:function ($$v) {_vm.sideNav=$$v},expression:"sideNav"}},[_c('v-list',[_c('v-list-tile',{attrs:{"to":'home'}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Home")])],1),_vm._v(" "),_vm._l((_vm.menuItems),function(item){return (_vm.isRequired(item.req))?_c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(item.title))])],1):_vm._e()}),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-list-tile',{on:{"click":_vm.onLogout}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"left":""}},[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Logout")])],1):_vm._e(),_vm._v(" "),(!_vm.userIsAuthenticated)?_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"left":""}},[_vm._v("login")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Login")])],1):_vm._e()],2)],1),_vm._v(" "),(_vm.showMenu && !_vm.isPlayZone)?_c('v-toolbar',{staticClass:"toolbar",attrs:{"light":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){_vm.sideNav = ! _vm.sideNav}}}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"titleBar"},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_c('img',{attrs:{"src":__webpack_require__("r1rV"),"width":"80px"}}),_vm._v(" \n        "),_c('div',{staticClass:"navTitle",attrs:{"to":'/'}},[_vm._v("\n          A Digital\n          "),_c('br'),_vm._v("Art Platform\n          "),_c('br'),_vm._v("for Hobart\n        ")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_vm._l((_vm.menuItems),function(item){return (_vm.isRequired(item.req))?_c('v-btn',{key:item.title,attrs:{"flat":"","to":item.link}},[(item.icon)?_c('v-icon',[_vm._v(" "+_vm._s(item.icon))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])],1):_vm._e()}),_vm._v(" "),(!_vm.userIsAuthenticated)?_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"flat":"","to":"/signin"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("login")]),_vm._v(" "),_c('span',[_vm._v("Login")])],1):_vm._e(),_vm._v(" "),_c('v-spacer')],2),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-md-and-up"},_vm._l((_vm.menuItems),function(item){return (_vm.isRequired(item.req))?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{key:item.title,attrs:{"slot":"activator","flat":"","to":item.link},slot:"activator"},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))]),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])],1):_vm._e()}))],1):_vm._e(),_vm._v(" "),_c('main',[_c('router-view',{ref:"home"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FRY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Controls_vue__ = __webpack_require__("Js1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e4bf059_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Controls_vue__ = __webpack_require__("g9Wq");
function injectStyle (ssrContext) {
  __webpack_require__("S3UG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Controls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e4bf059_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Controls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c56aafc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("rzuF");
function injectStyle (ssrContext) {
  __webpack_require__("gtIx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c56aafc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c56aafc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Content_ScheduleView_vue__ = __webpack_require__("IJh6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var vue;
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ScheduleView: __WEBPACK_IMPORTED_MODULE_0__Content_ScheduleView_vue__["a" /* default */] },
  data: function data() {
    return {
      cycle: true,
      cinterval: 1000,
      cModel: 1,
      video1: null,
      video2: null,
      window: {
        width: 0,
        height: 0
      },
      trackInfo: [],
      prelaunch: false,
      lastPlaylistId: null,
      hasPlaying: false,
      plistIds: [],
      scheduleDisplay: null,
      nowPlaying: null,
      currentSchedule: null,
      lastTrack: null,
      currentTrack: null,
      showBars: false,
      colours: [{ colour: '#231f20', height: 17, name: "dark", pad: 3, width: 100 }, { colour: '#ea148c', height: 17, name: "pink", pad: 3, width: 100 }, { colour: '#eb212e', height: 36, name: "red", pad: 3, width: 100 }, { colour: '#8ec549', height: 18, name: "green", pad: 3, width: 100 }, { colour: '#00afec', height: 10, name: "blue", pad: 3, width: 100 }, { colour: '#ea148c', height: 17, name: "pink", pad: 3, width: 100 }, { colour: '#eb212e', height: 36, name: "red", pad: 3, width: 100 }, { colour: '#ea148c', height: 18, name: "pink", pad: 3, width: 100 }, { colour: '#8ec549', height: 26, name: "green", pad: 3, width: 100 }, { colour: '#00afec', height: 10, name: "blue", pad: 3, width: 100 }],
      glitches: null,
      glitchCount: 20,
      glitchTop: 200,
      previewImages: []
    };
  },
  mounted: function mounted() {

    this.$store.dispatch("loadEventsStatus");
    //this.$store.dispatch('loadStatus');
    console.log("MOUNTED", this.status);
    vue = this;
    var self = this;
    this.date = new Date().toISOString().substr(0, 10);
    this.glitches = [];
    var childA = [];

    for (var i = 0; i < 6; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setInterval(this.glitchColour, 100);
    setTimeout(this.glitch, 150);
    this.video1 = document.getElementById('video1');
    if (this.video1) {
      this.video1.addEventListener('ended', myHandler, false);
      this.video1.addEventListener('playing', vidStart, false);
    }
    this.video2 = document.getElementById('video2');
    if (this.video2) {
      this.video2.addEventListener('playing', vidStart, false);
      this.video2.addEventListener('ended', myHandler, false);
    }
    //this.cycle=false
    function myHandler(e) {

      if (vue.video1.currentTime > 0) {
        vue.video1.load();
      }
      if (vue.video2 && vue.video2.currentTime > 0) {
        vue.video2.load();
      }
      vue.cycle = true;
    }
    function vidStart() {

      vue.cycle = false;
    }
    this.doStatus(this.status);
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  computed: {
    currentEventImages: function currentEventImages() {
      var images = [];
      for (var i in this.currentEvents) {
        if (this.currentEvents[i].image) {
          images.push({ image: this.currentEvents[i].image, title: this.currentEvents[i].title });
        }
      }
      return images;
    },
    currentEvent: function currentEvent() {
      return this.$store.getters.getCurrentEvent;
    },
    currentEvents: function currentEvents() {
      return this.$store.getters.getCurrentEvents;
    },
    vidHeight: function vidHeight() {
      return this.window.width / 12 * 8 * 9 / 16;
    },
    vidWidth: function vidWidth() {
      return this.window.width / 12 * 8;
    },
    randomPad: function randomPad() {
      return Math.floor(Math.random() * 5 + 1) + "px";
    },
    hasStatus: function hasStatus() {
      return this.$store.getters.getStatus != null;
    },
    status: function status() {

      return this.$store.getters.getStatus;
    },
    tracks: function tracks() {

      return this.$store.getters.getTracks;
    },
    trackIndex: function trackIndex() {
      if (status) {
        return status.active;
      } else {
        return null;
      }
    },
    schedules: function schedules() {

      return this.$store.getters.loadedSchedules;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },

  watch: {
    status: function (_status) {
      function status(_x) {
        return _status.apply(this, arguments);
      }

      status.toString = function () {
        return _status.toString();
      };

      return status;
    }(function (status) {
      this.doStatus(status);
    }),
    cModel: function cModel() {
      console.log(this.cModel);
      this.cinterval = 5000;
      if (this.cModel == 0) {
        if (this.video2) {
          this.video2.pause();
        }
        if (this.video1.currentTime > 0) {
          this.video1.load();
        }
      }
      if (this.cModel == 1) {
        this.video1.pause();
        if (this.video2 && this.video2.currentTime > 0) {
          this.video2.load();
        } else if (this.video2) {
          this.video2.play();
        }
      }
    }
  },
  methods: {
    goto: function goto(link) {
      this.$router.push(link);
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
    },
    glitch: function glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);
        return;
      }
      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    },
    glitchColour: function glitchColour() {
      for (var i in this.colours) {
        if (Math.random() * 10 > 7) {
          this.colours[i].height = Math.random() * 20 + 5;
        }
        this.colours[i].pad = Math.floor(Math.random() * 5 + 1);
        if (Math.random() * 10 > 9 && i > 0) {
          this.colours[i].width = 100 - Math.floor(Math.random() * 20);
        } else {
          this.colours[i].width = 100;
        }
      }
    },
    getItem: function getItem(index) {
      console.log(this.currentSchedule.items[index]);
      if (this.currentSchedule.items[index] && this.currentSchedule.items[index].title != "The Loop") {
        return this.getContent(this.currentSchedule.items[index].id);
      } else {
        return null;
      }
    },
    allowedDates: function allowedDates(val) {
      parseInt(val.split('-')[2], 10) % 2 === 0;
    },
    playlistInfo: function playlistInfo(playlist) {
      this.plistIds.push(playlist.id);
      if (this.plistIds.length > 1 && this.plistIds[this.plistIds.length - 1] == this.plistIds[this.plistIds.length - 2]) {
        //this.lastPlaylistId=playlist.id;
        return null;
      } else {
        return "[ " + playlist.name + " ]";
      }
    },
    showSchedule: function showSchedule(id) {
      console.log("SHOW", id);
    },
    getContent: function getContent(id) {
      //console.log("GET CONTENT",id)
      // console.log(this.$store.getters.loadedContent(id));
      return this.$store.getters.loadedContent(id);
    },
    getPlaylist: function getPlaylist(id) {

      return this.$store.getters.loadedPlaylist(id);
    },
    secondsToDuration: function secondsToDuration(sec) {
      var hrs = Math.floor(sec / (60 * 60));
      var mins = Math.floor((sec - hrs * 60 * 60) / 60);
      var secs = Math.floor(sec % 60);
      if (hrs < 10) {
        hrs = "0" + hrs;
      }
      if (mins < 10) {
        mins = "0" + mins;
      }
      if (secs < 10) {
        secs = "0" + secs;
      }
      return hrs + ":" + mins + ":" + secs;
    },
    doStatus: function doStatus(status) {
      if (!status) {
        return;
      }
      //console.log("Watch status",this.currentTrack,status);

      this.currentTrack = status.active - 2;
      if (this.currentTrack != this.lastTrack) {
        console.log("GET SCHEDULE", status.schedule);
        this.currentSchedule = this.$store.getters.loadedSchedule(status.schedule);
        this.lastTrack = this.currentTrack;
        var key = this.tracks.tracks[this.currentTrack - 1].split('.')[0];
        console.log("KEY", key, this.$store.getters.loadedContent(key));
        if (key.substr(0, 1) == "-") {
          this.nowPlaying = this.$store.getters.loadedContent(key);
        } else {
          if (this.currentSchedule.items.length > 0 && key != "Colour") {
            this.nowPlaying = this.getContent(this.currentSchedule.items[this.currentTrack].id);
          }
        }
        console.log("this.nowPlaying", this.nowPlaying);
        //
        var item;
        var index = this.currentTrack;
        var found = 0;
        //console.log("STATUS index",index,this.currentSchedule.items.length)
        this.previewImages = [];
        while (index < this.currentSchedule.items.length && found < 4) {

          item = this.getItem(index);
          console.log("XXXX", index, item);
          if (item) {
            console.log("XXXX", item, item.imageUrl);
          }

          if (item && item.imageUrl && item.title != "The Loop logo") {

            found++;
            this.previewImages.push(item);
          }
          index++;
        }
      }
    }
  }
});

/***/ }),

/***/ "G/M5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submissions_vue__ = __webpack_require__("CzIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79510ba6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Submissions_vue__ = __webpack_require__("O+HL");
function injectStyle (ssrContext) {
  __webpack_require__("KFUk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79510ba6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79510ba6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Submissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GjgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");




var _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    newContent: null,
    loadedContents: []
  },
  mutations: {
    setLoadedContents: function setLoadedContents(state, payload) {
      state.loadedContents = payload;
    },
    createContent: function createContent(state, payload) {
      state.newContent = payload;
      state.loadedContents.push(payload);
    },
    approveContent: function approveContent(state, payload) {
      state.loadedContents.push(payload);
      var content = state.loadedContents.find(function (content) {
        return content.id === payload.id;
      });
      if (payload.approved != null) {
        content.approved = payload.approved;
      }
    },
    updateContent: function updateContent(state, payload) {
      console.log("updateContent", payload.scaleMode);
      var content = state.loadedContents.find(function (content) {
        return content.id === payload.id;
      });
      if (payload.title) {
        content.title = payload.title;
      }
      if (payload.description) {
        content.description = payload.description;
      }
      if (payload.date) {
        content.date = payload.date;
      }
      if (payload.addTitle) {
        content.showTitle = payload.addTitle;
      }
      if (payload.subtitle) {
        content.subtitle = payload.subtitle;
      }
      if (payload.footer) {
        content.footer = payload.footer;
      }
      if (payload.keywords) {
        content.keywords = payload.keywords;
      }
      if (payload.scaleMode) {
        content.scaleMode = payload.scaleMode;
      }
      if (payload.videoSize) {
        content.videoSize = payload.videoSize;
      }
      if (payload.hideS) {
        content.hideS = payload.hideS;
      }
      if (payload.approved != null) {
        content.approved = payload.approved;
      }
      if (payload.rating) {
        content.rating = payload.rating;
      }
      if (payload.mode) {
        content.mode = payload.mode;
      }
      if (payload.status) {
        content.status = payload.status;
      }
      state.newContent = content;
    }
  },
  actions: (_actions = {
    loadContents: function loadContents(_ref) {
      var commit = _ref.commit;

      console.log("YYY LOAD CONTENT");
      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').once('value').then(function (data) {
        var contents = [];
        var obj = data.val();
        for (var key in obj) {
          contents.push({
            id: key,
            title: obj[key].title,
            subtitle: obj[key].subtitle || null,
            body: obj[key].body || null,
            hideS: obj[key].hideS || null,
            footer: obj[key].footer || null,
            description: obj[key].description,
            approved: obj[key].approved,
            rating: obj[key].rating,
            looping: obj[key].looping,
            duration: obj[key].duration,
            artist: obj[key].author,
            videoUrl: obj[key].videoUrl,
            videoSize: obj[key].videoSize || null,
            imageUrl: obj[key].imageUrl,
            web: obj[key].web,
            date: obj[key].date,
            type: obj[key].type,
            creatorId: obj[key].creatorId,
            keywords: obj[key].keywords || null,
            addTitle: obj[key].addTitle || null,
            scaleMode: obj[key].scaleMode || null,
            mode: obj[key].mode || null,
            status: obj[key].status || 'none'
          });
        }
        commit('setLoading', false);
        commit('setLoadedContents', contents);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    createContent: function createContent(_ref2, payload) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          getters = _ref2.getters;

      var store = this;

      var content = {
        title: payload.title,
        author: payload.author,
        image: payload.image,
        video: payload.video,
        videoSize: payload.videoSize || null,
        web: payload.web || null,
        type: payload.type,
        subtitle: payload.subtitle || null,
        body: payload.body || null,
        hideS: payload.hideS || null,
        footer: payload.footer || null,
        description: payload.description || "",
        duration: payload.duration,
        date: payload.date.toISOString(),
        keywords: payload.keywords || null,
        addTitle: payload.addTitle || null,
        scaleMode: payload.scaleMode || null,
        creatorId: getters.user.id,
        mode: payload.mode || null,
        status: payload.status || "none"
      };
      var imageUrl = void 0;
      var videoUrl = void 0;
      var contentURL = [];
      var key = void 0;
      var uploads = void 0;
      var type = payload.type;
      var images = [];
      if (type != "title") {
        images.push(payload.image);
      }
      if (type == "video") {
        images.push(payload.video);
      }
      //console.log("UPLOADS", type, images);
      // Reach out to firebase and store it
      __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').push(content).then(function (data) {
        console.log(data);
        key = data.key;
        return key;
      }).then(function (key) {
        console.log("UPLOADS", images.length);
        if (images.length > 0) {
          commit('setUpLoading', true);
          var bytes = {};
          var totalBytes = 0;
          var uploadedBytes = 0;
          uploads = images.map(function (uploadedImage) {
            console.log(uploadedImage);
            bytes[uploadedImage.size] = 0;
            console.log(bytes);
            totalBytes += uploadedImage.size;
            var filename = uploadedImage.name;
            var ext = filename.slice(filename.lastIndexOf('.'));
            var uploadTask = __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"]().ref('content/' + key + ext).put(uploadedImage);

            // you probably don't need this part
            // since 'progress' is not used anywhere
            uploadTask.on('state_changed', function (snapshot) {
              bytes[snapshot.totalBytes] = snapshot.bytesTransferred;
              uploadedBytes = 0;
              for (var b in bytes) {
                uploadedBytes += bytes[b];
              }
              var progress = uploadedBytes / totalBytes * 100;
              //var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              console.log(progress + " of " + snapshot.totalBytes, snapshot);
              commit('setProgress', progress);
            });

            return uploadTask.then(function (snapshot) {
              console.log("URL", snapshot.downloadURL);
              contentURL.push(snapshot.downloadURL);
            });
          });

          // wait for all uploadTasks to be done
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(uploads).then(function () {
            //this.createListing()
            console.log("all uploaded", contentURL, key);
            dispatch('assignContentToUser', key);
            commit('setUpLoading', false);
            return contentURL;
          }).then(function (fileData) {
            console.log("videoUrl fileData", fileData);
            //TODO check 0 is image and 1 is video.
            imageUrl = fileData[0];
            videoUrl = null;
            if (type == "video") {
              videoUrl = fileData[1];
            }
            return __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').child(key).update({ imageUrl: imageUrl, videoUrl: videoUrl });
          }).then(function () {
            commit('createContent', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, content, {
              imageUrl: imageUrl,
              videoUrl: videoUrl,
              id: key
            }));
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log("UPLOAD", key);
          commit('createContent', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, content, {
            imageUrl: null,
            videoUrl: null,
            id: key
          }));
        }
      });
    },
    replaceImage: function replaceImage(_ref3, payload) {
      var commit = _ref3.commit;

      console.log("replaceImage", payload);
      commit('setLoading', true);
      var filename = payload.image.name;
      var ext = filename.slice(filename.lastIndexOf('.'));
      var uploadTask = __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"]().ref('content/' + payload.id + ext).put(payload.image);

      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"].TaskState.PAUSED:
            // or 'paused'
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"].TaskState.RUNNING:
            // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {

          console.log('File available at', downloadURL);
          //commit('updateContent', { imageUrl: downloadURL })
          var updateObj = { imageUrl: downloadURL, status: 'image updated' };
          commit('setLoading', false);

          __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').child(payload.id).update(updateObj).then(function () {

            commit('updateContent', payload);
          }).catch(function (error) {
            commit('setLoading', false);
            console.log(error);
          });
        });
      });
    },
    replaceVideo: function replaceVideo(_ref4, payload) {
      var commit = _ref4.commit;

      console.log("replaceVideo", payload);
      commit('setLoading', true);
      var filename = payload.video.name;
      var ext = filename.slice(filename.lastIndexOf('.'));
      var uploadTask = __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"]().ref('content/' + payload.id + ext).put(payload.video);

      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"].TaskState.PAUSED:
            // or 'paused'
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"].TaskState.RUNNING:
            // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {

          console.log('File available at', downloadURL);
          //commit('updateContent', { imageUrl: downloadURL })
          var updateObj = { videoUrl: downloadURL, status: 'video uploaded' };
          commit('setLoading', false);

          __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').child(payload.id).update(updateObj).then(function () {

            commit('updateContent', payload);
          }).catch(function (error) {
            commit('setLoading', false);
            console.log(error);
          });
        });
      });
    },
    createContentInfo: function createContentInfo(_ref5, payload) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          getters = _ref5.getters;

      var store = this;

      var content = {
        title: payload.title,
        author: payload.author,
        image: payload.image,
        video: payload.video,
        videoSize: payload.videoSize || null,
        web: payload.web || null,
        type: payload.type,
        subtitle: payload.subtitle || null,
        body: payload.body || null,
        hideS: payload.hideS || null,
        footer: payload.footer || null,
        description: payload.description || "",
        duration: payload.duration,
        date: payload.date.toISOString(),
        keywords: payload.keywords || null,
        addTitle: payload.addTitle || null,
        scaleMode: payload.scaleMode || null,
        creatorId: getters.user.id,
        mode: payload.mode || null,
        status: payload.status || "none"
      };
      var imageUrl = void 0;
      var videoUrl = void 0;
      var contentURL = [];
      var key = void 0;
      var uploads = void 0;
      var type = payload.type;
      var images = [];
      if (type == "web") {
        images.push(payload.image);
      }
      console.log("UPLOADS", type, images);
      // Reach out to firebase and store it
      __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').push(content).then(function (data) {
        console.log(data);
        key = data.key;
        return key;
      }).then(function (key) {
        console.log("UPLOADS", images.length);
        if (images.length > 0) {
          commit('setUpLoading', true);
          var bytes = {};
          var totalBytes = 0;
          var uploadedBytes = 0;
          uploads = images.map(function (uploadedImage) {
            console.log(uploadedImage);
            bytes[uploadedImage.size] = 0;
            console.log(bytes);
            totalBytes += uploadedImage.size;
            var filename = uploadedImage.name;
            var ext = filename.slice(filename.lastIndexOf('.'));
            var uploadTask = __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"]().ref('content/' + key + ext).put(uploadedImage);

            uploadTask.on('state_changed', function (snapshot) {
              bytes[snapshot.totalBytes] = snapshot.bytesTransferred;
              uploadedBytes = 0;
              for (var b in bytes) {
                uploadedBytes += bytes[b];
              }
              var progress = uploadedBytes / totalBytes * 100;
              commit('setProgress', progress);
            });

            return uploadTask.then(function (snapshot) {
              console.log("URL", snapshot.downloadURL);
              contentURL.push(snapshot.downloadURL);
            });
          });

          // wait for all uploadTasks to be done
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(uploads).then(function () {
            //this.createListing()
            console.log("all uploaded", contentURL, key);
            dispatch('assignContentToUser', key);
            commit('setUpLoading', false);
            return contentURL;
          }).then(function (fileData) {
            console.log("videoUrl fileData", fileData);
            //TODO check 0 is image and 1 is video.
            imageUrl = fileData[0];
            videoUrl = null;
            if (type == "video") {
              videoUrl = fileData[1];
            }
            return __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').child(key).update({ imageUrl: imageUrl, videoUrl: videoUrl });
          }).then(function () {
            commit('createContent', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, content, {
              imageUrl: imageUrl,
              videoUrl: videoUrl,
              id: key
            }));
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          console.log("UPLOAD", key);
          commit('createContent', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, content, {
            imageUrl: null,
            videoUrl: null,
            id: key
          }));
        }
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'replaceImage', function replaceImage(_ref6, payload) {
    var commit = _ref6.commit;

    console.log("replaceImage", payload);
    commit('setLoading', true);
    var filename = payload.image.name;
    var ext = filename.slice(filename.lastIndexOf('.'));
    var uploadTask = __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"]().ref('content/' + payload.id + ext).put(payload.image);

    uploadTask.on('state_changed', function (snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      console.log('Upload is ' + progress + '% done');
      switch (snapshot.state) {
        case __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"].TaskState.PAUSED:
          // or 'paused'
          console.log('Upload is paused');
          break;
        case __WEBPACK_IMPORTED_MODULE_3_firebase__["storage"].TaskState.RUNNING:
          // or 'running'
          console.log('Upload is running');
          break;
      }
    }, function (error) {
      // Handle unsuccessful uploads
    }, function () {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {

        console.log('File available at', downloadURL);
        //commit('updateContent', { imageUrl: downloadURL })
        var updateObj = { imageUrl: downloadURL, status: 'image updated' };
        commit('setLoading', false);

        __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').child(payload.id).update(updateObj).then(function () {

          commit('updateContent', payload);
        }).catch(function (error) {
          commit('setLoading', false);
          console.log(error);
        });
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'updateContentData', function updateContentData(_ref7, payload) {
    var commit = _ref7.commit;

    console.log("updateContentData", payload);
    commit('setLoading', true);
    var updateObj = {};
    if (payload.title) {
      updateObj.title = payload.title;
    }
    if (payload.description) {
      updateObj.description = payload.description;
    }
    if (payload.author) {
      updateObj.author = payload.author;
    }
    if (payload.artist) {
      updateObj.author = payload.artist;
    }
    if (payload.duration) {
      updateObj.duration = payload.duration;
    }
    if (payload.date) {
      updateObj.date = payload.date;
    }
    if (payload.approved != null) {
      updateObj.approved = payload.approved;
    }
    if (payload.rating) {
      updateObj.rating = payload.rating;
    }
    if (payload.keywords) {
      updateObj.keywords = payload.keywords;
    }
    if (payload.subtitle) {
      updateObj.subtitle = payload.subtitle;
    }
    if (payload.scaleMode) {
      updateObj.scaleMode = payload.scaleMode;
    }
    if (payload.footer) {
      updateObj.footer = payload.footer;
    }
    if (payload.status) {
      updateObj.status = payload.status;
    }
    __WEBPACK_IMPORTED_MODULE_3_firebase__["database"]().ref('content').child(payload.id).update(updateObj).then(function () {
      commit('setLoading', false);
      commit('updateContent', payload);
    }).catch(function (error) {
      commit('setLoading', false);
      console.log(error);
    });
  }), _actions),
  getters: {
    newContent: function newContent(state) {
      return state.newContent;
    },
    loadedContents: function loadedContents(state) {
      return state.loadedContents.sort(function (contentA, contentB) {
        var d1 = new Date(contentA.date);
        var d2 = new Date(contentB.date);
        return d2.getTime() - d1.getTime();
      });
    },
    featuredContents: function featuredContents(state, getters) {
      return getters.loadedContents.slice(0, 5);
    },
    loadedContent: function loadedContent(state) {

      return function (contentId) {
        return state.loadedContents.find(function (content) {
          return content.id === contentId;
        });
      };
    }
  }
});

/***/ }),

/***/ "HGSV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HLeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    status: null
  },
  mutations: {
    setStatus: function setStatus(state, payload) {

      state.status = payload;
    }
  },
  actions: {
    loadStatus: function loadStatus(_ref) {
      var commit = _ref.commit;


      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('status').on('value', function (snapshot) {

        commit('setStatus', snapshot.val());
      });
    }
  },
  getters: {
    getStatus: function getStatus(state) {

      return state.status;
    }
  }
});

/***/ }),

/***/ "HqMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onCreateContent($event)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","pr-3":""}},[(_vm.mode=='video')?_c('div',{attrs:{"id":"videoHolder"}},[_c('div',{staticStyle:{"margin-left":"15px","font-size":"16px"}},[_c('h2',[_vm._v("Video")]),_vm._v(" "),_c('p',[_vm._v("Video content must be an h264 encoded MP4.\n            We cannot accept links to youtube, vimeo etc.")]),_vm._v(" "),_c('p',[_vm._v("The screen resolution is 960x576px. \n           All content will be resized to fit the screen. \n           "),_c('br'),_vm._v("In default mode standard 16x9 content will lose 32 pixels from each side."),_c('br'),_vm._v(" "),_c('br'),_vm._v("Once your video has been uploaded you will be able to preview your video and choose how it will fit on the screen.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Looping videos:-")]),_vm._v(" If you video is designed to be a continuous loop please check the looping icon")]),_vm._v(" "),_c('p',[_vm._v("All details must be submitted before your video can be uploaded.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.videoUrl && false),expression:"!videoUrl && false"}],staticClass:"aspect"},[_c('h2',[_vm._v(_vm._s(_vm.videoText))])]),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.enableVideoUpload)?_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickVideo}},[_vm._v("Select Video")]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.videoUrl ),expression:"!videoUrl "}],staticStyle:{"font-size":"16px"}},[_c('b',[_vm._v(_vm._s(_vm.videoDetails))])]),_vm._v(" "),(_vm.videoDetails)?_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.addVideo}},[_vm._v("Upload Video")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mode=='web')?_c('div',{attrs:{"id":"webHolder"}},[(!_vm.webURL)?_c('h5',{staticClass:"primary--text"},[_vm._v("Submit URL")]):_vm._e(),_vm._v(" "),(_vm.webURL)?_c('vue-friendly-iframe',{attrs:{"src":_vm.webURL,"id":"webFrame"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"URL","label":"URL","id":"description"},model:{value:(_vm.webURLInput),callback:function ($$v) {_vm.webURLInput=$$v},expression:"webURLInput"}}),_vm._v(" "),(false)?_c('img',{staticClass:"ledOverlay",attrs:{"src":require("../../assets/images/screenOverlay.png"),"width":"100%"}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickUrl}},[_vm._v("Select URL")]),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),(_vm.mode=='title')?_c('div',[_c('h5',{staticClass:"primary--text"},[_vm._v("Title Card")]),_vm._v(" "),_c('div',{attrs:{"id":"cardHolder"}},[_c('div',{staticClass:"cTitle"},[_vm._v(_vm._s(_vm.contentInfo.title))]),_vm._v(" "),_c('div',{staticClass:"cSubtitle"},[_vm._v(_vm._s(_vm.contentInfo.subtitle))]),_vm._v(" "),_c('div',{staticClass:"cBody"},[_vm._v(_vm._s(_vm.contentInfo.body))]),_vm._v(" "),_c('div',{staticClass:"cFooter"},[_vm._v(_vm._s(_vm.contentInfo.footer))])]),_vm._v(" "),_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.contentInfo.title),callback:function ($$v) {_vm.$set(_vm.contentInfo, "title", $$v)},expression:"contentInfo.title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"subtitle","label":"Subtitle","id":"subtitle"},model:{value:(_vm.contentInfo.subtitle),callback:function ($$v) {_vm.$set(_vm.contentInfo, "subtitle", $$v)},expression:"contentInfo.subtitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"body","label":"Body","id":"body"},model:{value:(_vm.contentInfo.body),callback:function ($$v) {_vm.$set(_vm.contentInfo, "body", $$v)},expression:"contentInfo.body"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"footer","label":"Footer","id":"footer"},model:{value:(_vm.contentInfo.footer),callback:function ($$v) {_vm.$set(_vm.contentInfo, "footer", $$v)},expression:"contentInfo.footer"}}),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),(_vm.mode=='message')?_c('div',[_c('h2',[_vm._v("Participate")]),_vm._v(" "),_c('p',[_vm._v("The Loop takes submissions for content throughout the year. It’s open to artists, curators, and community-members and organisations who work with creative screen-based media."),_c('br'),_vm._v("The Loop does not accept advertising or promotional material."),_c('br'),_vm._v("To submit content for consideration, upload a file here.")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('video')}}},[_vm._v("Submit Video")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('web')}}},[_vm._v("Submit Web Content")]),_vm._v(" "),(_vm.isCurator)?_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('title')}}},[_vm._v("Create Title Card")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mode!='message')?_c('v-container',{attrs:{"pl-3":"","pr-1":""}},[_c('v-layout',{attrs:{"fluid":""}},[(_vm.uploading())?_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-linear',{model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"text-xs-right":""}},[_c('v-flex',{attrs:{"xs1":"","text-xs-left":""}},[(_vm.uploading())?_c('span',[_vm._v(_vm._s(_vm.progressText))]):_vm._e()])],1)],1):_vm._e()],1),_vm._v(" "),(_vm.mode!='title' && _vm.mode!='message')?_c('v-flex',{attrs:{"xs12":"","sm3":""}},[(_vm.mode!='title'  && false)?_c('div',{attrs:{"id":"imageHolder"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.imageUrl),expression:"!imageUrl"}],staticClass:"aspect"},[_c('h5',[_vm._v("Poster Image")])]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageUrl),expression:"imageUrl"}],attrs:{"src":_vm.imageUrl,"width":"100%"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":"","disabled":_vm.uploading()},on:{"click":_vm.onPickFile}},[_vm._v("Select Image")])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.contentInfo.title),callback:function ($$v) {_vm.$set(_vm.contentInfo, "title", $$v)},expression:"contentInfo.title"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"author","label":"Artist","id":"author","rules":_vm.notEmpty,"required":""},model:{value:(_vm.contentInfo.author),callback:function ($$v) {_vm.$set(_vm.contentInfo, "author", $$v)},expression:"contentInfo.author"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"name":"description","label":"Description","id":"description","required":""},model:{value:(_vm.contentInfo.description),callback:function ($$v) {_vm.$set(_vm.contentInfo, "description", $$v)},expression:"contentInfo.description"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.keywords,"label":"Keywords - select from list or add your own.","multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(_vm.contentInfo.keywords),callback:function ($$v) {_vm.$set(_vm.contentInfo, "keywords", $$v)},expression:"contentInfo.keywords"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Add title to start of content"},model:{value:(_vm.contentInfo.addTitle),callback:function ($$v) {_vm.$set(_vm.contentInfo, "addTitle", $$v)},expression:"contentInfo.addTitle"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"disabled":!_vm.formIsValid || _vm.uploading(),"type":"submit"}},[_vm._v("Create Entry")]),_vm._v(" "),(false)?_c('app-view-content-details-dialog',{attrs:{"videoUrl":_vm.videoUrl,"imageUrl":_vm.imageUrl,"content":_vm.contentInfo}}):_vm._e()],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}}),_vm._v(" "),_c('input',{ref:"videoInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"video/mp4"},on:{"change":_vm.onVideoPicked}})])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I77Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contents_vue__ = __webpack_require__("ShEE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1147d121_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contents_vue__ = __webpack_require__("xijl");
function injectStyle (ssrContext) {
  __webpack_require__("JiVM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1147d121"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1147d121_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IJ20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    uploading: false,
    error: null,
    progress: 0
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setUpLoading: function setUpLoading(state, payload) {
      state.uploading = payload;
    },
    setProgress: function setProgress(state, payload) {
      state.progress = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    uploading: function uploading(state) {
      return state.uploading;
    },
    progress: function progress(state) {
      return state.progress;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),

/***/ "IJh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleView_vue__ = __webpack_require__("IwSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f0d93a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleView_vue__ = __webpack_require__("2O9n");
function injectStyle (ssrContext) {
  __webpack_require__("HGSV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f0d93a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content__ = __webpack_require__("GjgE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__playlist__ = __webpack_require__("Wz7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schedule__ = __webpack_require__("QMNH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control__ = __webpack_require__("Jrtv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user__ = __webpack_require__("6EED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__share__ = __webpack_require__("IJ20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__status__ = __webpack_require__("HLeH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracks__ = __webpack_require__("Cedj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__play__ = __webpack_require__("WuVR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__website__ = __webpack_require__("25Jp");













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_6__user__["a" /* default */],
    content: __WEBPACK_IMPORTED_MODULE_2__content__["a" /* default */],
    controls: __WEBPACK_IMPORTED_MODULE_5__control__["a" /* default */],
    playlist: __WEBPACK_IMPORTED_MODULE_3__playlist__["a" /* default */],
    schedule: __WEBPACK_IMPORTED_MODULE_4__schedule__["a" /* default */],
    share: __WEBPACK_IMPORTED_MODULE_7__share__["a" /* default */],
    status: __WEBPACK_IMPORTED_MODULE_8__status__["a" /* default */],
    tracks: __WEBPACK_IMPORTED_MODULE_9__tracks__["a" /* default */],
    play: __WEBPACK_IMPORTED_MODULE_10__play__["a" /* default */],
    website: __WEBPACK_IMPORTED_MODULE_11__website__["a" /* default */]
  }
});

/***/ }),

/***/ "IwSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["schedule"],
  data: function data() {
    return {
      items: [],
      playlists: {},
      expandSub: [],
      expandMain: false
    };
  },

  watch: {
    schedule: function schedule(value) {
      console.log("XXXXX Watch", this.schedule);
      this.fillSchedule();
    },
    expandPlaylist: function expandPlaylist(value) {
      if (value) {
        this.expandMain = [true];
      } else {
        this.expandMain = false;
      }
    }
  },
  mounted: function mounted() {
    console.log("XXXXX Mounted View", this.schedule);
    if (this.schedule) {
      this.fillSchedule();
      if (this.schedule.expandPlaylist) {
        this.expandMain = [true];
      } else {
        this.expandMain = false;
      }
    }
    this.$store.dispatch("loadMenuItems");
  },
  computed: {
    expandPlaylist: function expandPlaylist() {
      console.log("expandPlaylist WATCHER");
      if (this.schedule) {
        return this.schedule.expandPlaylist;
      } else {
        return false;
      }
    }
  },
  methods: {
    getArtist: function getArtist(id) {
      var cont = this.getContent(id);
      if (!cont) {
        return null;
      }
      return "- " + cont.artist;
    },
    getIcon: function getIcon(type) {
      var icon = null;
      switch (type) {
        case "video":
          icon = "ondemand_video";
          break;
        case "title":
          icon = "title";
          break;
        case "playlist":
          icon = "list";
          break;
        case "web":
          icon = "web_asset";
          break;
      }
      return icon;
    },
    fillSchedule: function fillSchedule() {
      console.log("FILL Schedule");
      var id;
      var pIndex;
      var time = this.clockToSec(this.schedule.startTime);
      var playlist;
      console.log("this.schedule", this.schedule);
      var item;
      for (var i in this.schedule.items) {
        item = this.schedule.items[i];
        console.log("item", item);
        if (item.pListId) {
          console.log("NEW PLAYLIST", item.pListIndex);
          id = item.pListId;
          pIndex = id;
          console.log("a playlist starting at ", item, time);
          item.time = time;

          console.log("Playlist", id, pIndex, item);
          if (this.playlists[pIndex]) {
            console.log("------", item);
            this.playlists[pIndex].items.push(item);
          } else {
            this.playlists[pIndex] = {
              items: [item],
              ppIndex: item.pListIndex
            };
            playlist = this.$store.getters.loadedPlaylist(id);
            console.log("Playlist  ", playlist, id);
            playlist.time = time;
            //for(var p in playlist.items){
            // console.log("XXXXX",playlist.items)
            //playlist.items[p].duration=playlist.items[p].duration
            //playlist.items[p].duration=this.getContent(playlist.items[p].id).duration*playlist.items[p].loops;
            //time+=playlist.items[p].duration

            //playlist.items[p].time=time
            //}
            this.items.push(playlist);
          }
          //time=time+this.getContent(item.id).duration*item.loops;
          time = time + item.duration * item.loops;
        } else {
          item.time = time;
          this.items.push(item);
          console.log("XXXXX", item);
          time += item.duration * item.loops;
          console.log("XXXXX Time", time);
        }
      }
      console.log("******", this.playlists);
      console.log("******---", this.items);
    },
    getContent: function getContent(id) {
      return this.$store.getters.loadedContent(id);
    },
    secToTime: function secToTime(sec) {
      var secs = sec % 60;
      var mins = (sec - secs) / 60 % 60;
      var hrs = (sec - mins * 60 - secs) / 60 / 60;
      secs = Math.round(secs);
      if (secs < 10) secs = "0" + secs;
      if (mins < 10) mins = "0" + mins;
      return hrs + ":" + mins + ":" + secs;
    },
    timeToSec: function timeToSec(time) {
      var times = time.split(":");
      var secs = parseInt(times[2], 10);
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60 + secs;
    },
    clockToSec: function clockToSec(time) {
      var times = time.split(":");
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60;
    },
    secToClock: function secToClock(sec) {
      if (this.schedule.hideTime) {
        return;
      }
      var secs = sec % 60;
      var mins = (sec - secs) / 60 % 60;
      var hrs = (sec - mins * 60 - secs) / 60 / 60;
      if (this.isWeekend()) {
        hrs += 2;
      }
      secs = Math.round(secs);
      if (secs < 10) secs = "0" + secs;
      if (mins < 10) mins = "0" + mins;
      return hrs + ":" + mins;
      //return hrs+":"+mins+":"+secs
    },
    isWeekend: function isWeekend() {
      var day = new Date().getDay();
      return day == 6 || day == 0;
    },
    secondsToDurationText: function secondsToDurationText(sec) {
      var hrs = Math.floor(sec / (60 * 60));
      var mins = Math.floor((sec - hrs * 60 * 60) / 60);
      var secs = Math.floor(sec % 60);
      var time = "";
      if (hrs > 0) {
        time = hrs + "hour" + this.plural(hrs) + " ";
      }
      if (mins > 0) {
        time = time + mins + "min" + this.plural(mins) + " ";
      }
      if (secs > 0) {
        time = time + secs + "sec" + this.plural(secs) + " ";
      }
      return time;
    },
    plural: function plural(val) {
      if (val != 1) {
        return "s";
      } else {
        return "";
      }
    }
  }
});

/***/ }),

/***/ "JiVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jrtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    controls: null
  },
  mutations: {
    setControls: function setControls(state, payload) {
      state.controls = payload;
    },
    setControlsP: function setControlsP(state, payload) {
      state.controls.play = payload;
    },
    setControlsPreview: function setControlsPreview(state, payload) {
      state.controls.preview = payload;
    },
    setControlsGenerate: function setControlsGenerate(state, payload) {
      //state.controls.generate = payload
    },
    setControlsOpen: function setControlsOpen(state, payload) {
      state.controls.open = payload;
    }
  },
  actions: {
    loadControls: function loadControls(_ref) {
      var commit = _ref.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('control').on('value', function (snapshot) {

        commit('setControls', snapshot.val());
      });
    },
    setControlsPlay: function setControlsPlay(_ref2, payload) {
      var commit = _ref2.commit;

      var value = parseInt(payload.index, 10) || 1;
      if (!isNaN(this.getters.getControlsPlay)) {
        //value = this.getters.getControlsPlay + 1;
      }
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('control').update({ play: value }).then(function () {

        commit('setControlsP', value);
      });
    },
    setControlsGenerate: function setControlsGenerate(_ref3, payload) {
      var commit = _ref3.commit;


      console.log("Generating", payload);
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('command').update({ command: 'generate', generate: payload }).then(function () {
        console.log("Generating", payload);
        commit('setControlsGenerate', payload);
      });
    },
    setControlsOpen: function setControlsOpen(_ref4, payload) {
      var commit = _ref4.commit;


      console.log("Opening", payload);
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('command').update({ command: 'open', open: payload.id }).then(function () {

        commit('setControlsOpen', payload.id);
        __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('status').update({ 'schedule': payload.id, starttime: payload.startTime }).then(function () {});
      });
    },
    setControlsVolume: function setControlsVolume(_ref5, payload) {
      var commit = _ref5.commit;


      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('command').update({ command: 'volume', volume: payload }).then(function () {});
    },
    setControlsPreview: function setControlsPreview(_ref6, payload) {
      var commit = _ref6.commit;

      var value = parseInt(payload.index, 10) || 1;
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('control').update({ preview: value }).then(function () {
        console.log("Updated", value, payload);
        commit('setControlsPreview', value);
      });
    },
    sendCommand: function sendCommand(_ref7, payload) {
      var commit = _ref7.commit;

      var duration = 1000;
      if (payload.paramname == "duration") {
        duration = parseInt(payload.param, 10);
      }
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('command').set({ command: payload.cmd, duration: duration, id: Math.floor(Math.random() * 100000) }).then(function () {
        console.log("Command Sent");
        //commit('setControlsP', value)
      });
    },
    sendMessage: function sendMessage(_ref8, payload) {
      var commit = _ref8.commit;


      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('message').set({ heading: payload.heading, description: payload.description, id: Math.floor(Math.random() * 100000) }).then(function () {
        console.log("Message Sent");
        //commit('setControlsP', value)
      });
    }
  },
  getters: {
    getControls: function getControls(state) {
      return state.controls;
    },
    getControlsPlay: function getControlsPlay(state) {
      if (state.controls != null) {
        return state.controls.play;
      } else {
        return null;
      }
    }
  }
});

/***/ }),

/***/ "Js1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      //volume:75,
      deviceVolume: 75,
      heading: '',
      description: '',
      duration: 1000,
      ftbBtn: { cmd: "ftb" },
      muteBtn: { cmd: "volumeOnOff" },
      controls: [{ label: "Cut", cmd: "cut", icon: "blur_off" }, { label: "Fade", cmd: "fade", icon: "blur_on", paramname: "duration", param: 1000 }, { label: "FTB", cmd: "showBlack", icon: "label_important" }],
      email: '',
      password: '',
      confirmPassword: '',
      version: "0.20"
    };
  },
  created: function created() {
    console.log(this.scheduals);
    this.$store.dispatch('loadControls');
    if (this.mediaList && this.mediaList.length == 0) {
      this.$store.dispatch('loadContents');
    }
    console.log("XXXX STATUS", this.status);
    if (this.status) {
      if (this.status.deviceVolume) {
        this.deviceVolume = parseFloat(this.status.deviceVolume);
      }
    }
  },


  computed: {
    tracks: function tracks() {
      return this.$store.getters.getTracks;
    },
    status: function status() {
      //return false;
      return this.$store.getters.getStatus;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    scheduals: function scheduals() {

      return this.$store.getters.loadedSchedules;
    },
    mediaBtns: function mediaBtns() {
      console.log("BTNS");
      var btns = [];
      var mediaObj = {};
      var tracks = this.tracks.tracks;
      var callBtn = null;
      var callBack = null;
      for (var i = 0; i < tracks.length; i++) {

        console.log(tracks[i]);
        var media = tracks[i].split(".");
        var id = media[0];
        console.log("---", id);
        if (id.indexOf("title") == 0) {
          mediaObj = { text: "Title", index: i + 1, label: "" + (i + 1), cmd: "play", media: id };
        } else if (id.indexOf("Browser") == 0) {
          mediaObj = { text: "URL", index: i + 1, label: "" + (i + 1), cmd: "play", media: id };
        } else if (id.indexOf("Dec") == 0) {
          mediaObj = { text: "Camera", index: i + 1, label: "" + (i + 1), cmd: "play", media: id };
        } else if (id.indexOf("Colour") == 0) {
          mediaObj = { text: "Blank", index: i + 1, label: "" + (i + 1), cmd: "play", media: id };
        } else if (id.indexOf("card") == 0) {
          mediaObj = { text: "Card", index: i + 1, label: "" + (i + 1), cmd: "play", media: id };
        } else if (id.indexOf("Call") == 0) {
          mediaObj = { text: "Video Call", index: i + 1, label: "", cmd: "play", media: id };
          callBtn = { text: "Call F", label: "", cmd: "call", media: id.substr(5) };
          callBack = { text: "Call B", label: "", cmd: "callBack", media: id.substr(5) };
        } else {
          mediaObj = { index: i + 1, label: "" + (i + 1), cmd: "play", media: id };
        }
        if (media[1] == "mp4") {
          if (this.getContent(id)) {
            mediaObj.image = this.getContent(id).imageUrl;
          } else {
            console.log("MISSING", id, this.getContent(id));
            mediaObj.image = null;
          }
        }
        btns.push(mediaObj);
        if (callBtn) {
          btns.push(callBtn);
          callBtn = null;
        }
        if (callBack) {
          btns.push(callBack);
          callBack = null;
        }
      }
      console.log(btns);
      return btns;
    }
  },
  watch: {
    user: function user(value) {

      console.log("HAVE A USER");
    },
    status: function status(value) {

      console.log("HAVE status", value);
      if (value.deviceVolume) {
        this.deviceVolume = parseFloat(value.deviceVolume).toFixed(1);
      }
    },
    tracks: function tracks(value) {
      console.log("HAVE tracks", value);
      console.log(this.mediaBtns);
      /*this.mediaBtns=[];
      var mediaObj={};
      for(var i=0;i<value.tracks.length;i++){
      
        console.log(value.tracks[i]);
        var media=value.tracks[i].split(".")
        var id=media[0];
          mediaObj={label:""+(i+1),cmd:"play",media:id};
        if(media[1]=="mp4"){
          console.log(this.getContent(id));
          mediaObj.image=this.getContent(id).imageUrl;
        }
         this.mediaBtns.push(mediaObj);
         
      }
      */
    }
  },
  methods: {
    volumeUp: function volumeUp() {
      this.$store.dispatch('sendCommand', { cmd: 'volumeUp' });
    },
    volumeDown: function volumeDown() {
      //this.$store.dispatch('setControlsVolume', 90);
      this.$store.dispatch('sendCommand', { cmd: 'volumeDown' });
    },
    btnText: function btnText(btn) {
      if (btn.text == "Call F" || btn.text == "Call B") {
        return btn.text;
      }
      if (btn.media.indexOf("-") != 0) {
        if (btn.media.indexOf("Browser") == 0) {
          return btn.media.substr(8);
        }
        return btn.media;
      }
      if (btn.label && btn.text) {
        return btn.label + " " + btn.text;
      }
      if (btn.text) {
        return btn.text;
      }

      if (btn.label) {
        return btn.label;
      }

      return null;
    },
    sendMessage: function sendMessage(btn) {
      this.$store.dispatch('sendMessage', { heading: this.heading, description: this.description });
      console.log(this.heading);
    },
    sendCommand: function sendCommand(btn) {

      this.$store.dispatch('sendCommand', btn);
      console.log(btn);
    },
    play: function play(btn) {
      this.$store.dispatch('setControlsPlay', btn);
    },
    preview: function preview(btn) {
      if (btn.cmd == "call") {
        window.open('https://www.vmixcall.com/call.aspx?Key=' + btn.media + '&Name=' + btn.media, '_blank');
      } else if (btn.cmd == "callBack") {
        window.open('https://www.vmixcall.com/call.aspx?Key=' + btn.media + '&Name=' + btn.media + '&Camera=Back', '_blank');
      } else {
        this.$store.dispatch('setControlsPreview', btn);
        console.log(btn);
      }
    },
    generatePlaylist: function generatePlaylist() {
      console.log("Make the list");
      this.$store.dispatch('sendCommand', { cmd: "generate" });
    },
    downloadFiles: function downloadFiles() {
      console.log("Download Files");
      this.$store.dispatch('sendCommand', { cmd: "download" });
    },
    openPreset: function openPreset(sch) {
      console.log("OPEN SCH", sch);
      this.$store.dispatch('setControlsOpen', sch);
    },
    openPlaylist: function openPlaylist() {
      console.log("Make the list");
      this.$store.dispatch('sendCommand', { cmd: "open" });
    },
    startPlaylist: function startPlaylist() {
      console.log("Make the list");
      this.$store.dispatch('sendCommand', { cmd: "start" });
    },
    stopPlaylist: function stopPlaylist() {
      console.log("Make the list");
      this.$store.dispatch('sendCommand', { cmd: "stop" });
    },
    getInfo: function getInfo() {
      console.log("Get Info");
      this.$store.dispatch('sendCommand', { cmd: "info" });
    },
    refresh: function refresh() {
      this.$store.dispatch('sendCommand', { cmd: "refresh" });
    },
    onSignin: function onSignin() {
      console.log('email:', this.email);
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      console.log('Dismissed alert');
      this.$store.dispatch('clearError');
    },
    getContent: function getContent(id) {
      return this.$store.getters.loadedContent(id);
    }
  }
});

/***/ }),

/***/ "JvTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeAreOne_vue__ = __webpack_require__("OrKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31bbe1f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeAreOne_vue__ = __webpack_require__("mR7h");
function injectStyle (ssrContext) {
  __webpack_require__("FGJs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31bbe1f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WeAreOne_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31bbe1f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WeAreOne_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KFUk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ku90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editable_vue__ = __webpack_require__("oUcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ef7cb16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editable_vue__ = __webpack_require__("CAEv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ef7cb16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aede119_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("FI9S");
function injectStyle (ssrContext) {
  __webpack_require__("82ws")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aede119_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MKaD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MTZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "N8ek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylus_main_styl__ = __webpack_require__("tLfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_date__ = __webpack_require__("5TPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shared_Alert_vue__ = __webpack_require__("yVzT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Content_ViewContentDialogue_vue__ = __webpack_require__("eR0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_swatches__ = __webpack_require__("gQ/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_swatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_swatches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_swatches_dist_vue_swatches_min_css__ = __webpack_require__("peKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_swatches_dist_vue_swatches_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_swatches_dist_vue_swatches_min_css__);


















// Import the styles too, globally


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a, {
  theme: {
    primary: '#00897b'
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('date', __WEBPACK_IMPORTED_MODULE_8__filters_date__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('app-alert', __WEBPACK_IMPORTED_MODULE_9__components_Shared_Alert_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_swatches___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('app-view-content-details-dialog', __WEBPACK_IMPORTED_MODULE_10__components_Content_ViewContentDialogue_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
  },
  created: function created() {
    var _this = this;

    // Initialize Firebase
    var config = {
      apiKey: "AIzaSyDPiRD2_JIh9ap1gAh4mf3c1KNkFcbDFXU",
      authDomain: "the-loop-cb6ab.firebaseapp.com",
      databaseURL: "https://the-loop-cb6ab.firebaseio.com",
      projectId: "the-loop-cb6ab",
      storageBucket: "the-loop-cb6ab.appspot.com",
      messagingSenderId: "848554627148"

    };

    __WEBPACK_IMPORTED_MODULE_5_firebase__["initializeApp"](config);

    var firestore = __WEBPACK_IMPORTED_MODULE_5_firebase__["firestore"]();
    var settings = { /* your settings... */timestampsInSnapshots: true };
    firestore.settings(settings);

    //var provider = new firebase.auth.GoogleAuthProvider();

    __WEBPACK_IMPORTED_MODULE_5_firebase__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
        _this.$store.dispatch('fetchUserData');
      }
    });

    //this.$store.dispatch('loadContents')
    this.$store.dispatch('loadPlaylists');

    this.$store.dispatch('loadTracks');
    this.$store.dispatch('loadSchedules');
    this.$store.dispatch('loadContents').then(function () {
      _this.$store.dispatch('loadStatus');
    });
    //this.$store.dispatch('loadControls')
  }
});

/***/ }),

/***/ "NWNW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_volume_vue__ = __webpack_require__("bVyK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4c5054_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volume_vue__ = __webpack_require__("sDIZ");
function injectStyle (ssrContext) {
  __webpack_require__("pfrV")
  __webpack_require__("OBtz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b4c5054"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_volume_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4c5054_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volume_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O+HL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('h2',[_vm._v("Submission Guidelines for The Loop")]),_vm._v(" "),_c('p',[_vm._v("To ensure that your video is played at the highest quality for the platform, please\nfollow these guidelines for vision and audio formatting before uploading content\ndirectly to the Loop.")]),_vm._v(" "),_c('h2',[_vm._v("Accepted video file formats")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("MPEG-4 / mp4 (recommended video codec: H.264)")]),_vm._v(" "),_c('li',[_vm._v("Maximum 4GB file size")])]),_vm._v(" "),_c('h2',[_vm._v("Audio")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("It’s important that your audio is good quality and normalised to ensure volume\nconsistency across all content on The Loop")]),_vm._v(" "),_c('li',[_vm._v("If your audio is very poor quality we may not be able to screen it")])]),_vm._v(" "),_c('h2',[_vm._v("Accessibility")]),_vm._v(" "),_c('p',[_vm._v("We strongly recommend that you provide text captioning and audio description to all\nthe content you submit so that it aligns with our Accessibility and Inclusion Policy.\nMost current editing software provides automated captioning to assist in this process\nit is your responsibility to check the accuracy of all captioning for your content.")]),_vm._v(" "),_c('h2',[_vm._v("Other material required")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("a still image that is indicative of your content –")]),_vm._v(" "),_c('li',[_vm._v("If you are submitting video for a particular Loop program please tag the name\nof the program in the Loop submission portal")])]),_vm._v(" "),_c('h2',[_vm._v("Screen specs")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Screen size: 4800 x 2880mm at a 5mm pitch")]),_vm._v(" "),_c('li',[_vm._v("Output resolution: 960 x 576 (square pixels) – This refers to the resolution of visible area\nof the screen that your film will play at. It is ok to submit your content at full HD 1920x1080 the Loop will scale it appropriately.")]),_vm._v(" "),_c('li',[_vm._v("The screen is not 16:9, it is slightly narrower. By Default your image will be cropped If your video does not fit these\ndimensions, we can adjust the scale so that it plays letterboxed if required. Please let us know your preference in advance.")]),_vm._v(" "),_c('li',[_vm._v("Please ensure all titles/subtitles and other important graphics are not cropped.")])]),_vm._v(" "),_c('h2',[_vm._v("License and Agreement")]),_vm._v(" "),_c('p',[_vm._v("You must complete this "),_c('v-btn',{attrs:{"href":"https://au.openforms.com/Form/fadca18a-afd1-4452-b8c4-bdc6f4ac542c"}},[_vm._v("agreement and declaration")]),_vm._v(" in order to give permission for\nyour content to be screened on the Loop.")],1),_vm._v(" "),_c('h2',[_vm._v("Get in touch")]),_vm._v(" "),_c('p',[_vm._v("\n                If you have particular questions or require assistance with your submission please\ncontact Tobias Hengeveld – Public Art Project Officer for the City of Hobart – call\n(03) 62382565 or email hengeveldt@hobartcity.com.au or\npulicart@hobartcity.com.au\n              ")]),_vm._v(" "),_c('p'),(!_vm.userIsAuthenticated)?_c('div',[_c('b',[_vm._v("You need an account to sumbit content. ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/signin"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock_open")]),_vm._v("Sign In")],1),_vm._v(" "),_c('v-btn',{attrs:{"to":"/signup"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("face")]),_vm._v("Sign Up")],1)],1):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{attrs:{"to":"/content/new"}},[_c('v-icon',[_vm._v("movie")]),_vm._v(" Upload Content")],1)],1):_vm._e(),_vm._v(" "),_c('p')])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OBtz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OrKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "PV2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swatches__ = __webpack_require__("gQ/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swatches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_swatches__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a, Swatches: __WEBPACK_IMPORTED_MODULE_2_vue_swatches___default.a
  },
  data: function data() {
    return {
      deletedialog: false,
      deleteID: null,
      mediaMode: 'media',
      editdialog: false,
      currentElement: null,
      color: '#1CA085',
      playlist: [],
      loadedList: null,
      playlistName: 'Playlist',
      email: '',
      password: '',
      confirmPassword: '',
      elementCount: 0,
      keywordList: [],
      keywords: ['Animation', 'MyState', 'Student', 'Stories in September', 'TAC', 'TAHO', 'Tasmanian Artist', 'The Loop', 'Title', 'UTAS', 'Visual Art', 'Wide Angle', 'Test']

    };
  },
  created: function created() {
    console.log("USER", this.user);
    if (this.mediaList.length == 0) {
      this.$store.dispatch('loadContents');
    }
  },
  mounted: function mounted() {
    this.adjustTimes();
    console.log("MEDIA", this.mediaList);
  },


  computed: {
    playlists: function playlists() {
      console.log("P", this.$store.getters.loadedPlaylists);
      return this.$store.getters.loadedPlaylists;
    },
    mediaList: function mediaList() {
      return this.$store.getters.loadedContents;
    },
    totalDuration: function totalDuration() {
      var duration = 0;
      for (var i = this.playlist.length - 1; i >= 0; --i) {
        duration += this.playlist[i].duration * this.playlist[i].loops;
      }
      return duration;
    },
    getLoops: function getLoops() {
      return 3;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    loadedList: function loadedList(playlist) {
      console.log(playlist);
      this.editPlaylist(playlist, true);
    },
    user: function user(value) {
      console.log("HAVE A USER");
    },
    currentElement: function currentElement(value) {
      console.log("Current Element", value);
    }
  },
  methods: {
    showDetails: function showDetails(content) {
      console.log("ShowDetails");
      window.open(content.videoUrl, '_blank');
    },
    deletePlaylist: function deletePlaylist(playlistId) {
      console.log("DELETE", playlistId);
      this.deleteID = playlistId;
      this.deletedialog = true;
      //this.$store.dispatch('deletePlaylist',playlistId);   
    },
    confirmDelete: function confirmDelete() {
      console.log("DELETE -", this.deletedialog);
      this.$store.dispatch('deletePlaylist', this.deleteID);
      this.deletedialog = false;
    },
    cleanList: function cleanList() {
      this.playlist = [];
      this.loadedList = null, this.playlistName == "Playlist";
    },
    editPlaylist: function editPlaylist(playlist, clean) {
      if (clean) {
        this.playlist = [];
      }
      console.log("playlist", playlist.items);
      var pList;
      var item;
      for (var i in playlist.items) {
        this.elementCount++;
        pList = playlist.items[i];
        item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getContent(pList.id));
        item.tid = "clone" + this.elementCount;
        item.duration = pList.duration;
        item.durationText = this.secToTime(item.duration);
        item.loops = pList.loops;
        console.log("NEW", item);
        this.playlist.push(item);
      }
      if (clean || this.playlistName == "Playlist") {
        this.playlistName = playlist.name;
        this.color = playlist.color;
      } else {
        this.playlistName = this.playlistName + " + " + playlist.name;
      }

      //this.playlist.push(playlist.items[0]);
      // this.playlist.push(this.rebuild(this.getContent(playlist.items[0].id))
    },
    getContent: function getContent(id) {
      return this.$store.getters.loadedContent(id);
    },
    matchesKey: function matchesKey(element) {

      if (this.keywordList.length == 0) {
        return true;
      }
      if (this.keywordList[0] == "None" && !element.keywords) {
        return true;
      }
      if (!element.keywords) {
        return false;
      }
      return this.findOne(this.keywordList, element.keywords);
    },
    findOne: function findOne(haystack, arr) {
      var haystack_lc = haystack.map(function (x) {
        return x.toLowerCase();
      });
      return arr.some(function (v) {

        return haystack_lc.indexOf(v.toLowerCase()) >= 0;
      });
    },
    editableDuration: function editableDuration(type) {
      if (type == "URL" || type == "web" || type == "title" || type == "Camera" || type == "Blank") {
        return true;
      }
      return false;
    },
    doEditChanges: function doEditChanges(changes) {
      console.log("doEditChanges", this.currentElement, changes);
      if (this.currentElement.type != "video") {
        this.currentElement.duration = this.timeToSec(changes);
      }

      if (this.currentElement.loops) {
        this.currentElement.totalDuration = this.currentElement.duration * this.currentElement.loops;
        this.currentElement.durationText = this.secToTime(this.currentElement.totalDuration);
      } else {
        this.currentElement.totalDuration = this.currentElement.duration = this.timeToSec(this.currentElement.durationText);
      }
    },
    totalClipDuration: function totalClipDuration(item) {
      return this.secToTime(item.duration * item.loops);
    },
    removeMedia: function removeMedia(id) {
      console.log("remove", id);
      for (var i = this.playlist.length - 1; i >= 0; --i) {
        if (this.playlist[i].tid == id) {
          this.playlist.splice(i, 1);
        }
      }
    },
    clone: function clone(e1) {
      this.elementCount++;
      return { tid: "clone" + this.elementCount + "C",
        id: e1.id,
        title: e1.title,
        subtitle: e1.subtitle || null,
        body: e1.body || null,
        footer: e1.footer || null,
        duration: e1.duration || 0,
        videoUrl: e1.videoUrl,
        imageUrl: e1.imageUrl,
        web: e1.web,
        color: e1.color,
        time: 0,
        type: e1.type,
        loops: 1,
        durationText: this.secToTime(e1.duration)
      };
    },
    onChange: function onChange(evt) {
      console.log("Change");
      this.adjustTimes();
    },
    adjustTimes: function adjustTimes() {
      var items = document.querySelectorAll('#mainList .card');
      for (var i = 0; i < items.length; i++) {
        this.playlist[i].time = this.secToTime(items[i].offsetTop * 60);
      }
    },
    textChange: function textChange() {
      console.log("TC");
      this.adjustTimes();
    },
    mediaHeight: function mediaHeight(element) {

      //return (element.duration*element.loops)+"px"
      return "120px";
    },
    checkMove: function checkMove(evt) {
      // cant drag empty elements
      return evt.draggedContext.element.title !== '';
    },
    sendMessage: function sendMessage(btn) {
      this.$store.dispatch('sendMessage', { heading: this.heading, description: this.description });
      console.log(this.heading);
    },
    sendCommand: function sendCommand(btn) {
      this.$store.dispatch('sendCommand', btn);
      console.log(btn);
    },
    onSignin: function onSignin() {
      console.log('email:', this.email);
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      console.log('Dismissed alert');
      this.$store.dispatch('clearError');
    },
    secToTime: function secToTime(sec) {
      var secs = sec % 60;
      var mins = (sec - secs) / 60 % 60;
      var hrs = (sec - mins * 60 - secs) / 60 / 60;
      secs = Math.round(secs);
      if (secs < 10) secs = "0" + secs;
      if (mins < 10) mins = "0" + mins;
      return hrs + ":" + mins + ":" + secs;
    },
    timeToSec: function timeToSec(time) {
      var times = time.split(":");
      var secs = parseInt(times[2], 10);
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60 + secs;
    },
    clearPlaylist: function clearPlaylist() {
      this.cleanList();
    },
    updatePlaylist: function updatePlaylist() {
      var pList = { duration: this.totalDuration, name: this.playlistName, color: this.color, type: "playlist" };
      pList.items = [];
      pList.id = this.loadedList.id;
      var item;
      for (var i = 0; i < this.playlist.length; i++) {
        item = this.playlist[i];
        pList.items.push({ index: i, duration: item.duration, loops: parseInt(item.loops, 10), id: item.id });
      }
      console.log("Update", pList);
      this.$store.dispatch('updatePlaylistData', pList);
    },
    savePlaylist: function savePlaylist() {

      var pList = { duration: this.totalDuration, name: this.playlistName, color: this.color, type: "playlist" };
      pList.items = [];
      var item;
      for (var i = 0; i < this.playlist.length; i++) {
        item = this.playlist[i];
        pList.items.push({ index: i, duration: item.duration, loops: parseInt(item.loops, 10), id: item.id });
      }
      console.log("SAVE", pList);
      this.$store.dispatch('createPlaylist', pList);
    }
  }
});

/***/ }),

/***/ "PWdL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[(false)?_c('v-flex',{attrs:{"xs12":"","sm6":"","pa-0":"","pr-4":""}},[(_vm.nowPlaying)?_c('div',[(_vm.nowPlaying.type=='title')?_c('div',{staticClass:"titlePreview",attrs:{"style:":""}},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.nowPlaying.title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(_vm.nowPlaying.subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(_vm.nowPlaying.body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(_vm.nowPlaying.footer))])]):_vm._e(),_vm._v(" "),(false)?_c('v-img',{attrs:{"src":_vm.nowPlaying.imageUrl}}):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.nowPlaying.title)+" - "+_vm._s(_vm.nowPlaying.artist))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.nowPlaying.description))])],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","pa-0":""}},[(!_vm.loading)?_c('div',{staticStyle:{"cursor":"pointer"}},[(_vm.status)?_c('div',[_c('v-layout',{attrs:{"justify-space-between":"","row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('h2',[_vm._v("Todays Schedule")])]),_vm._v(" "),_c('v-flex')],1),_vm._v(" "),(_vm.status)?_c('ScheduleView',{attrs:{"schedule":_vm.currentSchedule}}):_vm._e()],1):_vm._e()]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QMNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedSchedules: [],
    createdKey: null

  },
  mutations: {
    setCurrentSchedule: function setCurrentSchedule(state, payload) {
      state.createdKey = payload;
    },
    setLoadedSchedules: function setLoadedSchedules(state, payload) {
      state.loadedSchedules = payload;
    },
    createSchedule: function createSchedule(state, payload) {
      state.loadedSchedules.push(payload);
      state.createdKey = payload.id;
    },
    deleteSchedule: function deleteSchedule(state, payload) {
      for (var i = state.loadedSchedules.length - 1; i >= 0; --i) {
        if (state.loadedSchedules[i].id == payload) {
          state.loadedSchedules.splice(i, 1);
        }
      }
    },
    updateSchedule: function updateSchedule(state, payload) {
      console.log("MUTATIONS", payload);
      var schedule = state.loadedSchedules.find(function (schedule) {
        return schedule.id === payload.id;
      });
      if (payload.name) {
        schedule.title = payload.name;
      }
      if (payload.description) {
        schedule.description = payload.description;
      }
      if (payload.date) {
        schedule.date = payload.date;
      }
      if (payload.description) {
        schedule.description = payload.description;
      }
      if (payload.duration) {
        schedule.duration = payload.duration;
      }
      if (payload.items) {
        schedule.items = payload.items;
      }

      if (payload.color) {
        schedule.color = payload.color;
      }
      if (payload.startDate) {
        schedule.startDate = payload.startDate;
      }
      if (payload.startTime) {
        schedule.startTime = payload.startTime;
      }
      if (payload.endTime) {
        schedule.endTime = payload.endTime;
      }
      if (payload.hideTime) {
        schedule.hideTime = payload.hideTime;
      }
      if (payload.expandPlaylist) {
        schedule.expandPlaylist = payload.expandPlaylist;
      }
    }
  },
  actions: {
    loadTextSchedule: function loadTextSchedule(_ref) {
      var commit = _ref.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('schedule').once('value').then(function (data) {
        console.log(data);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    loadSchedules: function loadSchedules(_ref2) {
      var commit = _ref2.commit;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('schedule').once('value').then(function (data) {
        var schedules = [];
        var obj = data.val();
        for (var key in obj) {
          schedules.push({
            id: key,
            title: obj[key].title,
            description: obj[key].description,
            duration: obj[key].duration,
            videoUrl: obj[key].videoUrl,
            imageUrl: obj[key].imageUrl,
            color: obj[key].color,
            web: obj[key].web,
            items: obj[key].items,
            hideS: obj[key].hideS,
            date: obj[key].date,
            creatorId: obj[key].creatorId,
            startTime: obj[key].startTime,
            startDate: obj[key].startDate,
            hideTime: obj[key].hideTime || false,
            expandPlaylist: obj[key].expandPlaylist || false
          });
        }
        commit('setLoading', false);
        commit('setLoadedSchedules', schedules);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    createSchedule: function createSchedule(_ref3, payload) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          getters = _ref3.getters;

      console.log("createSchedule", payload);
      var store = this;
      var key = void 0;
      var schedule = {
        title: payload.name,
        items: payload.items,
        duration: payload.duration || 0,
        color: payload.color,
        creatorId: getters.user.id,
        startDate: payload.startDate,
        startTime: payload.startTime,
        hideTime: payload.hideTime || false,
        expandPlaylist: payload.expandPlaylist || false
      };
      console.log("createSchedule", schedule);
      // Reach out to firebase and store it
      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('schedule').push(schedule).then(function (data) {
        console.log(data);
        key = data.key;
        return key;
      }).then(function (key) {
        console.log("SUBMITTED SCHEDULE");
        commit('createSchedule', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schedule, {
          id: key
        }));
        commit('setCurrentSchedule', schedule);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteSchedule: function deleteSchedule(_ref4, payload) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('schedule').child(payload).remove().then(function () {
        commit('deleteSchedule', payload);
      });
    },
    updateScheduleData: function updateScheduleData(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setLoading', true);
      console.log("updateScheduleData", payload);
      var updateObj = {};
      if (payload.name) {
        updateObj.title = payload.name;
      }
      if (payload.description) {
        updateObj.description = payload.description;
      }
      if (payload.duration) {
        updateObj.duration = payload.duration;
      }
      if (payload.items) {
        updateObj.items = payload.items;
      }
      if (payload.date) {
        updateObj.date = payload.date;
      }
      if (payload.color) {
        updateObj.color = payload.color;
      }
      if (payload.startDate) {
        updateObj.startDate = payload.startDate;
      }
      if (payload.startTime) {
        updateObj.startTime = payload.startTime;
      }
      if (payload.endTime) {
        updateObj.endTime = payload.endTime;
      }
      if (payload.hideTime) {
        updateObj.hideTime = payload.hideTime;
      }
      if (payload.expandPlaylist) {
        updateObj.expandPlaylist = payload.expandPlaylist;
      }
      console.log("updateScheduleData2", updateObj);
      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('schedule').child(payload.id).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateSchedule', payload);
      }).catch(function (error) {
        commit('setLoading', false);
        console.log(error);
      });
    }
  },
  getters: {
    createdKey: function createdKey(state) {
      return state.createdKey;
    },
    loadedSchedules: function loadedSchedules(state) {
      return state.loadedSchedules.sort(function (scheduleA, scheduleB) {
        return scheduleA.date > scheduleB.date;
      });
    },
    loadedSchedule: function loadedSchedule(state) {
      return function (scheduleId) {
        return state.loadedSchedules.find(function (schedule) {
          return schedule.id === scheduleId;
        });
      };
    }
  }
});

/***/ }),

/***/ "QsO5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QvwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('video',{staticStyle:{"margin-top":"10px","margin":"auto","position":"relative"},attrs:{"id":"video","src":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FSlowbart.mp4?alt=media&token=bdf7fdfc-b036-47aa-8784-ddefa8cd4533","poster":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2Fslowbart.png?alt=media&token=2ef0e16b-0101-4234-8e02-e7ef6b52be7c","width":"100%","controls":"","autoplay":""},on:{"click":function($event){_vm.cycle=false}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("SLOWBART: An ambient film program")]),_vm._v(" "),_c('h4',[_vm._v("Friday 4 October, 5:30 - 6:30pm @ The Loop, 157 Elizabeth Street, Hobart"),_c('br'),_vm._v("\n          \n        \n          Speeches and refreshments from 5:30pm"),_c('br'),_vm._v("\n          full screening of Slowbart: An ambient film starting at 6pm"),_c('br'),_vm._v("\n          Opened by the Lord Mayor, Anna Reynolds, and head of School for Media and Creative Arts, Dr Meg Keating"),_c('p')]),_vm._v(" "),_c('h3',[_vm._v("A special feature for The Loop, Hobart's Digital Art platform.")]),_vm._v(" "),_c('p',[_vm._v("\nSlowbart invites you into the realm of 'Slow TV' for a double-take as stories and scenes of Hobart and surrounds unfold at a relaxed pace."),_c('br'),_vm._v("\nDeveloped by emerging curators Heath Willis and Victoria Bremner from The School of Media, University of Tasmania in partnership with The City of Hobart.\n")]),_vm._v(" "),_c('p'),_c('h3',[_vm._v(" Delving into the realm of ‘Slow TV’:  From the macro to the micro…")]),_vm._v("\nHobart has an easy-going and serene atmosphere that’s unusual for a capital city. Slowbart leans in to this idea, highlighting imagery that embraces the aesthetic of ‘slow TV’ and reveals unusual views of Hobart and our surrounds through the eyes of the people and inhabitants that call it home."),_c('p'),_vm._v(" "),_c('p',[_vm._v("From ambient landscapes and soundscapes to leisurely depictions of local happenings, Slowbart is about stories told at a relaxed pace. It’s about gradually unfolding moments and experiences, designed to be enjoyed by audiences as they wait, or pass by, or settle in for the long-haul.")]),_vm._v(" "),_c('p',[_vm._v("Filmmakers, artists and content makers of all kinds were encouraged to scour their hard drives, delve into the depths of their filing cabinets and check under their beds to contribute imagery and film work for this program. Developed into two distinct programs, Slowbart: an ambient film and The Hour of Power: lunchtime featurettes, The Slowbart program features an original score from young music composer, Finn Clarke from The Conservatorium of Music, University of Tasmania. Other highlights include a series of animation and shorts from local film-makers.")]),_vm._v(" "),_c('h3',[_vm._v("Join us as we launch the program with a special screening of Slowbart: an ambient film ")]),_vm._v("as well as highlights from The Hour of Power at a special red-carpet evening event.\n "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('h3',[_vm._v("The program is proudly jointly presented by the City of Hobart and University of Tasmania.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S3UG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ScRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card-text',[_c('v-container'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSignup($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":" Confirm Password","id":"confirmPassword","type":"password","rules":[_vm.comparePasswords]},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("Sign Up\n            "),_c('span',{staticClass:"customLoader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading},on:{"click":_vm.onSignupGoogle}},[_vm._v("Sign Up With Google\n            "),_c('span',{staticClass:"customLoader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ShEE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      radioBtns: ['Show All', 'approved', 'pending'],
      approvedState: 0,
      playvalX: '',
      date: null,
      menu: false,
      showEmail: false,
      //keywords: ['Action','Drama','Animation'],
      keywordList: [],
      keywords: ['Animation', 'MyState', 'Student', 'Stories in September', 'TAC', 'TAHO', 'Tasmanian Artist', 'The Loop', 'Title', 'UTAS', 'Visual Art', 'Wide Angle', 'Test']
    };
  },

  components: {},
  created: function created() {
    if (this.contents.length == 0) {
      this.$store.dispatch('loadContents');
    }
  },
  mounted: function mounted() {},

  computed: {
    playval: function playval() {
      return this.$store.getters.getControlsPlay;
    },
    contents: function contents() {
      console.log("CONTENTS", this.$store.getters.loadedContents[0]);
      return this.$store.getters.loadedContents;
    }
  },
  methods: {
    showDetails: function showDetails(content) {
      console.log("ShowDetails");
      window.open(content.videoUrl, '_blank');
      //this.$set(content,'showDetails',true);
      //console.log("ShowDetails",content)
    },
    getContact: function getContact(userId) {
      this.$store.dispatch("getContact", userId).then(function (response) {
        console.log(response);
        alert("Email : " + response);
        return response;
      }, function (error) {
        console.error("No Data");
        return "no email confirmed";
      });
    },
    showApproved: function showApproved(content) {
      switch (this.approvedState) {
        case 0:
          return true;
          break;
        case 1:
          return content.approved;
          break;
        case 2:
          return !content.approved;
          break;
      }
    },
    doEdit: function doEdit(content) {
      console.log("EDIT CONTENT", content);
      this.$set(content, 'allowEdit', false);
      this.$store.dispatch('updateContentData', content);
    },
    allowEdit: function allowEdit(content) {
      console.log("allowEdit");
      this.$set(content, 'allowEdit', true);
    },
    addKeyword: function addKeyword(content) {
      console.log("Add Keyword", content);
    },
    approveContent: function approveContent(content) {
      content.approved = true;
      this.$store.dispatch('updateContentData', content);
      console.log("Approve", content);
    },
    disapproveContent: function disapproveContent(content) {
      content.approved = false;
      this.$store.dispatch('updateContentData', content);
      console.log("Approve", content);
    },
    matchesKey: function matchesKey(element) {
      // console.log( this.keywordList,element.keywords)
      if (this.keywordList.length == 0) {
        return true;
      }
      if (this.keywordList[0] == "None" && !element.keywords) {
        return true;
      }
      if (!element.keywords) {
        return false;
      }
      return this.findOne(element.keywords, this.keywordList);
    },
    findOne: function findOne(haystack, arr) {
      return arr.some(function (v) {
        return haystack.indexOf(v) >= 0;
      });
    },
    remove: function remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.chips));
    },
    clickPlay: function clickPlay() {
      this.$store.dispatch('setControlsPlay');
    },
    secondsToDurationText: function secondsToDurationText(sec) {
      var hrs = Math.floor(sec / (60 * 60));
      var mins = Math.floor((sec - hrs * 60 * 60) / 60);
      var secs = Math.floor(sec % 60);
      var time = "";
      if (hrs > 0) {
        time = hrs + "hour" + this.plural(hrs) + " ";
      }
      if (mins > 0) {
        time = time + mins + "min" + this.plural(mins) + " ";
      }
      if (secs > 0) {
        time = time + secs + "sec" + this.plural(secs) + " ";
      }
      return time;
    },
    plural: function plural(val) {
      if (val != 1) {
        return "s";
      } else {
        return "";
      }
    }
  }
});

/***/ }),

/***/ "SnXZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tpnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      black: 0,
      captionOpacity: 0,
      imageNum: 0,
      time: null,
      minute: null,
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

      camsX: [
      //{name:"Tasman Bridge",link:'https://rosebayhigh.education.tas.edu.au/wp-content/uploads/webcampic-med.jpg'},
      {
        name: "Argyle and Davey Street",
        link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg2.jpg"
      }, {
        name: "Railway Roundabout",
        link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg1.jpg"
      }, {
        name: "Davey Street & Sandy Bay Road",
        link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg3.jpg"
      }, {
        name: "Tasman Bridge",
        link: "https://www.transport.tas.gov.au/__traffic_updates/CapImg4.jpg"
      }, {
        name: "kunanyi / Mount Wellington Platform",
        link: "https://hccapps.hobartcity.com.au/webcams/platform"
      }, {
        name: "kunanyi / Mount Wellington Summit",
        link: "https://hccapps.hobartcity.com.au/webcams/summit"
      }, {
        name: "Salamanca",
        link: "http://120.29.240.91/axis-cgi/mjpg/video.cgi?resolution=720x576&dummy=1542411927643"
      }]
    };
  },
  mounted: function mounted() {
    setTimeout(this.nextPic, 5000);
    setInterval(this.tic, 1000);
    this.$store.dispatch("loadCameras");
  },

  computed: {
    cameraOptions: function cameraOptions() {
      return this.$store.getters.getCameraOptions;
    },
    camDuration: function camDuration() {
      return this.cameraOptions.duration * 1000;
    },
    cams: function cams() {
      return this.$store.getters.getCameras;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },

  methods: {
    tic: function tic() {
      var d = new Date(),
          seconds = d.getSeconds().toString().length == 1 ? "0" + d.getSeconds() : d.getSeconds(),
          minutes = d.getMinutes().toString().length == 1 ? "0" + d.getMinutes() : d.getMinutes(),
          hours = d.getHours().toString().length == 1 ? "0" + d.getHours() : d.getHours(),
          ampm = d.getHours() >= 12 ? "pm" : "am";

      this.time = this.days[d.getDay()] + " " + this.months[d.getMonth()] + " " + d.getDate() + " " + d.getFullYear() + " " + hours + ":" + minutes + ":" + seconds;
    },
    nextMinute: function nextMinute() {
      var d = new Date(),
          minutes = d.getMinutes().toString().length == 1 ? "0" + d.getMinutes() : d.getMinutes(),
          hours = d.getHours().toString().length == 1 ? "0" + d.getHours() : d.getHours();
      this.minute = this.months[d.getMonth()] + " " + d.getDate() + " " + d.getFullYear() + " " + hours + ":" + minutes;
    },
    nextPic: function nextPic() {
      this.nextMinute();
      setTimeout(this.switch, 100);

      this.black = 1;
    },
    fadeCaption: function fadeCaption() {
      this.captionOpacity = 0;
      setTimeout(this.reveal, 50);
    },
    reveal: function reveal() {
      this.black = 0;
      this.captionOpacity = 0;
      setTimeout(this.nextPic, this.camDuration);
      if (this.cameraOptions.zoom) {
        document.getElementById("screenColor").classList.add("zoom");
      }
    },
    switch: function _switch() {
      document.getElementById("screenColor").classList.remove("zoom");
      if (this.imageNum == this.cams.length - 1) {
        this.$store.dispatch("loadCameras");
      }
      this.imageNum = (this.imageNum + 1) % this.cams.length;

      this.captionOpacity = 1;

      setTimeout(this.fadeCaption, 150);
    },
    mouseDown: function mouseDown(event) {},
    mouseUp: function mouseUp(event) {}
  }
});

/***/ }),

/***/ "UDPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow":"hidden"},attrs:{"ma-0":"","pa-0":"","fluid":"","fill-height":""}},[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=VT323","rel":"stylesheet"}}),_vm._v(" "),_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","pa-0":"","fill-height":""}},[_c('div',{staticClass:"screenCover fade",style:({'opacity':_vm.black})},[_c('div',{staticClass:"camCaption fade2",style:({'opacity':_vm.captionOpacity})},[_vm._v(_vm._s(_vm.cams[_vm.imageNum].name))])]),_vm._v(" "),(_vm.cams && _vm.cameraOptions.showDetails)?_c('div',{staticClass:"timeText top left"},[_vm._v("Hobart Web Cameras - "+_vm._s(this.time)+" - "+_vm._s(_vm.cams[_vm.imageNum].name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"screenColor",style:({'background-image':'url(\''+_vm.cams[_vm.imageNum].link+'?'+this.minute+')'}),attrs:{"id":"screenColor"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UeCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadNew_vue__ = __webpack_require__("fpIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1509f30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadNew_vue__ = __webpack_require__("HqMj");
function injectStyle (ssrContext) {
  __webpack_require__("tvUr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1509f30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VII7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VY5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Program_vue__ = __webpack_require__("Br1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51d25efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Program_vue__ = __webpack_require__("PWdL");
function injectStyle (ssrContext) {
  __webpack_require__("ef7p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51d25efa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Program_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51d25efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Program_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WuVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    play: null,
    colour: null,
    cameras: null,
    cameraOptions: { duration: 5, showDetails: true, zoom: true },
    pixels: [],
    pixelIndex: 0

  },
  mutations: {
    setPixel: function setPixel(state, payload) {},
    setPixelIndex: function setPixelIndex(state, payload) {
      console.log("payload", payload);
      state.pixelIndex = payload;
    },
    setCameraOptions: function setCameraOptions(state, payload) {
      state.cameraOptions = payload;
    },
    setCameras: function setCameras(state, payload) {
      console.log("Active Cameras", payload);
      state.cameras = payload;
    },
    setPixels: function setPixels(state, payload) {
      state.pixels = payload;
    },
    setPlay: function setPlay(state, payload) {
      state.play = payload;
    },
    setColour: function setColour(state, payload) {
      console.log("SET COLOUR", payload);
      state.colour = payload;
    }
  },
  actions: {
    loadCameras: function loadCameras(_ref) {
      var commit = _ref.commit;

      console.log("LOAD CAMERAS");
      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/webcams').once('value').then(function (data) {
        console.log("CAMERA", data.val());
        var cams = data.val();
        var cam = void 0;
        var activeCams = [];
        for (var c in cams) {
          cam = cams[c];
          if (c == "options") {
            commit('setCameraOptions', cam);
          } else {
            if (cam.active) {
              activeCams.push(cam);
            }

            console.log(cam.name, cam.active);
          }
        }
        commit('setCameras', activeCams);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    loadPlay: function loadPlay(_ref2) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play').on('value', function (snapshot) {
        commit('setPlay', snapshot.val());
      });
    },
    addPixel: function addPixel(_ref3) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/pixelIndex').once('value').then(function (data) {
        commit('setPixelIndex', data.val());
        __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/').update({ pixelIndex: data.val() + 1 });
        __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/pixels').child('pixel' + data.val()).update({ xpos: 0, ypos: 0, color: "rgb(255,255,255" });
      });
    },
    loadPixels: function loadPixels(_ref4) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/pixels').on('value', function (snapshot) {
        commit('setPixels', snapshot.val());
      });
    },
    resetPixels: function resetPixels(_ref5) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/').update({ pixelIndex: 0 });
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/').update({ pixels: [] });
    },
    loadColour: function loadColour(_ref6) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/colour').on('value', function (snapshot) {
        commit('setColour', snapshot.val());
      });
    },
    setColour: function setColour(_ref7, payload) {
      var commit = _ref7.commit;

      console.log("SET COLOUR XX", payload);
      var value = payload;
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play').update({ colour: value }).then(function () {
        commit('setColour', value);
      });
    },
    setPixel: function setPixel(_ref8, payload) {
      var commit = _ref8.commit;

      var value = payload.xpos;
      console.log("SET pos", payload, value);
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('play/pixel/pixels').child(payload.id).update({ xpos: payload.xpos, ypos: payload.ypos, color: payload.color }).then(function () {
        commit('setPixel', payload);
      });
    }
  },
  getters: {
    getPixelIndex: function getPixelIndex(state) {
      return state.pixelIndex;
    },
    getCameraOptions: function getCameraOptions(state) {
      return state.cameraOptions;
    },
    getCameras: function getCameras(state) {
      return state.cameras;
    },
    getPlay: function getPlay(state) {
      return state.play;
    },
    getColour: function getColour(state) {
      return state.colour;
    },
    getPixels: function getPixels(state) {
      return state.pixels;
    }
  }
});

/***/ }),

/***/ "Wz7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadedPlaylists: []
  },
  mutations: {
    setLoadedPlaylists: function setLoadedPlaylists(state, payload) {
      console.log("PLAYLISTS", payload);
      state.loadedPlaylists = payload;
    },
    createPlaylist: function createPlaylist(state, payload) {
      state.loadedPlaylists.push(payload);
    },
    deletePlaylist: function deletePlaylist(state, payload) {
      for (var i = state.loadedPlaylists.length - 1; i >= 0; --i) {
        if (state.loadedPlaylists[i].id == payload) {
          state.loadedPlaylists.splice(i, 1);
        }
      }
    },
    updatePlaylist: function updatePlaylist(state, payload) {
      var playlist = state.loadedPlaylists.find(function (playlist) {
        return playlist.id === payload.id;
      });
      if (payload.name) {
        playlist.name = payload.name;
      }
      if (payload.description) {
        playlist.description = payload.description;
      }
      if (payload.duration) {
        playlist.duration = payload.duration;
      }
      if (payload.items) {
        playlist.items = payload.items;
      }
      if (payload.color) {
        playlist.color = payload.color;
      }
      if (payload.date) {
        playlist.date = payload.date;
      }
      if (payload.type) {
        playlist.type = payload.type;
      }
    }
  },
  actions: {
    loadPlaylists: function loadPlaylists(_ref) {
      var commit = _ref.commit;

      console.log("AAAA loadPlaylists");
      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('playlist').once('value').then(function (data) {
        var playlists = [];
        var obj = data.val();
        for (var key in obj) {

          playlists.push({
            id: key,
            name: obj[key].name,
            description: obj[key].description,
            duration: obj[key].duration,
            items: obj[key].items,
            color: obj[key].color,
            date: obj[key].date,
            type: obj[key].type,
            creatorId: obj[key].creatorId
          });
        }
        commit('setLoading', false);
        commit('setLoadedPlaylists', playlists);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    createPlaylist: function createPlaylist(_ref2, payload) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          getters = _ref2.getters;

      var store = this;
      var key = void 0;
      var playlist = {
        name: payload.name,
        items: payload.items,
        duration: payload.duration,
        color: payload.color,
        type: payload.type,
        creatorId: getters.user.id

        // Reach out to firebase and store it
      };__WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('playlist').push(playlist).then(function (data) {
        console.log(data);
        key = data.key;
        return key;
      }).then(function (key) {
        console.log("SUBMITTED PLAYLIST");
        commit('createPlaylist', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, playlist, {
          id: key
        }));
      }).catch(function (error) {
        console.log(error);
      });
    },
    deletePlaylist: function deletePlaylist(_ref3, payload) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('playlist').child(payload).remove().then(function () {
        commit('deletePlaylist', payload);
      });
    },
    updatePlaylistData: function updatePlaylistData(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setLoading', true);
      var updateObj = {};

      if (payload.name) {
        updateObj.name = payload.name;
      }
      if (payload.description) {
        updateObj.description = payload.description;
      }
      if (payload.duration) {
        updateObj.duration = payload.duration;
      }
      if (payload.items) {
        updateObj.items = payload.items;
      }
      if (payload.color) {
        updateObj.color = payload.color;
      }
      if (payload.date) {
        updateObj.date = payload.date;
      }
      if (payload.type) {
        updateObj.type = payload.type;
      }
      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('playlist').child(payload.id).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updatePlaylist', payload);
      }).catch(function (error) {
        commit('setLoading', false);
        console.log(error);
      });
    }
  },
  getters: {
    loadedPlaylists: function loadedPlaylists(state) {
      console.log("GETTER PLAYLIST", state.loadedPlaylists);

      return state.loadedPlaylists;
    },
    featuredPlaylists: function featuredPlaylists(state, getters) {
      return getters.loadedPlaylists.slice(0, 5);
    },
    loadedPlaylist: function loadedPlaylist(state) {
      return function (playlistId) {
        return state.loadedPlaylists.find(function (playlist) {
          return playlist.id === playlistId;
        });
      };
    }
  }
});

/***/ }),

/***/ "Xn6Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[(true)?_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('img',{attrs:{"src":__webpack_require__("ooxT"),"width":"100%"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("cQCs"),"height":"80px;"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Complementing the inaugural "),_c('b',[_vm._v("Hobart Current 2021 :Liberty")]),_vm._v(", the City of Hobart is hosting a program of diverse community activities, providing opportunities to discover and explore the notion of ‘liberty’ .")]),_vm._v(" "),_c('p',[_c('v-btn',{attrs:{"href":"https://hobartcurrent.com/","target":"blank"}},[_vm._v("Hobart Current")]),_vm._v(" is Hobart’s inaugural biennale of contemporary art exhibition scheduled for March 2021. Creative Director, Rosie Dennis, has chosen the theme of ‘liberty’ for next year’s exhibition and invites artists and community to respond and participate in a range of public programming and opportunities that will run alongside the exhibition."),_c('br'),_vm._v("For other ways to participate read more on the"),_c('v-btn',{attrs:{"href":"https://hobartcurrent.com/get-involved","target":"blank"}},[_vm._v("Hobart Current website")]),_vm._v(".")],1),_vm._v(" "),_c('h2',[_vm._v("Call-Out for a new video program"),_c('br')]),_c('br'),_vm._v(" "),_c('h1',[_vm._v("LIBERTY LOOP")]),_vm._v(" "),_c('h1',[_vm._v("What does liberty mean to you?")]),_vm._v(" "),_c('p',[_vm._v("Are you filmmaker, animator, video or digital artist or content creator? Due to COVID-19 we have all had our liberty challenged in some way in recent times so you could reflect on those experiences or what liberty means to you specifically or personally.")]),_vm._v(" "),_c('p'),_c('p',[_vm._v("Liberty Loop will be a special program of your creative responses to ‘liberty’. The program will be screened during Hobart Current 2021 Liberty : From Here to Here on Hobart’s big screen, The Loop: A Digital Art Platform for Hobart.")]),_vm._v(" "),_c('h2',[_vm._v("Why Liberty?")]),_vm._v(" "),_c('p',[_vm._v("Creative Director of Hobart Current 2021, Rosie Dennis, has provided LIBERTY as a provocation to ten artists as part of the Hobart Current exhibition in March 2021.\n\n\"This theme can be interpreted globally and locally, as celebrating the nation as a whole or a neighbourhood. I’m interested in sparking a fuller conversation about who chooses freedom for whom, in what space and during what time”.\n\nWe would now like to extend the invitation to you, the Hobart community, and get your thoughts, ideas, stories inspired by this theme.")]),_vm._v(" "),_c('h2',[_vm._v("When will it screen?")]),_vm._v(" "),_c('p',[_vm._v("\nLiberty Loop is currently scheduled to screen on The Loop during the Hobart Current: Liberty exhibition in March 2021.\n"),_c('br'),_vm._v("\nScreening times between:\n\n8 am–8 pm weekdays, 10 am–8 pm weekends\n")]),_vm._v(" "),_c('h2',[_vm._v("What can I submit?")]),_vm._v(" "),_c('p',[_vm._v("\nScreen art of all mediums will be considered including, short film, documentary, video and digital artworks, ambient works and interactive web art. \n"),_c('br'),_vm._v("For more information on The Loop and how to submit a work for consideration please visit www.theloophobart.com.au.\n"),_c('br'),_vm._v(" "),_c('b',[_vm._v("Submission Deadline: 10 March 2021.")])]),_vm._v(" "),_c('p',[_vm._v("\nFor support and all enquiries please contact "),_c('v-btn',{attrs:{"href":"mailto:publicart@hobartcity.com.au"}},[_c('span',{staticStyle:{"text-transform":"lowercase"}},[_vm._v("publicart@hobartcity.com.au")])]),_vm._v(" or contact Alex Hullah on (03) 6238 2565.\n")],1),_vm._v(" "),_c('p',[_vm._v("\n          To submit content for consideration go to:  "),_c('v-btn',{attrs:{"to":'/participate'}},[_c('span',{staticStyle:{"text-transform":"lowercase"}},[_vm._v("theloophobart.com.au/participate")])])],1)]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xx+M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y+QN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'imageUrl', 'videoUrl'],
  data: function data() {
    return {
      editDialog: false
    };
  },

  computed: {
    showDetails: function showDetails() {
      return this.content.showDetails;
    },
    uploading: function uploading() {
      return this.$store.getters.uploading;
    }
  },
  watch: {
    showDetails: function showDetails(val) {
      if (val) {
        this.editDialog = true;
      }
    }
  },
  methods: {
    doEdit: function doEdit() {
      this.$store.dispatch('updateContentData', this.content);
      this.editDialog = false;
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked: function onFilePicked(event) {
      var _this = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {

        _this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.$store.dispatch('replaceImage', { id: this.content.id, image: files[0] });
      //this.imageUrl = files[0]
    }
  }
});

/***/ }),

/***/ "YAQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"mt-0":"","fluid":""}},[_c('v-layout',{attrs:{"align-space-around":"","fill-height":"","row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":"","pl-2":"","pt-0":"","mt-0":""}},[_c('swatches',{staticStyle:{"display":"inline-block","top":"16px"},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"display":"inline-block","padding-top":"0px","margin-top":"0px","width":"70%"},model:{value:(_vm.playlistName),callback:function ($$v) {_vm.playlistName=$$v},expression:"playlistName"}},[_vm._v("New Playlist")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-2":"","pr-4":"","pt-0":"","mt-0":""}},[(_vm.playlists)?_c('v-combobox',{attrs:{"items":_vm.playlists,"item-text":"name","label":"Load Existing Playlist","return-object":"","hide-selected":""},model:{value:(_vm.loadedList),callback:function ($$v) {_vm.loadedList=$$v},expression:"loadedList"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{staticClass:"scroll-y",staticStyle:{"height":"75vh"},attrs:{"id":"scroll-target"}},[_c('v-layout',[_c('v-flex',{attrs:{"sm12":""}},[_c('draggable',{staticStyle:{"position":"relative"},attrs:{"id":"mainList","options":{group:'people'}},on:{"change":_vm.onChange},model:{value:(_vm.playlist),callback:function ($$v) {_vm.playlist=$$v},expression:"playlist"}},[_c('transition-group',{staticStyle:{"background-color":"#eee","min-height":"70vh","display":"block"}},_vm._l((_vm.playlist),function(element,ei){return _c('v-card',{key:element.tid+'_'+ei,attrs:{"id":element.tid,"min-height":_vm.mediaHeight(element),"color":element.color}},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""},on:{"click":function($event){_vm.currentElement=element}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[(element.type!='title')?_c('v-card-media',[(false)?_c('video',{attrs:{"src":element.videoUrl,"height":"110px","poster":element.imageUrl}}):_vm._e(),_vm._v(" "),(element.imageUrl)?_c('img',{attrs:{"src":element.imageUrl,"height":"110"},on:{"click":function($event){_vm.showDetails(element)}}}):_vm._e()]):_vm._e(),_vm._v(" "),(element.type=='title')?_c('div',{staticClass:"titlePreview"},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(element.title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(element.subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(element.body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(element.footer))])]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('v-card-text',[_c('h4',[_vm._v(_vm._s(element.title))]),_vm._v(" "),(element.type=='video')?_c('span',[_vm._v("Clip length: "+_vm._s(_vm.secToTime(element.duration))),_c('br')]):_vm._e(),_vm._v(" "),(element.type=='web')?_c('span',[_vm._v("URL: "+_vm._s(element.web)),_c('br')]):_vm._e(),_vm._v("\n                          "+_vm._s(element.type)+"\n                          Total duration: "+_vm._s(_vm.totalClipDuration(element))+"\n                      ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticStyle:{"right":"50px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"indigo"},on:{"click":function($event){_vm.editdialog=true}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"red"},on:{"click":function($event){_vm.removeMedia(element.tid)}}},[_c('v-icon',[_vm._v("delete")])],1),_c('br'),_c('br'),_vm._v(" "),(element.type=='video')?_c('v-text-field',{attrs:{"label":"loops","value":"1","type":"number"},on:{"click":function($event){_vm.textChange()}},model:{value:(element.loops),callback:function ($$v) {_vm.$set(element, "loops", $$v)},expression:"element.loops"}}):_vm._e()],1)],1)],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-footer',{staticStyle:{"position":"relative","bottom":"0px"},attrs:{"slot":"footer"},slot:"footer"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('span',[_c('b',[_vm._v("Duration "+_vm._s(this.secToTime(_vm.totalDuration)))])]),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},on:{"click":_vm.savePlaylist}},[_vm._v("Save")]),_vm._v(" "),(_vm.loadedList)?_c('v-btn',{staticStyle:{"float":"right"},on:{"click":function($event){_vm.updatePlaylist()}}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},on:{"click":_vm.clearPlaylist}},[_vm._v("Clear")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{class:{ 'v-btn--active': _vm.mediaMode=='playlist' },on:{"click":function($event){_vm.mediaMode='playlist'}}},[_vm._v("Playlists")]),_vm._v(" "),_c('v-btn',{class:{ 'v-btn--active': _vm.mediaMode=='media' },on:{"click":function($event){_vm.mediaMode='media'}}},[_vm._v("Media")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pr-4":""}},[_c('v-combobox',{attrs:{"items":_vm.keywords,"label":"Search by Keywords - select from list or add your own.","multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(_vm.keywordList),callback:function ($$v) {_vm.keywordList=$$v},expression:"keywordList"}})],1)],1),_vm._v(" "),_c('v-container',{staticClass:"scroll-y",staticStyle:{"max-height":"75vh"},attrs:{"id":"scroll-target2"}},[_c('v-layout',[(_vm.mediaMode=='playlist')?_c('v-flex',{attrs:{"sm12":""}},_vm._l((_vm.playlists),function(element){return _c('v-card',{key:element.id},[_c('v-container',{style:('background-color:'+element.color+';'),attrs:{"fluid":"","pt-2":"","mb-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"color":"#fff","margin-bottom":"10px"},attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(element.name)+" "+_vm._s(_vm.secToTime(element.duration))+" "+_vm._s(element.color)+"\n              "),_c('v-btn',{staticStyle:{"right":"50px","top":"0px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"#eee"},on:{"click":function($event){_vm.editPlaylist(element)}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"right":"80px","top":"0px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"#eee"},on:{"click":function($event){_vm.loadedList=element}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"top":"0px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"#eee"},on:{"click":function($event){_vm.deletePlaylist(element.id)}}},[_c('v-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow-x":"auto"}},_vm._l((element.items),function(item,i){return _c('img',{key:'itm'+i,staticStyle:{"width":"120px","height":"90px","background-color":"#333"},attrs:{"ma-1":"","src":_vm.getContent(item.id).imageUrl}})}))],1)],1)],1)})):_vm._e(),_vm._v(" "),(_vm.mediaMode=='media')?_c('v-flex',{attrs:{"sm12":""}},[_c('draggable',{attrs:{"options":{group:{ name:'people',  pull:'clone', put:false }},"move":_vm.checkMove,"clone":_vm.clone},model:{value:(_vm.mediaList),callback:function ($$v) {_vm.mediaList=$$v},expression:"mediaList"}},[_c('transition-group',_vm._l((_vm.mediaList),function(element){return (_vm.matchesKey(element))?_c('v-card',{key:element.id,attrs:{"height":_vm.mediaHeight(element),"color":element.color}},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":"","ma-2":"","pt-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[(element.type!='title')?_c('v-card-media',[_c('video',{attrs:{"src":element.videoUrl,"height":"110px","poster":element.imageUrl}})]):_vm._e(),_vm._v(" "),(element.type=='title')?_c('div',{staticClass:"titlePreview"},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(element.title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(element.subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(element.body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(element.footer))])]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-card-text',[_c('h4',[_vm._v(_vm._s(element.title))]),_vm._v(" "),(element.artist)?_c('span',[_vm._v(" "+_vm._s(element.artist)),_c('br')]):_vm._e(),_vm._v(" "),(element.type=='web')?_c('span',[_vm._v(" "+_vm._s(element.web)),_c('br')]):_vm._e(),_vm._v(" "),(element.type=='title')?_c('span',[_vm._v(" "+_vm._s(element.subtitle)),_c('br')]):_vm._e(),_vm._v(" "),(element.type=='video')?_c('span',[_vm._v(" Clip length: "+_vm._s(_vm.secToTime(element.duration))),_c('br')]):_vm._e(),_vm._v("\n                       "+_vm._s(element.type)+"\n                      ")])],1)],1)],1)],1):_vm._e()}))],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.editdialog),callback:function ($$v) {_vm.editdialog=$$v},expression:"editdialog"}},[(_vm.currentElement)?_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Edit Details")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          Type:"+_vm._s(_vm.currentElement.type)),_c('br'),_vm._v(" "),(_vm.editableDuration(_vm.currentElement.type))?_c('v-text-field',{attrs:{"label":"Duration"},model:{value:(_vm.currentElement.durationText),callback:function ($$v) {_vm.$set(_vm.currentElement, "durationText", $$v)},expression:"currentElement.durationText"}}):_vm._e(),_vm._v(" "),(_vm.currentElement.type=='video')?_c('v-text-field',{attrs:{"label":"Loops"},model:{value:(_vm.currentElement.loops),callback:function ($$v) {_vm.$set(_vm.currentElement, "loops", $$v)},expression:"currentElement.loops"}}):_vm._e(),_vm._v(" "),(_vm.currentElement.type=='video')?_c('p',[_vm._v("\n          Duration:"+_vm._s(_vm.secToTime(_vm.currentElement.duration*_vm.currentElement.loops))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentElement.type!='video' && !_vm.editableDuration(_vm.currentElement.type))?_c('p',[_vm._v("\n          Duration:"+_vm._s(_vm.secToTime(_vm.currentElement.totalDuration))+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.doEditChanges(_vm.currentElement.durationText);_vm.editdialog = false}}},[_vm._v("\n            Ok\n          ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.deletedialog),callback:function ($$v) {_vm.deletedialog=$$v},expression:"deletedialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Delete Playlist?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n         There is no going back once its gone its gone.\n         Deleting playlists that are in use by a schedule will cause errors. \n         \n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.deletedialog = false}}},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.confirmDelete()}}},[_vm._v("\n            Delete\n          ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Program__ = __webpack_require__("VY5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Events__ = __webpack_require__("vQVo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Skitfaced__ = __webpack_require__("wYvX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Current__ = __webpack_require__("B7Ey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Content_UploadSkitfaced__ = __webpack_require__("kUJE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Participate__ = __webpack_require__("uJaI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Opportunities__ = __webpack_require__("/huF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Slowbart__ = __webpack_require__("0w4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LibertyLoop__ = __webpack_require__("6FS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_WeAreOne__ = __webpack_require__("JvTL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Involved__ = __webpack_require__("vbtM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Content_Contents__ = __webpack_require__("I77Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Content_Playlist__ = __webpack_require__("8qSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Submissions__ = __webpack_require__("G/M5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Content_Schedule__ = __webpack_require__("0jUY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Content_UploadContent__ = __webpack_require__("96hL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Content_UploadNew__ = __webpack_require__("UeCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_User_Profile__ = __webpack_require__("Dqi8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Control_Controls__ = __webpack_require__("FRY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Play_Colour__ = __webpack_require__("4N5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Play_WebCam__ = __webpack_require__("1n4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Play_volume__ = __webpack_require__("NWNW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Play_Pixel__ = __webpack_require__("lKdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_User_Signup__ = __webpack_require__("eu7k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_User_Signin__ = __webpack_require__("ixtv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__auth_guard__ = __webpack_require__("hlOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__admin_guard__ = __webpack_require__("ATei");

































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, { path: '/home',
    name: 'Home2',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/program',
    name: 'Program',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Program__["a" /* default */]
  }, {
    path: '/submissions',
    name: 'Submissions',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Submissions__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About__["a" /* default */]
  }, {
    path: '/participate',
    name: 'Participate',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Participate__["a" /* default */]
  }, {
    path: '/opportunities',
    name: 'Opportunities',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Opportunities__["a" /* default */]
  }, {
    path: '/slowbart',
    name: 'Slowbart',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Slowbart__["a" /* default */]
  }, {
    path: '/libertyloop',
    name: 'LibertyLoop',
    component: __WEBPACK_IMPORTED_MODULE_13__components_LibertyLoop__["a" /* default */]
  }, {
    path: '/weareone',
    name: 'WeAreOne',
    component: __WEBPACK_IMPORTED_MODULE_14__components_WeAreOne__["a" /* default */]
  }, {
    path: '/events',
    name: 'Events',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Events__["a" /* default */]
  }, {
    path: '/current',
    name: 'Current',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Current__["a" /* default */]
  }, {
    path: '/skitfaced',
    name: 'Skitfaced',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Skitfaced__["a" /* default */]
  }, {
    path: '/uploadskitfaced',
    name: 'UploadSkitfaced',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Content_UploadSkitfaced__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Contact__["a" /* default */]
  }, {
    path: '/involved',
    name: 'Involved',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Involved__["a" /* default */]
  }, {
    path: '/content',
    name: 'Contents',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Content_Contents__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_31__admin_guard__["a" /* default */]
  }, {
    path: '/playlist',
    name: 'Playlist',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Content_Playlist__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_31__admin_guard__["a" /* default */]
  }, {
    path: '/schedule',
    name: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Content_Schedule__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_31__admin_guard__["a" /* default */]
  }, {
    path: '/content/new',
    name: 'UploadContent',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Content_UploadContent__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_30__auth_guard__["a" /* default */]
  }, {
    path: '/content/new2',
    name: 'UploadNew',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Content_UploadNew__["a" /* default */]
  }, {
    path: '/controls',
    name: 'Controls',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Control_Controls__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_31__admin_guard__["a" /* default */]
  }, {
    path: '/play/colour/:mode',
    name: 'Colour',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Play_Colour__["a" /* default */]
  }, {
    path: '/colour',
    name: 'Colour',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Play_Colour__["a" /* default */]
  }, {
    path: '/play/colour',
    name: 'Colour2',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Play_Colour__["a" /* default */]
  }, {
    path: '/play/webcam',
    name: 'WebCam2',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Play_WebCam__["a" /* default */]
  }, {
    path: '/play/volume',
    name: 'Volume',
    component: __WEBPACK_IMPORTED_MODULE_26__components_Play_volume__["a" /* default */]
  }, {
    path: '/pixel',
    name: 'Pixel',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Play_Pixel__["a" /* default */]
  }, {
    path: '/play/pixel',
    name: 'Pixel2',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Play_Pixel__["a" /* default */]
  }, {
    path: '/play/pixel/:mode',
    name: 'Pixel2m',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Play_Pixel__["a" /* default */]
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_22__components_User_Profile__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_30__auth_guard__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_28__components_User_Signup__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_29__components_User_Signin__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ "YcGa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// https://wordtohtml.net/ to convert text to html
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {

    this.$store.dispatch("loadEventsStatus");
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({
        colour: "#00000044",
        height: 30,
        pad: 3,
        width: Math.random() * 50 + 50,
        child: childA
      });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    currentEvent: function currentEvent() {
      return this.$store.getters.getCurrentEvent;
    },
    currentEvents: function currentEvents() {
      return this.$store.getters.getCurrentEvents;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    qstring: function qstring() {
      return window.location.search.substr(1);
    },
    showEvent: function showEvent(title) {
      if (this.qstring()) {
        return this.qstring() == escape(title);
      } else {
        return true;
      }
    },
    glitch: function glitch() {
      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "ZDxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zfyi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"mt-0":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('h3',[_vm._v(_vm._s(_vm.user.email)+" - Previous Submissions")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs7":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"to":"/content/new"}},[_c('v-icon',[_vm._v("movie")]),_vm._v(" Upload Content")],1),_vm._v(" "),_c('v-btn',{staticStyle:{"display":"inline-block"},on:{"click":_vm.onLogout}},[_c('v-icon',[_vm._v("exit_to_app")]),_vm._v(" "),_c('span',[_vm._v("Logout")])],1)],1)],1),_vm._v(" "),_c('p'),_vm._v(" "),_vm._l((_vm.contents),function(content){return _c('v-layout',{key:content.id},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-card',{staticClass:"card"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":"","sm4":"","md3":""}},[_c('v-card-media',{attrs:{"src":content.imageUrl,"height":"130px"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","sm8":"","md9":""}},[_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":""}},[_c('div',[_c('h5',{staticClass:"balck--text  mb-0"},[_vm._v(_vm._s(content.title))]),_vm._v(" "),_c('div',[_vm._v("Artist: "+_vm._s(content.artist))]),_vm._v(" "),_c('div',[_vm._v("Uploaded: "+_vm._s(_vm._f("date")(content.date)))])])]),_vm._v(" "),_c('v-card-actions',[_c('app-view-content-details-dialog',{attrs:{"videoUrl":content.videoUrl,"imageUrl":content.imageUrl,"content":content}})],1)],1)],1)],1)],1)],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 200
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "afOU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      glitches: null,
      glitchCount: 20,
      glitchTop: 0
    };
  },
  mounted: function mounted() {
    this.glitches = [];
    var childA = [];
    for (var i = 0; i < 8; i++) {
      childA = [];
      for (var p = 0; p < 2; p++) {
        childA.push(Math.floor(Math.random() * 100));
      }
      this.glitches.push({ colour: '#00000044', height: 30, pad: 3, width: Math.random() * 50 + 50, child: childA });
    }
    setTimeout(this.glitch, 100);
  },

  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    glitch: function glitch() {

      this.glitchCount++;
      if (this.glitchCount > 50) {
        this.glitchCount = Math.random() * 20 - 10;
        this.glitchTop = Math.random() * 400 + 100;
      }
      if (this.glitchCount > 10) {
        this.glitchCount += Math.random() * 40;
        setTimeout(this.glitch, Math.random() * 100 + 100);

        return;
      }

      for (var g in this.glitches) {
        if (Math.random() * 10 > 7) {
          this.glitches[g].height = Math.random() * 20 + 5;
          for (var gc in this.glitches[g].child) {
            this.glitches[g].child[gc] = Math.floor(Math.random() * 160 + 20);
          }
          if (Math.random() * 10 > 5) {
            this.glitches[g].height = 0;
          }
        }
        this.glitches[g].pad = Math.floor(Math.random() * 5 + 5);
        this.glitches[g].width = Math.floor(Math.random() * 160 + 20);
      }
      if (Math.random() * 10 > 5) {
        // this.glitchTop=Math.random()*400+100;
      }
      setTimeout(this.glitch, 100);
    }
  }
});

/***/ }),

/***/ "b6Vx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bM7r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bVyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      deviceVolume: "~"
    };
  },
  mounted: function mounted() {
    if (this.status) {
      if (this.status.deviceVolume) {
        this.deviceVolume = parseFloat(this.status.deviceVolume);
      }
    }
  },

  computed: {
    status: function status() {
      //return false;
      return this.$store.getters.getStatus;
    },
    natVol: function natVol() {
      return Math.floor(Math.pow(10, this.deviceVolume / 10) * 10);
    }
  },

  methods: {
    volumeUp: function volumeUp() {
      this.$store.dispatch('sendCommand', { cmd: 'volumeUp' });
    },
    volumeDown: function volumeDown() {
      //this.$store.dispatch('setControlsVolume', 90);
      this.$store.dispatch('sendCommand', { cmd: 'volumeDown' });
    },
    volumeReset: function volumeReset(vol) {
      this.$store.dispatch('setControlsVolume', vol);
    }
  },
  watch: {
    status: function status(value) {

      console.log("HAVE status", value);
      if (value.deviceVolume) {
        this.deviceVolume = parseFloat(value.deviceVolume).toFixed(1);
      }
    }
  }
});

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8856cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("xRF4");
function injectStyle (ssrContext) {
  __webpack_require__("4ec5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b8856cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8856cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cK6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"ma-0":"","pa-0":"","fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","pa-0":"","fill-height":""}},[(_vm.screenMode)?_c('div',{staticClass:"screenColor",style:({ backgroundColor: _vm.colour})}):_vm._e(),_vm._v(" "),(!_vm.screenMode)?_c('div',{staticStyle:{"position":"absolute"}},[_c('div',{staticClass:"screenPreview",style:({backgroundColor: _vm.colour, width:'136px',height:'81px',display:'inline-block',position:'relative',top:'10px',left:'10px',paddingTop:'20%','text-align':'center'})},[_vm._v("Screen Colour")])]):_vm._e(),_vm._v(" "),(!_vm.screenMode)?_c('canvas',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"colorspace"}}):_vm._e(),_vm._v(" "),(_vm.screenMode)?_c('div',{staticClass:"screenText"},[_vm._v("Colour the screen at www.theloophobart.com.au/colour")]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cQCs":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "dCI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onCreateContent($event)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","pr-3":""}},[(_vm.mode=='video')?_c('div',{attrs:{"id":"videoHolder"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.videoUrl),expression:"!videoUrl"}],staticClass:"aspect"},[_c('h2',[_vm._v(_vm._s(_vm.videoText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.videoUrl),expression:"!videoUrl"}],staticClass:"videoBase"},[_c('h2',[_vm._v(_vm._s(_vm.videoDetails))])]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoUrl),expression:"videoUrl"}],attrs:{"id":"video1","width":"100%","src":_vm.videoUrl,"type":"video/mp4","controls":""}}),_vm._v(" "),(false)?_c('img',{staticClass:"ledOverlay",attrs:{"src":require("../../assets/images/screenOverlay.png"),"width":"100%"}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickVideo}},[_vm._v("Select Video")]),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-radio-group',{staticStyle:{"display":"inline-block","float":"right"},attrs:{"row":""},model:{value:(_vm.contentInfo.scaleMode),callback:function ($$v) {_vm.$set(_vm.contentInfo, "scaleMode", $$v)},expression:"contentInfo.scaleMode"}},[_vm._v("\n               Scale Content   \n               "),_c('v-radio',{attrs:{"label":"None","value":"none"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Fit","value":"fit"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Fill","value":"fill"}})],1),_vm._v(" "),(false)?_c('v-btn',{on:{"click":_vm.getScreenGrab}},[_vm._v("Snapshot")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mode=='web')?_c('div',{attrs:{"id":"webHolder"}},[(!_vm.webURL)?_c('h5',{staticClass:"primary--text"},[_vm._v("Submit URL")]):_vm._e(),_vm._v(" "),(_vm.webURL)?_c('vue-friendly-iframe',{attrs:{"src":_vm.webURL,"id":"webFrame"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"URL","label":"URL","id":"description"},model:{value:(_vm.webURLInput),callback:function ($$v) {_vm.webURLInput=$$v},expression:"webURLInput"}}),_vm._v(" "),(false)?_c('img',{staticClass:"ledOverlay",attrs:{"src":require("../../assets/images/screenOverlay.png"),"width":"100%"}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickUrl}},[_vm._v("Select URL")]),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),(_vm.mode=='title')?_c('div',[_c('h5',{staticClass:"primary--text"},[_vm._v("Title Card")]),_vm._v(" "),_c('div',{attrs:{"id":"cardHolder"}},[_c('div',{staticClass:"cTitle"},[_vm._v(_vm._s(_vm.contentInfo.title))]),_vm._v(" "),_c('div',{staticClass:"cSubtitle"},[_vm._v(_vm._s(_vm.contentInfo.subtitle))]),_vm._v(" "),_c('div',{staticClass:"cBody"},[_vm._v(_vm._s(_vm.contentInfo.body))]),_vm._v(" "),_c('div',{staticClass:"cFooter"},[_vm._v(_vm._s(_vm.contentInfo.footer))])]),_vm._v(" "),_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.contentInfo.title),callback:function ($$v) {_vm.$set(_vm.contentInfo, "title", $$v)},expression:"contentInfo.title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"subtitle","label":"Subtitle","id":"subtitle"},model:{value:(_vm.contentInfo.subtitle),callback:function ($$v) {_vm.$set(_vm.contentInfo, "subtitle", $$v)},expression:"contentInfo.subtitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"body","label":"Body","id":"body"},model:{value:(_vm.contentInfo.body),callback:function ($$v) {_vm.$set(_vm.contentInfo, "body", $$v)},expression:"contentInfo.body"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"footer","label":"Footer","id":"footer"},model:{value:(_vm.contentInfo.footer),callback:function ($$v) {_vm.$set(_vm.contentInfo, "footer", $$v)},expression:"contentInfo.footer"}}),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),(_vm.mode=='message')?_c('div',[_c('h2',[_vm._v("Participate")]),_vm._v(" "),_c('p',[_vm._v("The Loop takes submissions for content throughout the year. It’s open to artists, curators, and community-members and organisations who work with creative screen-based media."),_c('br'),_vm._v("The Loop does not accept advertising or promotional material."),_c('br'),_vm._v("To submit content for consideration, upload a file here.")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('video')}}},[_vm._v("Upload Video")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('web')}}},[_vm._v("Submit Web Content")]),_vm._v(" "),(_vm.isCurator)?_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('title')}}},[_vm._v("Create Title Card")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mode!='message')?_c('v-container',{attrs:{"pl-3":"","pr-1":""}},[_c('v-layout',{attrs:{"fluid":""}},[(_vm.uploading())?_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-linear',{model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"text-xs-right":""}},[_c('v-flex',{attrs:{"xs1":"","text-xs-left":""}},[(_vm.uploading())?_c('span',[_vm._v(_vm._s(_vm.progressText))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('span',[_vm._v("Please review your content before uploading ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"disabled":!_vm.formIsValid || _vm.uploading(),"type":"submit"}},[_vm._v("Upload Content")])],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.mode!='title')?_c('v-flex',{attrs:{"xs12":"","sm3":""}},[(_vm.mode!='title')?_c('div',{attrs:{"id":"imageHolder"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.imageUrl),expression:"!imageUrl"}],staticClass:"aspect"},[_c('h5',[_vm._v("Poster Image")])]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageUrl),expression:"imageUrl"}],attrs:{"src":_vm.imageUrl,"width":"100%"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":"","disabled":_vm.uploading()},on:{"click":_vm.onPickFile}},[_vm._v("Select Image")])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.contentInfo.title),callback:function ($$v) {_vm.$set(_vm.contentInfo, "title", $$v)},expression:"contentInfo.title"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"author","label":"Artist","id":"author","rules":_vm.notEmpty,"required":""},model:{value:(_vm.contentInfo.author),callback:function ($$v) {_vm.$set(_vm.contentInfo, "author", $$v)},expression:"contentInfo.author"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"name":"description","label":"Description","id":"description","required":""},model:{value:(_vm.contentInfo.description),callback:function ($$v) {_vm.$set(_vm.contentInfo, "description", $$v)},expression:"contentInfo.description"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.keywords,"label":"Keywords - select from list or add your own.","multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(_vm.contentInfo.keywords),callback:function ($$v) {_vm.$set(_vm.contentInfo, "keywords", $$v)},expression:"contentInfo.keywords"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Add title to start of content"},model:{value:(_vm.contentInfo.addTitle),callback:function ($$v) {_vm.$set(_vm.contentInfo, "addTitle", $$v)},expression:"contentInfo.addTitle"}}),_vm._v(" "),_c('app-view-content-details-dialog',{attrs:{"videoUrl":_vm.videoUrl,"imageUrl":_vm.imageUrl,"content":_vm.contentInfo}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}}),_vm._v(" "),_c('input',{ref:"videoInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"video/mp4"},on:{"change":_vm.onVideoPicked}})])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eNiQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eR0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewContentDialogue_vue__ = __webpack_require__("Y+QN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34906e56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewContentDialogue_vue__ = __webpack_require__("5FE9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewContentDialogue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34906e56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewContentDialogue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ef7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eu7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__("xeWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c1b27b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__("ScRz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c1b27b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fgVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card-text',[_c('h3',[_vm._v("You only need to sign in if you are going to upload content.")]),_vm._v(" "),_c('v-container'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSignin($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),(_vm.showForgot)?_c('div',{staticClass:"forgot",on:{"click":_vm.doForgot}},[_vm._v("Reset Password")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("Sign In\n            "),_c('span',{staticClass:"customLoader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading},on:{"click":_vm.onSigninGoogle}},[_vm._v("Sign In With Google\n            "),_c('span',{staticClass:"customLoader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fpIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe__ = __webpack_require__("QhtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__("2Pnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  //Vue.component('vue-friendly-iframe', VueFriendlyIframe);
  components: { VueFriendlyIframe: __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe___default.a, Checkbox: __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a },
  data: function data() {
    return {
      mode: "message",
      enableVideoUpload: false,
      uploadStarted: false,
      videoText: '[ MP4 files Only - NB Large Files may not Preview ]',
      videoDetails: "",
      valid: true,
      imageUrl: '',
      videoUrl: '',
      webURL: '',
      webURLInput: '',
      date: new Date(),
      time: new Date(),
      contentInfo: {
        title: '',
        author: '',
        image: '',
        video: '',
        videoSize: '',
        description: '',
        duration: '',
        type: 'video',
        addTitle: false,
        keywords: [],
        date: new Date(),
        scaleMode: 'none',
        mode: "created"
      },

      keywords: ['UTAS', 'Student', 'Wide Angle', 'The Loop', 'Test'],
      notEmpty: [function (v) {
        return !!v || 'can\'t be empty';
      }],
      titleRules: [function (v) {
        return !!v || 'Title is required';
      }, function (v) {
        return v && v.length >= 2 || 'Title is too short';
      }]
    };
  },

  computed: {
    newContent: function newContent() {
      return this.$store.getters.newContent;
    },
    progress: function progress() {
      return this.$store.getters.progress;
    },
    progressText: function progressText() {
      var pct = (Math.floor(this.progress * 100) * .01 + "").substr(0, 5);
      if (pct.length == 1) {
        pct += ".00";
      }
      if (pct.length == 2) {
        pct += ".00";
      }
      if (pct.length == 3) {
        pct += "0";
      }
      if (pct.length == 4 && this.progress > 10) {
        pct += "0";
      }
      return pct + "%";
    },
    formIsValid: function formIsValid() {
      return this.contentInfo.title !== '' && (this.contentInfo.author !== '' || this.mode == 'title') && (this.imageUrl !== '' || this.mode != 'web') && (
      //(this.contentInfo.video !== '' || this.mode!=='video' ) &&
      this.webUrl !== '' || this.mode !== 'web') && (this.contentInfo.description !== '' || this.mode == 'title');
    },
    fullDateTime: function fullDateTime() {
      var date = new Date(this.date);
      if (typeof this.time === 'string') {
        var hours = this.time.match(/^(\d+)/)[1];
        var minutes = this.time.match(/:(\d+)/)[1];
        date.setHours(hours);
        date.setMinutes(minutes);
      } else {
        date.setHours(this.time.getHours());
        date.setMinutes(this.time.getMinutes());
      }
      return date;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    isCurator: function isCurator() {
      return this.$store.getters.userCurator;
    }
  },
  watch: {
    newContent: function newContent(value) {
      console.log("NEW CONTENT", value);
      this.contentInfo.id = value.id;
      if (value.type == "video") {
        this.enableVideoUpload = true;
      }
    }
  },
  methods: {
    setType: function setType(type) {
      this.mode = type;
      this.contentInfo.type = type;
    },
    getScreenGrab: function getScreenGrab() {

      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector("#webFrame").querySelector("body")).then(function (canvas) {
        document.body.appendChild(canvas);
      });

      canvas = document.getElementById("c");
      var storageRef = firebase.storage().ref();
      var mountainsRef = storageRef.child('mountains.jpg');
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      var uploadTask = storageRef.child('images/' + "apple").put(image);
      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // See below for more detail
      }, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        var downloadURL = uploadTask.snapshot.downloadURL;
      });
    },
    uploading: function uploading() {
      if (!this.$store.getters.uploading && this.uploadStarted) {
        this.uploadStarted = false;
        this.$router.push('/profile');
      } else if (this.$store.getters.uploading) {
        this.uploadStarted = true;
      }
      return this.$store.getters.uploading;
    },
    onCreateContent: function onCreateContent() {
      console.log("CREATE CONTENT");
      if (!this.formIsValid) {
        return;
      }
      if (!this.contentInfo.image && this.mode != "title") {
        //return
      }
      if (!this.contentInfo.video && this.mode == "video") {
        // return
      }
      if (!this.contentInfo.web && this.mode == "web") {
        return;
      }

      this.$store.dispatch('createContentInfo', this.contentInfo);
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onPickVideo: function onPickVideo() {
      this.contentInfo.web = "";
      this.$refs.videoInput.click();
    },
    addVideo: function addVideo() {
      this.$store.dispatch('replaceVideo', this.contentInfo);
    },
    onPickUrl: function onPickUrl() {
      this.contentInfo.web = this.webURLInput;
      this.contentInfo.video = "";
      this.webURL = this.webURLInput;
    },
    onVideoPicked: function onVideoPicked(event) {
      var _this = this;

      var self = this;
      this.videoText = "loading preview ";
      var files = event.target.files;

      var filename = files[0].name;
      this.videoDetails = "file:" + filename + " size:" + Math.round(files[0].size / 1024 / 1024) + "MB";
      console.log(files[0]);

      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function (data) {
        console.log("LOADING", fileReader);
        console.log("LOADING2", data);
      });
      fileReader.addEventListener('progress', function (data) {
        console.log("progress", data);
        _this.videoText = "loading preview " + data.loaded;
      });
      fileReader.addEventListener('loadend', function (data) {
        console.log("LOADED", fileReader, data);
        _this.videoUrl = fileReader.result;
      });

      this.videoText = "File too large to preview please continue with submission or upload a smaller file";
      this.contentInfo.video = files[0];
    },
    onFilePicked: function onFilePicked(event) {
      var _this2 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this2.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.contentInfo.image = files[0];
    }
  }
});

/***/ }),

/***/ "g9Wq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"mt-0":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Screen Output")]),_vm._v(" "),(_vm.status.ftb=='True')?_c('v-btn',{attrs:{"color":"red"},on:{"click":function($event){_vm.sendCommand(_vm.ftbBtn)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(_vm._s('tv_off'))]),_vm._v("\n     "+_vm._s('OFF')+"\n    ")],1):_vm._e(),_vm._v(" "),(_vm.status.ftb!='True')?_c('v-btn',{attrs:{"color":"green"},on:{"click":function($event){_vm.sendCommand(_vm.ftbBtn)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(_vm._s('tv'))]),_vm._v("\n     "+_vm._s('ON')+"\n    ")],1):_vm._e(),_vm._v(" "),(_vm.status.muted=='True')?_c('v-btn',{attrs:{"color":"red"},on:{"click":function($event){_vm.sendCommand(_vm.muteBtn)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_mute")]),_vm._v("\n     "+_vm._s('OFF')+"\n    ")],1):_vm._e(),_vm._v(" "),(_vm.status.muted!='True')?_c('v-btn',{attrs:{"color":"green"},on:{"click":function($event){_vm.sendCommand(_vm.muteBtn)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_up")]),_vm._v("\n     "+_vm._s('ON')+"\n    ")],1):_vm._e(),_vm._v("\n    version:"+_vm._s(_vm.version)+"\n    ")],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":"","pt-2":""}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Volume: "+_vm._s(_vm.deviceVolume))]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.volumeDown()}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_down")]),_vm._v("-")],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.volumeUp()}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_up")]),_vm._v("+")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Heading"},model:{value:(_vm.heading),callback:function ($$v) {_vm.heading=$$v},expression:"heading"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","ml-4":""}},[_c('v-text-field',{attrs:{"label":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('v-btn',{on:{"click":_vm.sendMessage}},[_vm._v("Send")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',_vm._l((_vm.controls),function(control){return _c('div',{key:control.id,staticStyle:{"display":"inline-block"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.sendCommand(control)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v(_vm._s(control.icon))]),_vm._v("\n     "+_vm._s(control.label)),(control.param)?_c('v-text-field',{staticClass:"buttonInput",attrs:{"label":"Solo","solo":""},model:{value:(control.param),callback:function ($$v) {_vm.$set(control, "param", $$v)},expression:"control.param"}}):_vm._e()],1),_vm._v("\n    "+_vm._s(control.title)+"\n    ")],1)}))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{on:{"click":_vm.downloadFiles}},[_vm._v("Download Files")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.openPlaylist}},[_vm._v("Open Preset")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.startPlaylist}},[_vm._v("Start Playlist")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.stopPlaylist}},[_vm._v("Stop Playlist")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{on:{"click":_vm.getInfo}},[_vm._v("Get Info")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.refresh}},[_vm._v("Refresh")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('div',_vm._l((_vm.mediaBtns),function(btn){return (_vm.status)?_c('v-btn',{key:btn.id,class:{active:_vm.status.active==btn.label, preview:_vm.status.preview==btn.label},attrs:{"color":"primary"},on:{"click":function($event){_vm.preview(btn)}}},[_vm._v("\n    \n     "+_vm._s(_vm.btnText(btn))+"\n      "),(btn.image)?_c('img',{attrs:{"src":btn.image,"height":"35px"}}):_vm._e()]):_vm._e()}))])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',_vm._l((_vm.scheduals),function(sch){return _c('v-btn',{key:sch.id,on:{"click":function($event){_vm.openPreset(sch)}}},[_vm._v("\n     "+_vm._s(sch.title)+" \n    ")])}))],1),_vm._v(" "),(_vm.status)?_c('div',[_vm._v(_vm._s(_vm.status.active)),_c('br'),_vm._v(_vm._s(_vm.status.message))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gMGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"mt-0":"","fluid":""}},[_c('v-layout',{attrs:{"align-space-around":"","fill-height":"","row":""}},[_c('v-flex',{attrs:{"sm5":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('swatches',{model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}}),_vm._v(" "),_c('v-flex',{attrs:{"pl-2":""}},[_c('v-text-field',{model:{value:(_vm.scheduleName),callback:function ($$v) {_vm.scheduleName=$$v},expression:"scheduleName"}},[_vm._v("New Schedule")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event}},model:{value:(_vm.dateModal),callback:function ($$v) {_vm.dateModal=$$v},expression:"dateModal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"StartDate","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.dateModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.dialog.save(_vm.date)}}},[_vm._v("OK")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.dateModal = false}}},[_vm._v("Cancel")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-dialog',{ref:"timedialog",attrs:{"return-value":_vm.time,"persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){_vm.time=$event}},model:{value:(_vm.timeModal),callback:function ($$v) {_vm.timeModal=$$v},expression:"timeModal"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Time","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),(_vm.timeModal)?_c('v-time-picker',{attrs:{"full-width":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.timeModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.timedialog.save(_vm.time)}}},[_vm._v("OK")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"scroll-y",staticStyle:{"height":"calc(100vh - 260px)"},attrs:{"id":"scroll-target"}},[_c('v-layout',[_c('v-flex',{attrs:{"sm12":""}},[_c('draggable',{staticStyle:{"position":"relative"},attrs:{"id":"mainList","options":{group:'people'},"move":_vm.checkMove},on:{"change":_vm.onChange},model:{value:(_vm.schedule),callback:function ($$v) {_vm.schedule=$$v},expression:"schedule"}},[_c('transition-group',{staticStyle:{"background-color":"#eee","min-height":"70vh","display":"block"}},_vm._l((_vm.schedule),function(element,index){return _c('v-card',{key:element.id+'-'+index,ref:element.id,refInFor:true,class:{highlight:_vm.currentElement==element},staticStyle:{"min-height":"60px","overflow":"hidden"},attrs:{"id":element.id,"height":_vm.mediaHeight(element)}},[_c('v-container',{style:('height:90%;background-color:'+element.color+';'),attrs:{"fluid":"","pt-2":"","mb-0":""},on:{"click":function($event){_vm.currentElement=element}}},[_c('v-layout',{attrs:{"row":"","wrap":"","fill-height":""}},[_c('v-flex',{staticStyle:{"margin-bottom":"10px"},attrs:{"xs10":""}},[_vm._v("\n             \n             "+_vm._s(element.type)+" "+_vm._s(element.title)+" "+_vm._s(element.name)+" Starting:"+_vm._s(element.time)+" Duration:"+_vm._s(element.durationText)+"\n             "),(element.type=='URL')?_c('div',[_vm._v(_vm._s(element.link))]):_vm._e(),_vm._v("\n             - "+_vm._s(element.pListIndex)+"\n             "),(element.pListId)?_c('span',[_vm._v(_vm._s(_vm.getPlaylist(element.pListId).color))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticStyle:{"right":"50px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"indigo"},on:{"click":function($event){_vm.editdialog=true}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"red"},on:{"click":function($event){_vm.deleteItem(element,index)}}},[_c('v-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow-x":"auto","overflow-y":"hidden"},attrs:{"fill-height":""}},[(element.type!=='playlist' && element.imageUrl)?_c('v-img',{staticStyle:{"width":"120px","height":"90px","background-color":"#333"},attrs:{"ma-1":"","src":element.imageUrl}}):_vm._e(),_vm._v(" "),(element.type=='title')?_c('div',{staticClass:"titlePreview",staticStyle:{"min-height":"120px","background-color":"#333"}},[_c('div',{class:_vm.pTitle},[_vm._v(_vm._s(element.title))]),_vm._v(" "),_c('div',{class:_vm.pSubtitle},[_vm._v(_vm._s(element.subtitle))]),_vm._v(" "),_c('div',{class:_vm.pBody},[_vm._v(_vm._s(element.body))]),_vm._v(" "),_c('div',{class:_vm.pFooter},[_vm._v(_vm._s(element.footer))])]):_vm._e(),_vm._v(" "),(element.type=='playlist')?_c('div',_vm._l((element.items),function(item,it){return _c('v-img',{key:'itt'+it,staticStyle:{"width":"100px","max-height":"100px","background-color":"#333"},attrs:{"ma-1":"","fill-height":"","src":_vm.getContent(item.id).imageUrl}},[(_vm.getContent(item.id).type=='title')?_c('div',{staticClass:"titlePreview"},[_c('div',{class:_vm.pTitle},[_vm._v(_vm._s(_vm.getContent(item.id).title))]),_vm._v(" "),_c('div',{class:_vm.pSubtitle},[_vm._v(_vm._s(_vm.getContent(item.id).subtitle))]),_vm._v(" "),_c('div',{class:_vm.pBody},[_vm._v(_vm._s(_vm.getContent(item.id).body))]),_vm._v(" "),_c('div',{class:_vm.pFooter},[_vm._v(_vm._s(_vm.getContent(item.id).footer))])]):_vm._e()])})):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[(element.type=='video')?_c('div',{staticStyle:{"text-align":"right","padding-top":"10px"}},[_vm._v("Loops:"+_vm._s(element.loops))]):_vm._e()])],1)],1)],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-footer',{staticStyle:{"position":"relative","bottom":"0px"},attrs:{"slot":"footer"},slot:"footer"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('div',{staticStyle:{"line-height":"50px","margin-top":"50px","margin-left":"23px"}},[_c('b',[_vm._v("Duration "+_vm._s(this.secToTime(_vm.totalDuration)))])]),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},on:{"click":function($event){_vm.saveSchedule(false)}}},[_vm._v("Save")]),_vm._v(" "),(_vm.currentSchedule)?_c('v-btn',{staticStyle:{"float":"right"},on:{"click":function($event){_vm.saveSchedule(true)}}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(_vm.currentSchedule)?_c('v-btn',{staticStyle:{"float":"right"},on:{"click":function($event){_vm.showSchedule=true}}},[_vm._v("Show")]):_vm._e(),_vm._v(" "),(_vm.currentSchedule)?_c('v-btn',{staticStyle:{"float":"right"},on:{"click":_vm.deploySchedule}},[_vm._v("Deploy")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},on:{"click":_vm.clean}},[_vm._v("Clear")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","offset-xs1":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","pl-1":"","pt-0":"","mt-0":""}},[_c('v-btn',{class:{ 'v-btn--active': _vm.mediaMode=='schedule' },on:{"click":function($event){_vm.mediaMode='schedule'}}},[_vm._v("Schedules")]),_vm._v(" "),_c('v-btn',{class:{ 'v-btn--active': _vm.mediaMode=='playlist' },on:{"click":function($event){_vm.mediaMode='playlist'}}},[_vm._v("Playlists")]),_vm._v(" "),_c('v-btn',{class:{ 'v-btn--active': _vm.mediaMode=='media' },on:{"click":function($event){_vm.mediaMode='media'}}},[_vm._v("Media")]),_vm._v(" "),_c('v-btn',{class:{ 'v-btn--active': _vm.mediaMode=='source' },on:{"click":function($event){_vm.mediaMode='source'}}},[_vm._v("Sources")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"scroll-y",staticStyle:{"height":"75vh"},attrs:{"fill-height":"","fluid":"","id":"scroll-target2"}},[_c('v-layout',[_c('v-flex',{attrs:{"sm12":""}},[(_vm.mediaMode=='schedule')?_c('div',_vm._l((_vm.scheduals),function(element){return _c('v-card',{key:element.id,attrs:{"dark":""}},[_c('v-container',{style:('background-color:'+element.color+';'),attrs:{"fluid":"","pt-2":"","mb-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"color":"#fff","margin-bottom":"10px"},attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(element.title)+" "+_vm._s(_vm.secToTime(element.duration))+" "+_vm._s(element.color)+"\n              "),_c('v-btn',{staticStyle:{"right":"50px","top":"0px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"#eee"},on:{"click":function($event){_vm.editSchedule(element,true)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticStyle:{"top":"0px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"#eee"},on:{"click":function($event){_vm.deleteSchedule(element.id)}}},[_c('v-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow-x":"auto"}},_vm._l((element.items),function(item,key){return _c('div',{attrs:{"ma-1":""}},[(item)?_c('div',[(_vm.getContent(item.id))?_c('v-img',{staticStyle:{"width":"120px","height":"90px","background-color":"#ccc"},attrs:{"src":_vm.getContent(item.id).imageUrl}},[(_vm.getContent(item.id).type=='title')?_c('div',{staticClass:"titlePreview"},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.getContent(item.id).title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(_vm.getContent(item.id).subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(_vm.getContent(item.id).body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(_vm.getContent(item.id).footer))])]):_vm._e()]):_vm._e()],1):_vm._e()])}))],1)],1)],1)})):_vm._e(),_vm._v(" "),(_vm.mediaMode=='playlist')?_c('draggable',{attrs:{"options":{group:{ name:'people',  pull:'clone', put:false }},"move":_vm.checkMove,"clone":_vm.clone},model:{value:(_vm.playlists),callback:function ($$v) {_vm.playlists=$$v},expression:"playlists"}},[_c('transition-group',_vm._l((_vm.playlists),function(element,index){return _c('v-card',{key:element.id+'_'+index,attrs:{"dark":""}},[_c('v-container',{style:('background-color:'+element.color+';'),attrs:{"fluid":"","pt-2":"","mb-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"color":"#fff","margin-bottom":"10px"},attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(element.name)+" "+_vm._s(_vm.secToTime(element.duration))+" "+_vm._s(element.color)+"\n             ")]),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow-x":"auto"}},_vm._l((element.items),function(item,i){return _c('v-img',{key:'itm2'+i,staticStyle:{"width":"120px","height":"90px","background-color":"#333"},attrs:{"ma-1":"","src":_vm.getContent(item.id).imageUrl}},[(_vm.getContent(item.id).type=='title')?_c('div',{staticClass:"titlePreview"},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(_vm.getContent(item.id).title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(_vm.getContent(item.id).subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(_vm.getContent(item.id).body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(_vm.getContent(item.id).footer))])]):_vm._e()])}))],1)],1)],1)}))],1):_vm._e(),_vm._v(" "),(_vm.mediaMode=='media')?_c('div',[_c('v-combobox',{attrs:{"items":_vm.keywords,"label":"Search by Keyword.","multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(_vm.keywordList),callback:function ($$v) {_vm.keywordList=$$v},expression:"keywordList"}}),_vm._v(" "),_c('draggable',{attrs:{"options":{group:{ name:'people',  pull:'clone', put:false }},"move":_vm.checkMove,"clone":_vm.cloneMedia},model:{value:(_vm.mediaList),callback:function ($$v) {_vm.mediaList=$$v},expression:"mediaList"}},[_c('transition-group',_vm._l((_vm.mediaList),function(element,index){return (_vm.matchesKey(element))?_c('v-card',{key:element.id+'-'+index,attrs:{"color":element.color}},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":"","ma-2":"","pb-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-img',{attrs:{"src":element.imageUrl}},[(element.type=='title')?_c('div',{staticClass:"titlePreview",staticStyle:{"min-height":"100px"}},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(element.title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(element.subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(element.body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(element.footer))])]):_vm._e()])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-card-text',[_c('h4',[_vm._v(_vm._s(element.title))]),_vm._v(" "),(element.type=='web')?_c('span',[_vm._v(" "+_vm._s(element.web)),_c('br')]):_vm._e(),_vm._v(" "),(element.type=='video')?_c('span',[_vm._v(" Clip length: "+_vm._s(_vm.secToTime(element.duration))),_c('br')]):_vm._e()])],1)],1)],1)],1):_vm._e()}))],1)],1):_vm._e(),_vm._v(" "),(_vm.mediaMode=='source')?_c('draggable',{attrs:{"options":{group:{ name:'people',  pull:'clone', put:false }},"move":_vm.checkMove,"clone":_vm.cloneSource},model:{value:(_vm.sourceList),callback:function ($$v) {_vm.sourceList=$$v},expression:"sourceList"}},[_c('transition-group',_vm._l((_vm.sourceList),function(element,index){return _c('v-card',{key:element.id+'-'+index,attrs:{"height":_vm.mediaHeight(element),"color":element.color}},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":"","ma-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-icon',{staticStyle:{"font-size":"60px"}},[_vm._v("\n                    "+_vm._s(element.icon)+"\n                  ")]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"60px","text-align":"center","font-weight":"700"}},[_vm._v(_vm._s(element.type))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-card-text',[_c('h4',[_c('span',[_vm._v("Title: ")]),_c('editable',{attrs:{"content":element.title},on:{"update":function($event){element.title = $event}}})],1),_vm._v(" "),(element.type=='URL')?_c('div',[_c('span',[_vm._v("Url: ")]),_c('editable',{attrs:{"content":element.link},on:{"update":function($event){element.link = $event}}})],1):_vm._e(),_vm._v(" "),(element.description)?_c('div',[_c('span',[_vm._v("Description: ")]),_c('editable',{attrs:{"content":element.description},on:{"update":function($event){element.description = $event}}})],1):_vm._e(),_vm._v(" "),(false)?_c('span',[_vm._v("Clip length: "+_vm._s(_vm.secToTime(element.duration)))]):_vm._e()])],1)],1)],1)],1)}))],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700"},model:{value:(_vm.showSchedule),callback:function ($$v) {_vm.showSchedule=$$v},expression:"showSchedule"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Schedule Preview\n         "),_c('v-btn',{staticStyle:{"right":"10px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"indigo"},on:{"click":function($event){_vm.showSchedOptions=!_vm.showSchedOptions}}},[_c('v-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.showSchedOptions)?_c('div',[_c('span',{staticStyle:{"margin-left":"20px"}},[_c('b',[_vm._v("OPTIONS:")])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.currentLoadedSchedule.hideTime=!_vm.currentLoadedSchedule.hideTime}}},[_c('v-icon',[_vm._v("access_time")]),_vm._v(" "),(_vm.currentLoadedSchedule.hideTime)?_c('span',[_vm._v(" Show Times")]):_c('span',[_vm._v(" Hide Times")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.currentLoadedSchedule.expandPlaylist=!_vm.currentLoadedSchedule.expandPlaylist}}},[_c('v-icon',[_vm._v("list")]),(_vm.currentLoadedSchedule.expandPlaylist)?_c('span',[_vm._v("playlist contracted")]):_c('span',[_vm._v("playlist expanded")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.makeJson}},[_c('v-icon',[_vm._v("list")]),_c('span',[_vm._v("JSON")])],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',[(_vm.currentLoadedSchedule)?_c('ScheduleView',{attrs:{"schedule":_vm.currentLoadedSchedule}}):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.showSchedule = false}}},[_vm._v("\n            Close\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.editdialog),callback:function ($$v) {_vm.editdialog=$$v},expression:"editdialog"}},[(_vm.currentElement)?_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Edit Details")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          Type:"+_vm._s(_vm.currentElement.type)),_c('br'),_vm._v(" "),(_vm.editableDuration(_vm.currentElement.type))?_c('v-text-field',{attrs:{"label":"Duration"},model:{value:(_vm.currentElement.durationText),callback:function ($$v) {_vm.$set(_vm.currentElement, "durationText", $$v)},expression:"currentElement.durationText"}}):_vm._e(),_vm._v(" "),(_vm.currentElement.type=='video')?_c('v-text-field',{attrs:{"label":"Loops"},model:{value:(_vm.currentElement.loops),callback:function ($$v) {_vm.$set(_vm.currentElement, "loops", $$v)},expression:"currentElement.loops"}}):_vm._e(),_vm._v(" "),(_vm.currentElement.type=='video')?_c('p',[_vm._v("\n         \n          Duration:"+_vm._s(_vm.secToTime(_vm.currentElement.duration*_vm.currentElement.loops))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.currentElement.type!='video' && !_vm.editableDuration(_vm.currentElement.type))?_c('p',[_vm._v("\n          Duration:"+_vm._s(_vm.secToTime(_vm.currentElement.duration))+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.doEditChanges(_vm.currentElement.durationText);_vm.editdialog = false}}},[_vm._v("\n            Ok\n          ")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gQzT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gtIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hlOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");

/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),

/***/ "i6fs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Slowbart.8105e5e.jpg";

/***/ }),

/***/ "iNdf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "idHo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ixtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__("1Z2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2b5c05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__("fgVl");
function injectStyle (ssrContext) {
  __webpack_require__("Cppt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2b5c05_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j6Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe__ = __webpack_require__("QhtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__("2Pnh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  //Vue.component('vue-friendly-iframe', VueFriendlyIframe);
  components: { VueFriendlyIframe: __WEBPACK_IMPORTED_MODULE_0_vue_friendly_iframe___default.a, Checkbox: __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a },
  data: function data() {
    return {
      mode: "message",
      uploadStarted: false,
      videoText: '[  MP4 files Only - NB Large Files may not Preview ]',
      videoDetails: "",
      valid: true,
      imageUrl: '',
      videoUrl: '',
      webURL: '',
      webURLInput: '',
      date: new Date(),
      time: new Date(),
      contentInfo: {
        title: '',
        author: '',
        image: '',
        video: '',
        videoSize: '',
        description: '',
        duration: '',
        type: 'video',
        addTitle: false,
        keywords: [],
        date: new Date(),
        scaleMode: 'none',
        mode: "submitted"
      },

      keywords: ['UTAS', 'Student', 'Wide Angle', 'The Loop', 'Test'],
      notEmpty: [function (v) {
        return !!v || 'can\'t be empty';
      }],
      titleRules: [function (v) {
        return !!v || 'Title is required';
      }, function (v) {
        return v && v.length >= 2 || 'Title is too short';
      }]
    };
  },

  computed: {
    progress: function progress() {
      return this.$store.getters.progress;
    },
    progressText: function progressText() {
      var pct = (Math.floor(this.progress * 100) * .01 + "").substr(0, 5);
      if (pct.length == 1) {
        pct += ".00";
      }
      if (pct.length == 2) {
        pct += ".00";
      }
      if (pct.length == 3) {
        pct += "0";
      }
      if (pct.length == 4 && this.progress > 10) {
        pct += "0";
      }
      return pct + "%";
    },
    formIsValid: function formIsValid() {
      return this.contentInfo.title !== '' && (this.contentInfo.author !== '' || this.mode == 'title') && (this.imageUrl !== '' || this.mode == 'title') && (this.contentInfo.video !== '' || this.mode !== 'video') && (this.webUrl !== '' || this.mode !== 'web') && (this.contentInfo.description !== '' || this.mode == 'title');
    },
    fullDateTime: function fullDateTime() {
      var date = new Date(this.date);
      if (typeof this.time === 'string') {
        var hours = this.time.match(/^(\d+)/)[1];
        var minutes = this.time.match(/:(\d+)/)[1];
        date.setHours(hours);
        date.setMinutes(minutes);
      } else {
        date.setHours(this.time.getHours());
        date.setMinutes(this.time.getMinutes());
      }
      return date;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    isCurator: function isCurator() {
      return this.$store.getters.userCurator;
    }
  },
  methods: {
    setType: function setType(type) {
      this.mode = type;
      this.contentInfo.type = type;
    },
    getScreenGrab: function getScreenGrab() {

      __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(document.querySelector("#webFrame").querySelector("body")).then(function (canvas) {
        document.body.appendChild(canvas);
      });

      canvas = document.getElementById("c");
      var storageRef = firebase.storage().ref();
      var mountainsRef = storageRef.child('mountains.jpg');
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      var uploadTask = storageRef.child('images/' + "apple").put(image);
      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // See below for more detail
      }, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        var downloadURL = uploadTask.snapshot.downloadURL;
      });
    },
    uploading: function uploading() {
      if (!this.$store.getters.uploading && this.uploadStarted) {
        this.uploadStarted = false;
        this.$router.push('/profile');
      } else if (this.$store.getters.uploading) {
        this.uploadStarted = true;
      }
      return this.$store.getters.uploading;
    },
    onCreateContent: function onCreateContent() {
      console.log("CREATE CONTENT", this.contentInfo);
      if (!this.formIsValid) {
        return;
      }
      if (!this.contentInfo.image && this.mode != "title") {
        return;
      }
      if (!this.contentInfo.video && this.mode == "video") {
        return;
      }
      if (!this.contentInfo.web && this.mode == "web") {
        return;
      }

      this.$store.dispatch('createContent', this.contentInfo);
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onPickVideo: function onPickVideo() {
      this.contentInfo.web = "";
      this.$refs.videoInput.click();
    },
    onPickUrl: function onPickUrl() {
      this.contentInfo.web = this.webURLInput;
      this.contentInfo.video = "";
      this.webURL = this.webURLInput;
    },
    onVideoPicked: function onVideoPicked(event) {
      var _this = this;

      var self = this;
      this.videoText = "loading preview ";
      var files = event.target.files;

      var filename = files[0].name;
      this.videoDetails = "file:" + filename + " size:" + Math.round(files[0].size / 1024 / 1024) + "MB";
      console.log(files[0]);

      if (filename.lastIndexOf('.mp4') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function (data) {
        console.log("LOADING", fileReader);
        console.log("LOADING2", data);
      });
      fileReader.addEventListener('progress', function (data) {
        console.log("progress", data);
        _this.videoText = "loading preview " + data.loaded;
      });
      fileReader.addEventListener('loadend', function (data) {
        console.log("LOADED", fileReader, data);
        _this.videoUrl = fileReader.result;
      });
      if (files[0].size < 1024 * 1024 * 500) {
        fileReader.readAsDataURL(files[0]);
        //fileReader.readAsDataURL(slice)
        this.contentInfo.video = files[0];
        var vid = document.getElementById("video1");
        //console.log("SIZE",vid.width,vid.height);
        //self.contentInfo.videoSize=vid.width+","+vid.height;
        vid.oncanplay = function () {
          self.contentInfo.duration = vid.duration;
          console.log("SIZE", vid.videoWidth, vid.videoHeight);
          self.contentInfo.videoSize = vid.videoWidth + "," + vid.videoHeight;
        };
      } else {
        this.videoText = "File too large to preview please continue with submission or upload a smaller file";
        this.contentInfo.video = files[0];
      }
    },
    onFilePicked: function onFilePicked(event) {
      var _this2 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this2.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.contentInfo.image = files[0];
    }
  }
});

/***/ }),

/***/ "jfG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kUJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadSkitfaced_vue__ = __webpack_require__("j6Ff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96234a68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadSkitfaced_vue__ = __webpack_require__("dCI9");
function injectStyle (ssrContext) {
  __webpack_require__("lE7K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadSkitfaced_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96234a68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadSkitfaced_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lE7K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lKdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pixel_vue__ = __webpack_require__("950n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ea221c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pixel_vue__ = __webpack_require__("tY7Y");
function injectStyle (ssrContext) {
  __webpack_require__("rmme")
  __webpack_require__("ZDxa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62ea221c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pixel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ea221c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pixel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74df0ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("ETxJ");
function injectStyle (ssrContext) {
  __webpack_require__("VII7")
  __webpack_require__("eNiQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74df0ff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74df0ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mR7h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('v-img',{staticStyle:{"margin-top":"10px","margin":"auto","position":"relative"},attrs:{"src":'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FWeAreOne-crop.png?alt=media&token=a6539c27-6222-4c52-9f91-e27229b308c1',"width":"100%"},on:{"click":function($event){_vm.showBars=!_vm.showBars}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("We Are One at The Loop")]),_vm._v(" "),_c('h4',[_vm._v("Friday June 5, 2020\n4:30pm - 9:15pm\n@ The Loop\n"),_c('br'),_vm._v("\n157 Elizabeth Street, Hobart.\nOutdoor courtyard"),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("HOBART comes out of cultural hibernation with a special screening at The Loop.")]),_vm._v(" "),_c('p',[_vm._v("\nThis Friday, The Loop screens highlights from The We Are One Global Film Festival, a historic film event from international film festivals during lock-down.\n")]),_vm._v(" "),_c('p',[_vm._v("\nThis will be a free socially-distanced outdoor cinema experience showing a double feature and short films from the We Are One Global Film Festival.")]),_vm._v(" "),_c('p',[_vm._v("\nRug up and get cosy under the heaters and join us for a taste of the crème de la crème of international cinema talent. A warm invite is extended to the general public, UTAS residents and students are warmly invited to attend. There'll be heaters and beanbags. BYO warm things and snacks.\n")]),_vm._v(" "),_c('p',[_vm._v("\nAll welcome.\nBookings recommended via Eventbrite - "),_c('a',{attrs:{"href":"https://www.eventbrite.com.au/e/we-are-one-at-the-loop-tickets-107787605630","target":"blank"}},[_vm._v("Book here")]),_c('br'),_vm._v("\nDrop-ins welcome,  however there will be a 20-person capacity on a first-come-first-serve basis.\n")]),_vm._v(" "),_c('h3',[_vm._v("The program is proudly jointly presented by the City of Hobart and University of Tasmania.")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mWuK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o61H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{staticStyle:{"font-size":"14px"},attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[(true)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","pt-0":""}},[_c('v-img',{staticStyle:{"margin-top":"10px","position":"relative"},attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FLibertyLoop_website_banner.jpg?alt=media&token=6a02772f-13bb-431d-b73e-6f2f83876ef7","width":"100%"}})],1)],1):_vm._e(),_vm._v(" "),(true)?_c('v-layout',[(false)?_c('v-flex',{attrs:{"xs6":"","pt-3":""}},[_c('v-img',{staticStyle:{"margin-top":"10px","position":"relative"},attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FLibertyLoop_fbbanner.jpeg?alt=media&token=68b0479c-e678-491d-96da-a6b584e30059","width":"360px","height":"200px"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","pt-0":""}},[_c('br'),_vm._v(" "),_c('h2',[_vm._v("LIBERTY LOOP: FILMS OF THE PEOPLE")]),_vm._v(" "),_c('h4',[_c('br'),_vm._v("@ The Loop 157 Elizabeth Street, Hobart "),_c('br'),_vm._v("\n                  SCREENING DAILY 10AM – 3PM"),_c('br'),_vm._v("\n                  23 March – 9 May\n                  "),_c('br'),_c('br')])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n Complementing the inaugural Hobart Current: Liberty the City of Hobart is hosting a program of diverse community activities, providing opportunities to discover and explore the notion of ‘liberty’.\n"),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Liberty Loop: Films of The People")]),_vm._v(" is a film program from community and creators with diverse voices sharing stories of hotel quarantines, aquatic friendships, covid companions (the furry kind) and dance, dance, dance! The program invited creatives to reflect on the notion of ‘liberty’\n\nThe program has a little bit of everything from animates, films shorts, documentary and digital artwork and artist vlogs."),_c('br'),_c('br'),_vm._v("\n\nFor exhibition details and other events that are part of HOBART CURRENT: LIBERTY Public Programs, check out\n\n "),_c('v-btn',{attrs:{"href":"https://hobartcurrent.com/","target":"_blank"}},[_vm._v("Hobart Current: Liberty")]),_vm._v(" "),_c('br'),_c('br'),_vm._v("\n\nHOBART CURRENT is a biannual exhibition supported in partnership by The City of Hobart and Tasmanian Museum and Art Gallery.\n"),_c('br'),_c('br'),_vm._v("\nImage: The LOOP screen located in the heart of Hobart. Artwork: Sunrise by Alicja Trefler, video still, 2012. Courtesy of The University of Tasmania. Photo: Joseph Shrimpton\n"),_c('br'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-0":""}},[_c('v-img',{staticStyle:{"margin-top":"10px","position":"relative"},attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Slider%2FCurrent-footer.png?alt=media&token=497ce3ae-a7d7-47ae-b82b-2a40d2be55cb","width":"100%"}})],1),_vm._v(" "),_c('br')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oEqp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oFsg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oUcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['content'],
    data: function data() {

        return {};
    },

    mounted: function mounted() {
        this.$el.innerText = this.content;
    },
    methods: {
        update: function update(event) {
            this.$emit('update', event.target.innerText);
        }
    }
});

/***/ }),

/***/ "ooxT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/current.a17f2f0.jpg";

/***/ }),

/***/ "peKb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pfrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qg4J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r1rV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.45c726b.png";

/***/ }),

/***/ "rmme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rzuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('h2',[_vm._v("Contact")]),_vm._v(" "),_c('p',[_vm._v("\n          For more information about submitting content go to the "),_c('v-btn',{attrs:{"to":'/participate'}},[_vm._v("Participate")]),_vm._v(" page.\n         ")],1),_vm._v(" "),_c('p',[_vm._v("For all queries contact the Public Art Team"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:publicart@hobartcity.com.au"}},[_vm._v("publicart@hobartcity.com.au")]),_vm._v(" \n          or (03) 6238 2565.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sDIZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100vw","display":"flex","justify-content":"space-around","background-color":"#ffc75f"}},[_c('div',{staticStyle:{"max-width":"350px","text-align":"center","magin":"auto","height":"100vh","background-color":"#fff3"}},[_c('h2',{staticStyle:{"padding":"10px"}},[_vm._v("The Loop Volume Control")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","font-size":"20px"}},[_vm._v("Volume: "+_vm._s(_vm.deviceVolume))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-around","padding":"10px"}},[_c('div',[_c('v-btn',{on:{"click":function($event){_vm.volumeDown()}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_down")]),_vm._v("-")],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.volumeUp()}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_up")]),_vm._v("+")],1)],1)]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.volumeReset(70)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_up")]),_vm._v("MED")],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.volumeReset(80)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_up")]),_vm._v("MED HIGH")],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10px"}},[_vm._v("*default volume is ~ 7.3")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.volumeReset(52)}}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("volume_up")]),_vm._v("Reset")],1),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n      NB. Wait for the volume to update between button presses. The command needs to go to the loop and then back again with the updated value."),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tY7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"ma-0":"","pa-0":"","fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","pa-0":"","fill-height":""}},[(_vm.screenMode)?_c('div',{staticClass:"screenColor"},[_vm._l((_vm.pixels),function(p){return _c('div',{staticClass:"pixel",style:('top:'+_vm.pixelY(p)+'px;left:'+_vm.pixelX(p)+'px;background-color:'+p.color+';')})}),_vm._v(" "),_c('div',{staticClass:"pixelEffect"},_vm._l((_vm.effect),function(p){return _c('div',{staticClass:"pixel",style:('top:'+p.y+'px;left:'+p.x+'px;background-color:'+p.c+';')})}))],2):_vm._e(),_vm._v(" "),(!_vm.screenMode)?_c('div',{staticClass:"screenColor",staticStyle:{"position":"relative"},on:{"mouseup":function($event){_vm.moveY=0}}},[_c('div',{staticClass:"cPixel",style:({backgroundColor: _vm.pixelColour}),on:{"mousedown":function($event){_vm.cDown=true},"touchstart":function($event){_vm.cDown=true},"mouseup":_vm.centerUp,"touchend":_vm.centerUp,"touchcancel":_vm.centerUp}}),_vm._v(" "),_c('div',{staticClass:"arrow-up",on:{"mousedown":function($event){_vm.moveY=-1},"touchstart":function($event){_vm.moveY=-1},"mouseup":_vm.mouseUp,"touchend":_vm.mouseUp,"touchcancel":_vm.mouseUp}}),_vm._v(" "),_c('div',{staticClass:"arrow-down",on:{"mousedown":function($event){_vm.moveY=1},"touchstart":function($event){_vm.moveY=1},"mouseup":_vm.mouseUp,"touchend":_vm.mouseUp,"touchcancel":_vm.mouseUp}}),_vm._v(" "),_c('div',{staticClass:"arrow-right",on:{"mousedown":function($event){_vm.moveX=1},"touchstart":function($event){_vm.moveX=1},"mouseup":_vm.mouseUp,"touchend":_vm.mouseUp,"touchcancel":_vm.mouseUp}}),_vm._v(" "),_c('div',{staticClass:"arrow-left",on:{"mousedown":function($event){_vm.moveX=-1},"touchstart":function($event){_vm.moveX=-1},"mouseup":_vm.mouseUp,"touchend":_vm.mouseUp,"touchcancel":_vm.mouseUp}}),_vm._v(" "),(false)?_c('div',{staticClass:"pixelName"},[_vm._v("PIXEL "+_vm._s(_vm.cDown))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.screenMode)?_c('div',{staticClass:"screenText"},[_vm._v("www.theloophobart.com.au/pixel")]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uJaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Participate_vue__ = __webpack_require__("afOU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d874d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Participate_vue__ = __webpack_require__("2AZF");
function injectStyle (ssrContext) {
  __webpack_require__("qg4J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d874d46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Participate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d874d46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Participate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vQVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__("YcGa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d5962c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__("4xsP");
function injectStyle (ssrContext) {
  __webpack_require__("QsO5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02d5962c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02d5962c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vbtM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Involved_vue__ = __webpack_require__("3ul3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1706c50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Involved_vue__ = __webpack_require__("xVDm");
function injectStyle (ssrContext) {
  __webpack_require__("iNdf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1706c50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Involved_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1706c50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Involved_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w9mj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wYvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skitfaced_vue__ = __webpack_require__("/r3y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453a3e43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skitfaced_vue__ = __webpack_require__("zVBi");
function injectStyle (ssrContext) {
  __webpack_require__("Xx+M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-453a3e43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skitfaced_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453a3e43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skitfaced_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+az":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasTouch: false,
      canvas: null,
      ctx: null,
      xPos: null,
      yPos: null,
      screenCol: null,
      mouseIsDown: false
    };
  },
  mounted: function mounted() {
    //this.$store.dispatch('loadStatus');
    this.$store.dispatch("loadColour");
    console.log("MOUNTED", this.colour);
    if (!this.screenMode) {
      this.canvas = document.getElementById("colorspace");
      this.ctx = this.canvas.getContext("2d");
      this.buildColorPalette();
      this.canvas.onmousemove = this.mouseMove;
      this.canvas.onmousedown = this.mouseDown;
      document.onmouseup = this.mouseUp;
      this.canvas.ontouchmove = this.touchMove;
    }
  },

  computed: {
    screenMode: function screenMode() {
      return this.$route.path.indexOf("screen") > -1;
    },
    colour: function colour() {
      return this.$store.getters.getColour;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },

  methods: {
    mouseDown: function mouseDown(event) {
      this.mouseIsDown = true;
      this.mouseMove(event);
    },
    mouseUp: function mouseUp(event) {
      this.mouseIsDown = false;
    },
    touchMove: function touchMove(event) {
      this.yPos = (event.pageY - this.canvas.offsetTop) / this.canvas.scrollHeight * this.canvas.height;
      this.xPos = (event.pageX - this.canvas.offsetLeft) / this.canvas.scrollWidth * this.canvas.width;
      this.getColor();
    },
    mouseMove: function mouseMove(event) {
      if (this.mouseIsDown) {
        this.yPos = (event.pageY - this.canvas.offsetTop) / this.canvas.scrollHeight * this.canvas.height;
        this.xPos = (event.pageX - this.canvas.offsetLeft) / this.canvas.scrollWidth * this.canvas.width;
        this.getColor();
      }
    },
    getColor: function getColor() {
      var imageData = this.ctx.getImageData(this.xPos, this.yPos, 1, 1);
      console.log(imageData);
      this.screenCol = "rgb(" + imageData.data[0] + ", " + imageData.data[1] + ", " + imageData.data[2] + ")";
      this.setColour(this.screenCol);
    },
    buildColorPalette: function buildColorPalette() {
      var gradient = this.ctx.createLinearGradient(0, 0, this.canvas.width, 0);
      // Create color gradient
      gradient.addColorStop(0, "rgb(127,   127,   127)");
      gradient.addColorStop(0.04, "rgb(127,   127,   127)");
      gradient.addColorStop(0.05, "rgb(255,   0,   0)");
      gradient.addColorStop(0.2, "rgb(255,   0, 255)");
      gradient.addColorStop(0.35, "rgb(0,     0, 255)");
      gradient.addColorStop(0.5, "rgb(0,   255, 255)");
      gradient.addColorStop(0.65, "rgb(0,   255,   0)");
      gradient.addColorStop(0.8, "rgb(255, 255,   0)");
      gradient.addColorStop(1, "rgb(255,   0,   0)");
      // Apply gradient to canvas
      this.ctx.fillStyle = gradient;
      this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      // Create semi transparent gradient (white -> trans. -> black)
      gradient = this.ctx.createLinearGradient(0, 0, 0, this.canvas.height);
      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
      gradient.addColorStop(0.5, "rgba(255, 255, 255, 0)");
      gradient.addColorStop(0.5, "rgba(0,     0,   0, 0)");
      gradient.addColorStop(1, "rgba(0,     0,   0, 1)");
      // Apply gradient to canvas
      this.ctx.fillStyle = gradient;
      this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },
    setColour: function setColour(col) {
      this.$store.dispatch("setColour", col);
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sideNav: false,
      prelaunch: false
    };
  },

  computed: {
    showMenu: function showMenu() {
      console.log(this.$route.name);
      return !(this.$route.name == "HomePH");
    },
    isPlayZone: function isPlayZone() {
      var isPlay = false;
      isPlay = this.$route.path.indexOf("/launch") > -1 || this.$route.path.indexOf("/play/") > -1 || this.$route.path.indexOf("/colour") > -1 || this.$route.path.indexOf("/pixel") > -1;

      return isPlay;
    },
    menuItems: function menuItems() {
      var menuItems = [
      //{icon: 'face', title: 'Sign Up', link: '/signup'},
      //{icon: 'lock_open', title: 'Sign In', link: '/signin'},

      { title: "Program", link: "/program" }, { title: "About the Loop", link: "/about" }, { title: "Participate", link: "/participate" },
      // { title: "Opportunities", link: "/opportunities" },
      // { title: "Events", link: "/events" },
      { title: "Contact", link: "/contact" }];
      console.log(this.$route);
      if (this.$route.name == "Home" && false) {
        menuItems = [{ icon: 'face', title: 'Sign Up', link: '/signup' }, { icon: 'lock_open', title: 'Sign In', link: '/signin' }];
      } else if (this.$route.name == "Involved") {
        menuItems.push({ icon: "face", title: "Sign Up", link: "/signup" });
        menuItems.push({
          icon: "lock_open",
          title: "Sign In",
          link: "/signin"
        });
        //{icon: 'movie', title: 'Get involved', link: '/content/new'}
      }
      if (this.userIsAuthenticated) {
        menuItems.push({
          icon: "movie",
          title: "Content",
          link: "/content",
          req: "isCurator"
        });
        menuItems.push({
          icon: "person",
          title: "Profile",
          link: "/profile"
        });
        //menuItems.push({icon: 'filter_frames', title: 'Upload Content', link: '/content/new',req:"notCurator"})
        menuItems.push({
          icon: "filter_frames",
          title: "Upload",
          link: "/content/new",
          req: "isCurator"
        });
        menuItems.push({
          icon: "playlist_play",
          title: "Playlist",
          link: "/playlist",
          req: "isCurator"
        });
        menuItems.push({
          icon: "calendar_today",
          title: "Schedule",
          link: "/schedule",
          req: "isCurator"
        });
        menuItems.push({
          icon: "dashboard",
          title: "vMix",
          link: "/controls",
          req: "isAdmin"
        });
        //menuItems.push({icon: 'person', title: 'Profile', link: '/profile'})
      }
      return menuItems;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    isRequired: function isRequired(req) {
      if (req) {
        switch (req) {
          case "isAdmin":
            return this.$store.getters.userAdmin;
            break;
          case "isCurator":
            return this.$store.getters.userCurator;
          case "notCurator":
            return !this.$store.getters.userCurator;
            break;
        }
      }
      return true;
    },
    onLogout: function onLogout() {
      this.prelaunch = false;
      console.log(this.$refs);
      this.$refs.home.prelaunch = false;
      this.$store.dispatch("logout");
    }
  }
});

/***/ }),

/***/ "xRF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('v-container',{attrs:{"ma-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"grey","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","offset-xs0":"","sm10":"","offset-sm2":"","pa-2":""}},[_c('h2',[_vm._v("About the loop")]),_vm._v(" "),_c('p',[_vm._v("The Loop is an initiative of the City of Hobart, through the Creative Hobart Strategy, developed in\npartnership with the University of Tasmania (UTAS).\nThis large-scale outdoor public screen, located in the courtyard of UTAS student accommodation\nat 157 Elizabeth Street, screens a daily cultural program throughout the year.")]),_vm._v(" "),_c('h2',[_vm._v("Mission")]),_vm._v(" "),_c('p',[_vm._v("The Loop is a detour into digital culture. An oasis of art in the city. A place to share, experiment\nand discover. Showcasing the richness and diversity of Tasmania’s creative scene it is designed\nto enrich the daily civic life of Hobart’s CBD by offering encounters that delight, inspire and\nprovoke.")]),_vm._v(" "),_c('p',[_vm._v("\nAs a dedicated arts platform the Loop strives to foster and present work that is innovative,\ncollaborative, inclusive, expressive, reflective and highly creative. As such, it will not display\nadvertising or other commercially focused content.")]),_vm._v(" "),_c('p',[_vm._v("\n\nThe Loop has capacity to accommodate interactivity and live-streaming with a vision to expand\nits technical / conceptual parameters as the project evolves..")]),_vm._v(" "),_c('p',[_vm._v("\nCommunity members, artists, curators and organisations are encouraged to contribute content\nfor consideration. Please visit the "),_c('v-btn',{attrs:{"to":'/participate'}},[_vm._v("Participate")]),_vm._v(" page for more information.")],1),_c('p',[_vm._v("\nSometimes the audience will become the artist. Sometimes the City itself will become “art”.")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xVDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"mt-0":"","pt-0":""}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('p'),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary","width":7}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","pa-4":""}},[_c('h2',[_vm._v("Get Involved")]),_vm._v(" "),_c('p',[_vm._v("Register to participate")]),_vm._v(" "),_vm._l((_vm.menuItems),function(item){return _c('v-btn',{key:item.title,attrs:{"flat":"","to":item.link}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n             "+_vm._s(item.title)+"\n             ")],1)})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xeWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },

  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? 'Passwords do not Match' : '';
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/participate');
      }
    }
  },
  methods: {
    onSignup: function onSignup() {
      console.log('email:', this.email);
      this.$store.dispatch('signUserUp', { email: this.email, password: this.password });
    },
    onSignupGoogle: function onSignupGoogle() {

      this.$store.dispatch('signUserUpGoogle', { email: 'this.email', password: 'this.password' });
    },
    onDismissed: function onDismissed() {
      console.log('Dismissed alert');
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),

/***/ "xijl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"mt-0":"","fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs3":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.approvedState),callback:function ($$v) {_vm.approvedState=$$v},expression:"approvedState"}},_vm._l((_vm.radioBtns),function(btn,index){return _c('v-radio',{key:btn,attrs:{"label":btn,"value":index}})}))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-combobox',{attrs:{"items":_vm.keywords,"label":"Search by Keywords - select from list or add your own.","multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(_vm.keywordList),callback:function ($$v) {_vm.keywordList=$$v},expression:"keywordList"}})],1)],1),_vm._v(" "),_vm._l((_vm.contents),function(content){return (_vm.matchesKey(content) && _vm.showApproved(content))?_c('v-layout',{key:content.id,attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-container',{attrs:{"fluid":"","pa-2":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs5":"","sm4":"","md3":""}},[_c('v-responsive',[(content.videoUrl && false)?_c('video',{attrs:{"src":content.videoUrl,"height":"130px","controls":"","poster":content.imageUrl,"preload":"none"}}):_vm._e(),_vm._v(" "),(!content.videoUrl || true)?_c('img',{attrs:{"src":content.imageUrl,"height":"200"},on:{"click":function($event){_vm.showDetails(content)}}}):_vm._e()]),_vm._v(" "),(content.type=='title')?_c('div',{staticClass:"titlePreview"},[_c('div',{staticClass:"pTitle"},[_vm._v(_vm._s(content.title))]),_vm._v(" "),_c('div',{staticClass:"pSubtitle"},[_vm._v(_vm._s(content.subtitle))]),_vm._v(" "),_c('div',{staticClass:"pBody"},[_vm._v(_vm._s(content.body))]),_vm._v(" "),_c('div',{staticClass:"pFooter"},[_vm._v(_vm._s(content.footer))])]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":"","sm8":"","md9":""}},[_c('v-card',{staticClass:"card",attrs:{"flat":""}},[_c('v-layout',{staticStyle:{"min-height":"82px"},attrs:{"row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-title',{staticClass:"pt-0",attrs:{"primary-title":"","color":"teal"}},[_c('div',[_c('h3',{staticClass:"balck--text  mb-0"},[_vm._v(_vm._s(content.title))]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Artist:")]),_vm._v(" "+_vm._s(content.artist))]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Type:")]),_vm._v(" "+_vm._s(content.type))]),_vm._v(" "),(content.type=='web')?_c('div',[_c('a',{attrs:{"href":content.web,"target":"_blank"}},[_vm._v(_vm._s(content.web))])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.getContact(content.creatorId)}}},[_c('b',[_vm._v("Contact:")]),_vm._v(" "+_vm._s(content.creatorId))])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm4":"","md5":""}},[_c('div',[_c('b',[_vm._v("Description:")]),_c('span',[_vm._v(_vm._s(content.description))])]),_vm._v(" "),_c('b'),_vm._v(" "),_vm._l((content.keywords),function(word){return (!content.allowEdit)?_c('v-chip',{key:word,attrs:{"small":""}},[_vm._v("\n               "+_vm._s(word)+"\n              ")]):_vm._e()}),_vm._v(" "),(content.allowEdit)?_c('v-combobox',{attrs:{"items":_vm.keywords,"multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(content.keywords),callback:function ($$v) {_vm.$set(content, "keywords", $$v)},expression:"content.keywords"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-radio-group',{staticStyle:{"display":"inline-block"},attrs:{"disabled":!content.allowEdit,"row":""},model:{value:(content.scaleMode),callback:function ($$v) {_vm.$set(content, "scaleMode", $$v)},expression:"content.scaleMode"}},[_vm._v("\n              Scale Content   \n              "),_c('v-radio',{attrs:{"label":"None","value":"none"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Fit","value":"fit"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Fill","value":"fill"}})],1)],2),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm4":"","md3":""}},[_c('div',[_c('i',[_vm._v("Uploaded: "+_vm._s(_vm._f("date")(content.date)))])]),_vm._v(" "),_c('div',[_c('i',[_vm._v("Expires: never")])]),_vm._v(" "),_c('div',{on:{"click":_vm.clickPlay}},[_c('i',[_vm._v(_vm._s(_vm.playval)+" plays")])])])],1),_vm._v(" "),_c('v-footer',{attrs:{"color":"transparent","relative":""}},[_c('v-chip',{attrs:{"small":""}},[_vm._v("\n              "+_vm._s(_vm.secondsToDurationText(content.duration))+"\n            ")]),_vm._v(" "),(content.allowEdit)?_c('v-text-field',{staticStyle:{"max-width":"100px","flex":"none"},model:{value:(content.duration),callback:function ($$v) {_vm.$set(content, "duration", $$v)},expression:"content.duration"}}):_vm._e(),_vm._v(" "),(content.looping)?_c('v-chip',{attrs:{"small":""}},[_c('v-icon',[_vm._v("loop")])],1):_vm._e(),_vm._v(" "),(content.approved)?_c('v-chip',{attrs:{"small":""}},[_c('v-icon',{on:{"click":function($event){_vm.disapproveContent(content)}}},[_vm._v("check_circle")])],1):_c('v-chip',{attrs:{"small":""}},[_c('v-icon',{on:{"click":function($event){_vm.approveContent(content)}}},[_vm._v("all_out")])],1),_vm._v(" "),(!content.allowEdit && content.rating)?_c('v-chip',{attrs:{"small":""}},[_vm._l((content.rating),function(r){return _c('v-icon',[_vm._v("star")])}),_vm._v(" "),_vm._l(((5-content.rating)),function(e){return _c('v-icon',[_vm._v("star_border")])})],2):_vm._e(),_vm._v(" "),(content.allowEdit)?_c('v-chip',[_c('v-rating',{attrs:{"color":"#757575"},model:{value:(content.rating),callback:function ($$v) {_vm.$set(content, "rating", $$v)},expression:"content.rating"}})],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('app-view-content-details-dialog',{attrs:{"videoUrl":content.videoUrl,"imageUrl":content.imageUrl,"content":content}}),_vm._v(" "),(!content.allowEdit)?_c('v-btn',{staticStyle:{"right":"180px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"indigo"},on:{"click":function($event){_vm.allowEdit(content)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(content.allowEdit)?_c('v-btn',{staticStyle:{"right":"180px"},attrs:{"flat":"","fab":"","absolute":"","right":"","icon":"","small":"","color":"indigo"},on:{"click":function($event){_vm.doEdit(content)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),(content.allowEdit)?_c('div',[_vm._v("[ Content ID:"+_vm._s(content.id)+" ] [ Creator ID:"+_vm._s(content.creatorId)+" ] [ Video: "+_vm._s(content.videoUrl)+" ] [ Image: "+_vm._s(content.imageUrl)+" ]")]):_vm._e()],1)],1)],1)],1)],1):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yCdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: ''
    };
  },
  created: function created() {
    console.log("USER", this.user);
    //this.$store.dispatch('loadContents')
    this.$store.dispatch('loadUserContents', this.user.id);

    this.$store.dispatch('assignUserEmail', this.user.id);
  },


  computed: {
    contents: function contents() {
      return this.$store.getters.userContents;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value == null && value == undefined) {
        this.$router.push('/');
      } else {
        console.log("HAVE A USER", value);
      }
    }
  },
  methods: {
    onForgot: function onForgot() {
      this.$store.dispatch('forgotPassword', { email: this.email });
    },
    onSignin: function onSignin() {
      console.log('email:', this.email);
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onDismissed: function onDismissed() {
      console.log('Dismissed alert');
      this.$store.dispatch('clearError');
    },
    onLogout: function onLogout() {
      console.log("LOGOUT");
      this.$store.dispatch('logout');
    }
  }
});

/***/ }),

/***/ "yP2D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onCreateContent($event)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","pr-3":""}},[(_vm.mode=='video')?_c('div',{attrs:{"id":"videoHolder"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.videoUrl),expression:"!videoUrl"}],staticClass:"aspect"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.videoText)}},[_vm._v(_vm._s(_vm.videoText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.videoUrl),expression:"!videoUrl"}],staticClass:"videoBase"},[_c('h2',[_vm._v(_vm._s(_vm.videoDetails))])]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.videoUrl),expression:"videoUrl"}],attrs:{"id":"video1","width":"100%","src":_vm.videoUrl,"type":"video/mp4","controls":""}}),_vm._v(" "),(false)?_c('img',{staticClass:"ledOverlay",attrs:{"src":require("../../assets/images/screenOverlay.png"),"width":"100%"}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickVideo}},[_vm._v("Select Video")]),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-radio-group',{staticStyle:{"display":"inline-block","float":"right"},attrs:{"row":""},model:{value:(_vm.contentInfo.scaleMode),callback:function ($$v) {_vm.$set(_vm.contentInfo, "scaleMode", $$v)},expression:"contentInfo.scaleMode"}},[_vm._v("\n               Scale Content   \n               "),_c('v-radio',{attrs:{"label":"None","value":"none"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Fit","value":"fit"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Fill","value":"fill"}})],1),_vm._v(" "),(false)?_c('v-btn',{on:{"click":_vm.getScreenGrab}},[_vm._v("Snapshot")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mode=='web')?_c('div',{attrs:{"id":"webHolder"}},[(!_vm.webURL)?_c('h5',{staticClass:"primary--text"},[_vm._v("Submit URL")]):_vm._e(),_vm._v(" "),(_vm.webURL)?_c('vue-friendly-iframe',{attrs:{"src":_vm.webURL,"id":"webFrame"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"URL","label":"URL","id":"description"},model:{value:(_vm.webURLInput),callback:function ($$v) {_vm.webURLInput=$$v},expression:"webURLInput"}}),_vm._v(" "),(false)?_c('img',{staticClass:"ledOverlay",attrs:{"src":require("../../assets/images/screenOverlay.png"),"width":"100%"}}):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickUrl}},[_vm._v("Select URL")]),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),(_vm.mode=='title')?_c('div',[_c('h5',{staticClass:"primary--text"},[_vm._v("Title Card")]),_vm._v(" "),_c('div',{attrs:{"id":"cardHolder"}},[_c('div',{staticClass:"cTitle"},[_vm._v(_vm._s(_vm.contentInfo.title))]),_vm._v(" "),_c('div',{staticClass:"cSubtitle"},[_vm._v(_vm._s(_vm.contentInfo.subtitle))]),_vm._v(" "),_c('div',{staticClass:"cBody"},[_vm._v(_vm._s(_vm.contentInfo.body))]),_vm._v(" "),_c('div',{staticClass:"cFooter"},[_vm._v(_vm._s(_vm.contentInfo.footer))])]),_vm._v(" "),_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.contentInfo.title),callback:function ($$v) {_vm.$set(_vm.contentInfo, "title", $$v)},expression:"contentInfo.title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"subtitle","label":"Subtitle","id":"subtitle"},model:{value:(_vm.contentInfo.subtitle),callback:function ($$v) {_vm.$set(_vm.contentInfo, "subtitle", $$v)},expression:"contentInfo.subtitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"body","label":"Body","id":"body"},model:{value:(_vm.contentInfo.body),callback:function ($$v) {_vm.$set(_vm.contentInfo, "body", $$v)},expression:"contentInfo.body"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"footer","label":"Footer","id":"footer"},model:{value:(_vm.contentInfo.footer),callback:function ($$v) {_vm.$set(_vm.contentInfo, "footer", $$v)},expression:"contentInfo.footer"}}),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"raised":""},on:{"click":function($event){_vm.mode='message'}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),(_vm.mode=='message')?_c('div',[_c('h2',[_vm._v("Participate")]),_vm._v(" "),_c('p',[_vm._v("The Loop takes submissions for content throughout the year. It’s open to artists, curators, and community-members and organisations who work with creative screen-based media."),_c('br'),_vm._v("The Loop does not accept advertising or promotional material."),_c('br'),_vm._v("To submit content for consideration, upload a file here.")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('video')}}},[_vm._v("Upload Video")]),_vm._v(" "),(_vm.isCurator)?_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('web')}}},[_vm._v("Submit Web Content")]):_vm._e(),_vm._v(" "),(_vm.isCurator)?_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.setType('title')}}},[_vm._v("Create Title Card")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mode!='message')?_c('v-container',{attrs:{"pl-3":"","pr-1":""}},[_c('v-layout',{attrs:{"fluid":""}},[(_vm.uploading())?_c('v-flex',{attrs:{"xs12":""}},[_c('v-progress-linear',{model:{value:(_vm.progress),callback:function ($$v) {_vm.progress=$$v},expression:"progress"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"text-xs-right":""}},[_c('v-flex',{attrs:{"xs1":"","text-xs-left":""}},[(_vm.uploading())?_c('span',[_vm._v(_vm._s(_vm.progressText))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('span',[_vm._v("Please review your content before uploading "),_c('br'),_vm._v("Image, Title, Artist, And Description fields are all required ")]),_vm._v(" "),_c('br'),_c('v-btn',{staticClass:"primary",attrs:{"disabled":!_vm.formIsValid || _vm.uploading(),"type":"submit"}},[_vm._v("Upload Content")])],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.mode!='title')?_c('v-flex',{attrs:{"xs12":"","sm3":""}},[(_vm.mode!='title')?_c('div',{attrs:{"id":"imageHolder"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.imageUrl),expression:"!imageUrl"}],staticClass:"aspect"},[_c('h5',[_vm._v("Poster Image")])]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imageUrl),expression:"imageUrl"}],attrs:{"src":_vm.imageUrl,"width":"100%"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":"","disabled":_vm.uploading()},on:{"click":_vm.onPickFile}},[_vm._v("Select Image")])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.contentInfo.title),callback:function ($$v) {_vm.$set(_vm.contentInfo, "title", $$v)},expression:"contentInfo.title"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"author","label":"Artist","id":"author","rules":_vm.notEmpty,"required":""},model:{value:(_vm.contentInfo.author),callback:function ($$v) {_vm.$set(_vm.contentInfo, "author", $$v)},expression:"contentInfo.author"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"name":"description","label":"Description","id":"description","required":""},model:{value:(_vm.contentInfo.description),callback:function ($$v) {_vm.$set(_vm.contentInfo, "description", $$v)},expression:"contentInfo.description"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-combobox',{attrs:{"items":_vm.keywords,"label":"Keywords - select from list or add your own.","multiple":"","hide-selected":"","deletable-chips":"","chips":""},model:{value:(_vm.contentInfo.keywords),callback:function ($$v) {_vm.$set(_vm.contentInfo, "keywords", $$v)},expression:"contentInfo.keywords"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Add title to start of content"},model:{value:(_vm.contentInfo.addTitle),callback:function ($$v) {_vm.$set(_vm.contentInfo, "addTitle", $$v)},expression:"contentInfo.addTitle"}}),_vm._v(" "),(false)?_c('app-view-content-details-dialog',{attrs:{"videoUrl":_vm.videoUrl,"imageUrl":_vm.imageUrl,"content":_vm.contentInfo}}):_vm._e()],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}}),_vm._v(" "),_c('input',{ref:"videoInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"video/mp4"},on:{"change":_vm.onVideoPicked}})])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yVzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("03pU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2173a8ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("jfG/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2173a8ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zVBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"glitchHolder"},[(_vm.glitches)?_c('div',{style:({top:_vm.glitchTop+'px'}),attrs:{"id":"glitchOverlay"}},_vm._l((_vm.glitches),function(g){return _c('div',{staticClass:"glitchOver",style:({marginBottom:g.pad+'px',width:g.width+'%'})},_vm._l((g.child),function(gc){return _c('div',{staticClass:"glitchChild",style:({backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'})})}))})):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","padding":"0% 15%"}},[_c('v-img',{staticStyle:{},attrs:{"src":'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/events%2Fskitfaced%2Fskitfaced.jpg?alt=media&token=64833a1d-00d7-45f4-82a7-3fa46ca0e98c',"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"width":"300px"}},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v("November 2020\n        "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v("\n        3pm Monday, 19 October 2020\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Submission%20Guidelines%20for%20The%20Loop_Jan2020.pdf?alt=media&token=81717957-cc63-496a-b69a-9fddda62e181'}},[_vm._v("SUBMISSION GUIDELINES")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Contact")]),_vm._v(" "),_c('br'),_vm._v("Chloe Black\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:blackc@hobartcity.com.au"}},[_vm._v("BLACKC@HOBARTCITY.COM.AU​")]),_vm._v(" "),_c('br'),_vm._v("City of Hobart - Public Art\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:publicart@hobartcity.com.au"}},[_vm._v("PUBLICART@HOBARTCITY.COM.AU​")]),_vm._v(" "),_c('br'),_vm._v("(03) 6238 2100\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"to":"/participate"}},[_vm._v("SUBMIT CONTENT")]),_vm._v(" "),_c('br'),_vm._v("To submit content you need to Sign In or Sign Up via our participate portal\n      ")],1),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v("A new film and video comedy program curated by local comedian, Chloe Black for The Loop: A Digital Art Platform for Hobart.\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Are you sketchy? Do you make YouTube clips in your spare time? Been making funny faces during Quarantine? Are you a fan of sketch comedy? Do you remember the D-Gen? Fast Forward? The Comedy Company? Even….. *quickly Googles* The Mavis Bramston Show? Then Hobart needs you! To get SKITfaced!\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('br'),_vm._v("That’s right. YOU. The person reading this! We’re looking for quick, fast, and bite- sized delights of comedy content to be screened at The Hobart Loop on Elizabeth Street. There’s even a $1000 cash prize for the best one submitted. Other prize categories include Best Ensemble, Best Solo, Best Youth, and People’s Choice!\n        "),_vm._m(5),_vm._v("\n        Send us your content!\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Yes please. What can I submit?")]),_vm._v("Videos can be any length up to a maximum of 5 minutes.\n        "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          Just remember; clips have to be suitable for public broadcast (no nudity, or swears\n          or hateful content) and suitably subtitled (it's a public space, there are neighbours\n          and we have to abide by public noise regulations). But apart from that, have at it!\n        ")]),_vm._v(" "),_c('h2',[_vm._v("Video Formats")]),_vm._v(" "),_c('p',[_vm._v("\n          Videos need to be uploaded via The Loop’s submission portal.\n          The platform accepts .mpeg4, H.264 and files no larger than 4Gb. You’ll also be\n          asked to submit a brief description of your content and a key image.\n          Videos need to be a maximum of 5 minutes long.\n          Output resolution for the Loop’s screen is 960 x 576.\n          For more information on formatting and the screen download The Loop’s Submission\n          Guidelines.\n          "),_c('v-btn',{attrs:{"href":'https://firebasestorage.googleapis.com/v0/b/the-loop-cb6ab.appspot.com/o/Submission%20Guidelines%20for%20The%20Loop_Jan2020.pdf?alt=media&token=81717957-cc63-496a-b69a-9fddda62e181'}},[_c('v-icon',[_vm._v("description")]),_vm._v(" Submission\n            Guidelines\n          ")],1)],1),_vm._v(" "),_c('h2',[_vm._v("How do I submit?")]),_vm._v(" "),_c('p',[_vm._v("\n          You can upload your final video for consideration through The Loop’s online\n          submission portal at The Loops\n          "),_c('v-btn',{attrs:{"to":"/participate"}},[_vm._v("participate")]),_vm._v("page. Once you submit, we’ll be in\n          touch with you! You can also send us a URL if you’re video is online (ie: Youtube,\n          TikTok or Vimeo).\n        ")],1),_vm._v(" "),_c('h2',[_vm._v("Help!")]),_vm._v(" "),_c('p',[_vm._v("\n          If you’re having trouble with formatting, captioning, uploading your content or if you\n          need to check if your content is suitable, please contact the City’s Public Art team by\n          emailing\n          "),_c('v-btn',{attrs:{"href":'mailto:publicart@hobartcity.com.au'}},[_vm._v("publicart@hobartcity.com.au​")]),_vm._v("or call (03) 6238 2565.\n          "),_c('br'),_vm._v("Alternatively, email\n          program curator, Chloe Black,\n          "),_c('v-btn',{attrs:{"href":'mailto:blackc@hobartcity.com.au'}},[_vm._v("blackc@hobartcity.com.au​")])],1),_vm._v(" "),_c('h2',[_vm._v("Notification")]),_vm._v(" "),_c('p',[_vm._v("\n          We’ll be in touch after you submit. Announcement of successful submissions will be\n          in early November 2020.\n        ")]),_vm._v(" "),_c('h2',[_vm._v("Competition and Prizes")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h2',[_vm._v("Screening Dates")]),_vm._v(" "),_c('p',[_vm._v("\n          Skitfaced 2020 will be launched with a public screening event in November 2020 and\n          will screen in November –December 2020 on The Loop.\n          Follow\n          "),_c('v-btn',{attrs:{"href":'https://www.instagram.com/skitfacedhobart/'}},[_vm._v(" @skitfacedhobart")]),_vm._v("on Instagram to view and vote for your favourite skits in\n          November!\n        ")],1),_vm._v(" "),(!_vm.userIsAuthenticated)?_c('div',[_c('b',[_vm._v("You need an account to sumbit your comedy.")]),_vm._v(" "),_c('v-btn',{attrs:{"to":"/signin"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock_open")]),_vm._v("Sign In\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"to":"/signup"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("face")]),_vm._v("Sign Up\n          ")],1)],1):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('div',{staticStyle:{"text-align":"center"}},[_c('v-btn',{attrs:{"to":"/content/new"}},[_c('v-icon',[_vm._v("movie")]),_vm._v(" Submit your comedy here.\n          ")],1)],1):_vm._e()])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_vm._v("\n          SKITfaced 2020\n          "),_c('br'),_vm._v("curated by Chloe Black\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Screening\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('br'),_vm._v("**DEADLINE EXTENDED**\n          "),_c('br'),_vm._v("Submissions are now due\n          "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('i',[_vm._v("CALL OUT FOR CONTENT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EventHeading"},[_c('b',[_vm._v("SKITfaced 2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("\n          WE NEED YOU!!\n          "),_c('br'),_vm._v("TO BE FUNNY!!.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Great! What do I do?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          It’s been a tough time for Hobart’s comedy scene during Covid-19, so we’re\n          rewarding your efforts and talent! There will be a competition element including a\n          $1000 price for Best Featured Skit. Other categories include: Best Youth Entry; Best\n          Solo; and Best Ensemble. Also The People’s Choice! All selected content will be\n          given the Official Laurel to be placed on their CV and future promotions.\n          The program of content will be curated by Chloe Black. Prizes will be awarded by a\n          judging panel, including notable comedians. Prizes will be announced at the launch\n          event in November 2020.\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Superstar judging panel to be announced shortly!\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3836ef12b25d0fe35b83.js